export const cl = {
  sodimac: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      BEIGE: '#cfb174',
      NEGRO: '#000000',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      COMBO_GTD_MANQUEHUE_LABEL: 'GTD Manquehue',
      HOME_DELI_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      ENVIO_GRATIS_LABEL_AMOUNT: '$59.990',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      SPONSORED_PRODUCT_SLOTS_APP: '[0, 14.28, 42.8, 71.2]',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL: 'https://fconnect.falabellatienda.com/web-bff/solicita/llamada',
      ADDING_TO_CART_1: 'Agregando',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      CURRENT_NUMBER_PLACEHOLDER: '9 8765 4321',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      VIEW_PLANES_LABEL_REBRANDING: 'Ver planes',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Juntos van mejor',
      CHIP: 'CHIP',
      COOKIES_PAIR_TO_REMOVE: 'bi_ab::oltr_enabled',
      REGIONS: 'Regiones',
      PDP_STARTS_FROM: 'A partir de: ',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo con plan desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '14:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      PDP_NO_THANKS: 'Sin garantía extendida',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Envío a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$, conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Tienes 30 días desde que lo recibes. ',
      SELLER_SKU_ID: 'Cód. tienda',
      NEW_BADGE: 'Nuevo',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      CONNECT_GO_BACK: 'Volver atrás',
      COMBO_WOM_LABEL: 'WOM',
      SEE_COMMENTS: 'Ver comentarios',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK_MKP: 'No Retiro en tienda',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE',
      MORE_PRODUCTS_FROM_COLLECTION: 'Juntos van mejor',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      SELECTION_TIENDA: 'Selecciona la talla para ver disponibillidad en tienda:',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona un punto de retiro',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Encuentra $xlp_name$$facet_value$ con descuentos increíbles en Sodimac $country$ - Homecenter. Conoce nuestras ofertas y elige la mejor opción para ti.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Adquiere $facet_value$ en $xlp_name$, conoce la variedad de modelos que tenemos para ti y aprovecha nuestras ofertas de Sodimac $country$ - Homecenter.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      ONLY_BUY_AT_STORE: 'Compra solo en tienda',
      MARKET_PLACE: 'Marketplace',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      COMBO_MOVIL_FALABELLA_LABEL: 'Movil Falabella',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      CONNECT_AGENT: 'EvalFalConnectj6S9B30n104f94g',
      PRODUCT_OUTOFSTOCK: '¡Qué mal! Justo se agotó',
      ERROR_SERVICE_TRY_AGAIN:
        '¡Intenta nuevamente! la conexión tardó más de lo esperado. Vuelve a intentar y revisa los planes que tenemos disponibles para ti.',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      CONNECT_ASSESSMENT_FORM_ERROR_CLIENT: 'ESTIMADO CLIENTE',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      OCULTAR_LABEL: 'Ocultar',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      CONNECT_CMR_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/cmr/consultaCmrInternet',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce los plazos y exclusiones',
      VENDOR_PRICE_LABEL: 'Precio',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      PDP_BI_AB_COOKIE: 'pdp_ab',
      CONNECT_OPERATOR_SERVICE_CALL:
        'https://fconnect.falabellatienda.com/api-txd/credito/consultaInformacionCreditoInternet',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      VOLVER_A_REVISAR: 'Volver a revisar',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Comuna',
      LOG_OUT_LABEL: 'Cerrar sesión',
      GOOGLE_ELEMENT_UNIQUE_ID: 'div-gpt-ad-3024305',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      HOW_WORKS_CONNECT: '¿Cómo funciona Falabella Connect?',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      NEED_RUT: 'Tenemos ofertas especiales. Solo necesitamos tu RUT para mostrártelas.',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      SLP_BI_AB_COOKIE: 'search_ab',
      READY: 'Aplicar',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos podrían agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Región',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      CONNECT_ERROR_MESSAGE_BUTTON: 'Aceptar',
      COMBO_OPERATOR_LABEL: 'Operador',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      CONNECT_IMPORTANT_THINGS:
        ' Esperamos ofrecerte los mejores planes y equipos, pero antes queremos recordarte dos cosas importantes:',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANES: 'PLANES',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      ERROR_COLOR_NOT_SELECTED: 'Seleccionar tu color para contratar el plan',
      sellerMuteValue: 'LINIO',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      COMBO_ENTEL_LABEL: 'Entel',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis app',
      FAILED_ADDING_TO_CART_LABEL: 'Este producto ya no está disponible.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      COMBO_VTR_LABEL: 'VTR',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      COMBO_PREPAGO_LABEL: 'Prepago',
      HOW_WORKS_CONNECT_TITLE: 'Términos y condiciones Falabella Connect',
      HOME_DELIVERY_SHIPPING: 'Despacho a domicilio.',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      SAME_DAY_FACET_MINUTES: 59,
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '19990',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      COMBO_MOVISTAR_LABEL: 'Movistar',
      ASSOCIATED_SELLER_INFO:
        'Este es un producto publicado directamente por un vendedor nacional o internacional y cuenta con el respaldo de Falabella. En algunos casos podría tener plazos de despacho diferentes a los habituales.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      CURRENT_NUMBER_PREFIX: '+56 ',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      REVIEW_CONTRACT: 'Revisa el mandato y contrato. Elige la modalidad de firma que más te acomode.',
      OUT_SERVICE:
        'En estos momentos no fue posible atender su solicitud. Por favor vuelve a intentar dentro de unos minutos.',
      CONNECT_IFRAME_WIDTH: 1080,
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      SELECT_PROMOTION_TEXT: 'Seleccionar Promoción',
      CONNECT_PLANS_CMR_ERROR_BLACK_LIST: 'No califica para comprar planes con falabella connect.',
      RETURN_POLICY_INFO_HARDLINE: 'Tienes 30 días desde que lo recibes. ',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      CONNECT_AUTENTIA_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/validaCliente/validaCi',
      isFastShippingTextEnabled: false,
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      CMR_MAPPING:
        'WwogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBDTVIiLAogICAgImRpdmlkZUZhY3RvciI6IDIwMCwKICAgICJsb2dvIjogImljb25zLmNtclRhcmpldGFJY29uIgogIH0sCiAgewogICAgInRpdGxlIjogIkNvbiBEw6liaXRvIEJhbmNvIEZhbGFiZWxsYSIsCiAgICAiZGl2aWRlRmFjdG9yIjogNTAwLAogICAgImxvZ28iOiAiY29ucy5iYW5jb0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIEN1ZW50YSBGcGF5IiwKICAgICJkaXZpZGVGYWN0b3IiOiA1MDAsCiAgICAibG9nbyI6ICJpY29ucy5mcGF5SWNvbiIKICB9LAogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBkZSBjcsOpZGl0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuY3JlZGl0b0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIHRhcmpldGEgZGUgZMOpYml0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuZGViaXRvSWNvbiIKICB9Cl0=',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      PICKUP_OR_DELIVERY:
        'Retira tu compra en cualquiera de nuestras tiendas. Si firmaste en línea, recibe tu Smartphone donde quieras y disfrútalo.',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      HIRE_YOUR_PLAN: 'Datos para contratar tu plan',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      CURRENT_NUMBER_LABEL: 'Número Actual',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$|^[0-9]{1,}[A-Z]?C$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción ',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      PICKUP_INSTORE_SO_TITLE: 'Retiro en tienda',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Puntos de retiro disponibles',
      CMSIZE: 'cm',
      BUY_CONNECT_ONLINE: '¡Ahorra tiempo! Compra un Smartphone y contrata un plan, todo en línea y de una sola vez.',
      OF: 'de',
      PICKUP_INSTORE_CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      CHECK_THE_OFFERS: '¡Revisa las ofertas!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Encuentra lo que buscas en $xlp_name$. Visita Sodimac $country$ - Homecenter y conoce nuestra gran variedad en productos con increíbles ofertas.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAN: 'Limpiar Filtro',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p> <p>Descubre un amplio catálogo de productos en Sodimac para %Category Name%. Encuentra todo lo que necesitas para renovar tu hogar. ¡Visítanos y encuentra inspiración para tus proyectos!</p> <p>Desde herramientas hasta accesorios, estamos aquí para ayudarte a hacer realidad tus ideas y renovar tus espacios, creando un ambiente único y personalizado. Explora nuestra selección de herramientas, materiales y accesorios de calidad que te ayudarán a crear un espacio más tú.</p> <p>Desde remodelaciones hasta proyectos de decoración, estamos aquí para hacer tus ideas realidad. ¡Visítanos y encuentra todo lo que tenemos para ofrecerte en %Category Name%!</p> <h2>Explora la variedad de productos de %Category Name% en Sodimac</h2> <p>Herramientas, materiales y accesorios de calidad para tus proyectos y renovación de espacios. ¡Visítanos y descubre todo lo que tenemos para ofrecerte!</p> <p>Encuentra una amplia variedad de productos de %Category Name% en Sodimac. Encuentra todo lo necesario para tus proyectos de renovación y decoración. ¡Visítanos y haz tus ideas realidad!</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Compra lo mejor de $xlp_name$ a un solo click. Encuentra esto y todo lo que necesitas en Falabella y Falabella.com!',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: ' Ábrela',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      CMR_DEFAULT_INSTALLMENTS: '10',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      SUMMARY_MODAL_NOTICE:
        'El valor del plan lo podrás pagar en el sitio web del operador o directamente en la tienda.',
      CONNECT_ERROR_MESSAGE:
        'Lo sentimos, se ha producido un error confirmando tu compra. Por favor, comunícate con nuestro Servicio al Cliente al 223907910 o escríbenos a contacto@falabella.cl',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $10.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $10.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      MORE_OPTIONS: 'Ver opciones',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      toggleViewButtonText: 'Visualizar por:',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      SKU_EQUIPMENT: 'SKU Equipo',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      BACK_ROOM: 'trastienda',
      EVALUATE_PLANS_BUTTON: 'REVISAR PLANES',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RECEIVE_AND_ENJOY: '¡Recibe y disfruta!',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devuelve gratis por Derecho a retracto o Satisfacción garantizada.',
      CONNECT_IFRAME_URL: 'https://txd-fconnect-prd.appspot.com/#/?data=',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      VIEW_PLAN_REBRANDING: 'Ver plan',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      NEXT_DAY_SHIPPING_MIN_MAX_HOURS: '19.5,4',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      ATC_ONLY_BUY_AT_STORE: 'Ver Producto',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      ERROR_SERVICE_NO_PLANS: 'Lo sentimos, no se han encontrado planes disponibles en esta evaluación',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      CONNECT_PLANS_CMR_INVALID: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      LOGIN_SIGN_UP: 'Regístrate',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_IMPORTANT_THING_3: 'Si quieres portar tú número a otra compañía tienes que ser el titular de la línea.',
      CONNECT_AUTENTIA_ERROR_MESSAGE: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'REVISAR PLANES',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CONNECT_IMPORTANT_THING_2:
        'Para contratar un plan necesitamos hacer una previa evaluación financiera. Por esto Promotora CMR Falabella S.A nos proporciona información necesaria para que podamos ofrecerte un plan adecuado y especial para ti. Si todavía no tienes tu CMR no dudes en sacarla.',
      CONNECT_IMPORTANT_THING_1: 'Para contratar tu plan tienes que tener tarjeta',
      CONNECT_ERROR_MESSAGE_BASKET:
        'Lo sentimos, no es posible añadir más productos a la Bolsa. Ya tienes agregado un producto de Falabella Connect. Este tipo de producto debe ser comprado de manera independiente, ya que tiene un despacho preferente.',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      CONTRACT_PLAN: 'CONTRATAR PLAN',
      UKSIZE: 'UK',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      SKU_PLAN: 'SKU Plan',
      PLANS_DETAILS_FREE_LABEL: 'LIBRES',
      PRODUCT_ORCHESTRATOR_FLOW: 'false',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      HIRE: 'CONTRATA TU',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores que tenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CONNECT_LEGAL_TEXT:
        'Los términos y condiciones regulan la evaluación comercial de los planes de telefonía móvil ofrecidos por los operadores de telefonía móvil en nuestro sitio web www.falabella.com, que puedes contratar en conjunto con los teléfonos celulares comercializados por Falabella Retail S.A. Puedes revisar el contenido de los términos y condiciones de la evaluación comercial aqui.\n\nPara realizar la evaluación comercial, es necesario que seas titular de una tarjeta CMR, y que ésta haya sido emitida, con al menos, 90 días de antigüedad a la fecha de solicitud de evaluación o contratación del plan de telefonía móvil. Adicionalmente, validaremos la vigencia y la exactitud de los datos de tu cédula de identidad que nos proporciones.\n\nLos productos deben ser comprados de manera independiente y separada de otros productos que puedas tener en tu carro de compras. Si tienes productos adicionales en tu carro de compra, no te preocupes, éstos quedarán guardados para una compra futura.\n\nEl plan de telefonía y el precio del equipo pueden ser pagados con cualquier medio de pago disponible en falabella.com. El descuento en el precio del equipo está sujeto a la contratación del plan de telefonía respectivo y a la firma de un mandato para el cobro en tu tarjeta de crédito CMR, de la diferencia entre el precio del equipo y el precio prepago de este, según corresponda, el cual aplicará si das de baja el plan suscrito o contratas uno más económico dentro de un periodo de 18 meses para cada operador.\n\nDebido a los requerimientos y procesos del operador telefónico, existe un plazo máximo de 15 días para que recibas tu producto.',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      TRACK_ORDER: 'Seguimiento de mi orden',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      BOOM_SHIPPING: 'Boom',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      PLAN: 'PLAN',
      HOME_DELI_SO_TITLE: 'Despacho a domicilio',
      PRODUCT_CODE: 'Código del producto',
      SAME_DAY_FACET_HOURS: '15',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 600 390 4100',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN: 'https://fconnect.falabellatienda.com/api-txd/getTokenEncrypt',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'Agregar los {count} al Carro',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      TYPE_C_HOME_DELI_OUTOFSTOCK_MKP: 'No disponible para envío a domicilio',
      PICKUP_INSTORE_TITLE: 'Retiro en un punto',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '15:30 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      FILL_YOUR_DETAILS: 'Completa tus datos y firma',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      WARNING_A11Y_LABEL: 'Warning',
      ERROR_SERVICE_SAME_OPERATOR:
        'No puedes realizar compra de un plan de tu misma compañía. ¡Revisa la oferta con otros operadores!',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      COMBO_PLAN_PREPAGO_LABEL: 'Plan / Prepago',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'REVISA TUS PLANES',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      COMBO_CLARO_LABEL: 'Claro',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON: 'PROBAR CON OTRO RUT',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      GO_BACK_TO_PLANS: 'Volver a planes',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      COMBO_NETLINE_LABEL: 'Netline',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en Sodimac $country$. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G200401,G200402,G200403,G200405,G200406,G200407,G20040804,G20040809,G20040813,G20040901,G20040906,G20040908,G20040914,G200410,G200411,G200412,G20041303,G20041213,G20041405,G20041406,G20041407,G20041410,G200415,G200416,G200417,G200418,G200419,G20042002,G20042006,G200421,G200422,G200423,G200424',
      CIUDAD_TEXT: 'Partido',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      CMR_POINTS: 'CMR Puntos',
      CMRAPERTURATEXT_REQUEST: '¿Aún no tienes tu CMR Banco Falabella?',
      HOME_SHIPPING: 'Envío a domicilio',
      COMBO_SIMPLE_LABEL: 'Simple',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      COLLECTIONS_TO_SHOW_PLANS: 'connect-products,prueba-connect,falabella-connect',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      CONNECT_IFRAME_HEIGHT: 713,
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      CMR_Falabella: 'CMR Falabella.',
      WHY: '¿Porqué?',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PUM_AFFIX: ' a ',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      ACCEPT: 'ACEPTAR',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      COMBO_PLAN_LABEL: 'Plan',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 600 3904100',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      CHOOSE_YOUR_PLAN: 'Elige tu equipo y plan',
      COLORS_AVAILABLE_SMALL: 'Colores Disponibles',
      PICKUP_INSTORE_NOT_AVAILABLE_IN: 'No disponible en ',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      COMBO_VIRGIN_LABEL: 'Virgin',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_INFO_SHOES: 'Tienes 30 días desde que lo recibes. ',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      FREE_SHIPPING_PRICE: '59990',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      NEED_HELP_CALL_US_AT_PLAN: '¿Necesitas ayuda para contratar un plan? Llámanos al',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      ERROR_SERVICE_NO_CREDIT:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      OFFER_PRICE_WARRANTY_LABEL: '(Oferta)',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retiro desde 90 min',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SEARCH_TITLE: '$xlp_name$',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b> app,Llega <b>gratis</b> mañana,Retira hoy,Retira mañana',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      darSectionLabel: 'Producto sin derecho a retracto',
      WARRANTY_LABEL_PREFIX: '',
      OVERRIDE_FACETS_COUNT: 'f.derived.variant.sellerId',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio mayorista',
      WHOLESALE_BANNER_BADGE_TEXT_2: '',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      FALLBACK_SEO_TITLE_TYPE: '$type_facet$ en $category_name$ | Sodimac $country$',
      FALLBACK_SEO_DESCRIPTION_BRAND:
        'Encuentra $category_name$ $brand_name$ con descuentos increíbles en Sodimac $country$ - Homecenter. Conoce nuestras ofertas y elige la mejor opción para ti.',
      FALLBACK_SEO_TITLE: '$category_name$ | Sodimac $country$',
      FALLBACK_SEO_DESCRIPTION_TYPE:
        'Adquiere $type_facet$ en $category_name$, conoce la variedad de modelos que tenemos para ti y aprovecha nuestras ofertas de Sodimac $country$ - Homecenter.',
      FALLBACK_SEO_TITLE_BRAND: '$category_name$ $brand_name$ | Sodimac $country$',
      FALLBACK_SEO_DESCRIPTION:
        'Encuentra lo que buscas en $category_name$. Visita Sodimac Chile - Homecenter y conoce nuestra gran variedad en productos con increíbles ofertas.',
    },
    toggles: {
      isSearchWithSoCom: false,
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPositionPerCategoryEnabled: true,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isNewSearchVisible: true,
      isGenericCalculatorEnabled: true,
      IsSearchExperienceCheckbox: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isOneClickCheckoutEnabled: false,
      isEventFilterEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      isInhouseBundleWidgetActive: false,
      PDP_AB_TEST_OVERRIDE_VALUE: '',
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isAbCookieEnabled: false,
      isRelatedKeywordEnabled: false,
      showRatingDescription: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: false,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: false,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      showListToggleButtons: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isShippingAttributesEnabled: false,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isSurveyBarShowninPDP: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      showPricesForSodimacProducts: true,
      isActiveTabAssistentePersonal: false,
      isBestSellerEnabled: true,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      isSizeEquivalencyTableVisible: false,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isCMRAperturaUrlAddonsEnabled: true,
      isSisSodimacPdpEnabled: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: false,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      isComparativeTableSameSellerEnabled: false,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: false,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isRootCategoryGForFacetCategoriaDisabled: false,
      isSellerBusinessNameEnabled: true,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":false,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: false,
      isPhotoSlurpEnabled: false,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: false,
      isInternationalBuyVisiblePDP: true,
      isGoogleAdsBannerEnabled: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      identifyBuyAtStore: false,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: false,
      isOneClickButtonVisible: false,
      isPidAndPgidValidationDisabled: false,
      isShippingLabelsEnabledInPdp: false,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isNewSizeGroupService: false,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: false,
      isAddtionalSellerTextEnabled: true,
      isProductOrchestratorRecoEnabled: false,
      isCartQuantityLimitsEnabled: false,
      freeShippingOnZonesEnabled: true,
      isEventToggleVisible_SO_COM: false,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isSodimacFaviconTestActivated: false,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isEnabledSposoredVisitInPLP: true,
      isAIExperimentEnabled: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: false,
      isNormalPriceCrossedOut: true,
      isCustomPDPABTestFlagEnabled: false,
      isNewWarrantyOptionsEnabled: true,
      hasFreeShippingForInternationalProducts: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: true,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isReviewValidationWithOrder: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: true,
      isSizeChartDataVisible: true,
      is3PSellerSizeChartEnabled: false,
      isDemoUpVideoEnabled: false,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isEnabledSponsoredClickInPDP: true,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDebugAdsEnabled: false,
      showFacetsForCollectionRule: true,
      isDynamicFacetsEnabled: true,
      SHOW_SPONSORED_STRIP: false,
      addFeatureScriptsToLongDesc: true,
      allowLongDescScriptInjection: true,
      enableSponsoredInRecommendation: true,
      isEventToggleVisible_TO_COM: false,
      isKioskControlledSearchEnabled: false,
      popularBrandsStaticFacetsEnabled: false,
      IS_PROVIDER_EXPERIMENT_TURNED_ON: false,
      isSearchSpecialCharactersEnabled: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      isNewSearchOrchestratorEnabled: false,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isCustomBannerEnabled: true,
      isExpSellerFilterEnabled: true,
      isInstallmentWithoutInterestEnabled: true,
      popularBrandFacetsEnabled: true,
      SHOW_SKELETON: true,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpconOU',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com/falabella-cl/myaccount/myLists',
      BASKET_PAGE_URI: 'https://www.falabella.com/falabella-cl/basket',
      WORKING_HOURS_SODIMAC: 'https://sodimac.falabella.com/sodimac-cl/page/tiendas-y-horarios-sodimac',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      WORKING_HOURS_TIENDA: 'https://tienda.falabella.com/falabella-cl/page/horarios-tienda-Falabella',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.cl/sodimac-cl/basket',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpsinOU',
      EXT_WARRANTY_LIGHTBOX_LINK: '/falabella-cl/page/garantia?staticPageId=11300003',
      SERVICES_CL_FALABELLA: 'https://www.falabella.com/falabella-cl/page/servicios-falabella',
      WORKING_HOURS_TOTTUS: 'https://tottus.falabella.com/tottus-cl/page/horario_tiendas',
      moreWarrantyBenefitsLink: 'https://www.falabella.com/falabella-cl/page/postventa-garantia-extendida',
    },
    facetLabels: {
      'f.shipping.hd_same_day_zones': '<p>Si compras hasta las&nbsp;<strong>16:00 horas</strong></p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>Hasta 04/05/2025</p>',
      'f.derived.variant.freeShipping': '',
      'f.derived.variant.activeEvent': '<p>Hasta el 04/05/2025</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>SOLO POR 72 HRS</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: false,
        labels: false,
        novios: {
          facets: false,
          labels: false,
        },
        default: {
          facets: false,
          labels: false,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1655991838659-03',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-03',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-16553991838659-0',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-16553991534231-0',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com/falabella-cl',
        sodimac: 'https://sodimac.falabella.com/sodimac-cl',
        tottus: 'https://tottus.falabella.com/tottus-cl',
        linio: 'https://linio.falabella.com/linio-cl',
        homecenter: 'https://homecenter.falabella.com/homecenter-cl',
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusion: 'dior',
      productTitleBrandRemovalExclusions: ['dior'],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      skipPositionCategories: [
        'cat20002',
        'cat850030',
        'cat14330023',
        'cat850036',
        'cat7330051',
        'cat1320008',
        'CATG34996',
        'cat850040',
        'cat1320010',
        'cat16580002',
        'cat13140017',
        'cat850034',
        'cat850042',
        'cat7350055',
        'cat850044',
        'cat11610008',
        'cat7350018',
        'cat7350012',
        'cat7350013',
        'cat7350017',
        'cat7350019',
        'cat18380042',
        'cat1320012',
        'cat7450073',
        'cat17980009',
        'cat7500027',
        'cat13620025',
        'cat7450062',
        'cat1640033',
        'cat5260002',
        'cat7450083',
        'cat7450088',
        'cat7450086',
        'cat7450065',
        'cat660024',
        'cat2083',
        'cat850068',
        'cat850064',
        'cat12440001',
        'cat690245',
        'cat13680004',
        'cat14730004',
        'cat6930168',
        'cat6930003',
        'CATG35031',
        'CATG12010',
        'cat7280122',
        'cat5620004',
        'cat12850003',
        'cat12850002',
        'cat12270016',
        'CATG34995',
        'cat7480104',
        'cat2017',
        'cat3207',
        'cat690235',
        'cat5880085',
        'cat3208',
        'cat6050003',
        'cat3143',
        'cat6050008',
        'cat590028',
        'cat570195',
        'cat6050011',
        'cat13990004',
        'CATG34994',
        'cat6930019',
        'cat12650001',
        'cat6930011',
        'cat6930180',
        'cat6930190',
        'cat6930014',
        'cat6930181',
        'cat6930018',
        'CATG19087',
        'cat6930191',
        'cat12650004',
        'cat12650002',
        'CATG33917',
        'cat190004',
        'cat7660148',
        'cat16400020',
        'cat16400012',
        'cat16400016',
        'cat16400014',
        'cat16400019',
        'cat16400015',
        'cat19280010',
        'cat16400013',
        'cat16400018',
        'cat17010032',
        'cat17010033',
        'cat19280007',
        'cat14370004',
        'cat17180020',
        'cat17180021',
        'cat7530038',
        'cat7530010',
        'cat15330001',
        'cat15330018',
        'cat15330005',
        'cat15330021',
        'cat15330022',
        'cat15330003',
        'cat15330006',
        'cat15330023',
        'cat15330011',
        'cat15330027',
        'cat15330009',
        'cat15330025',
        'cat15330030',
        'cat15330017',
        'cat15330019',
        'cat15330010',
        'cat15330026',
        'cat15330012',
        'cat15330029',
        'cat15330004',
        'cat15330020',
      ],
      SponsoredDisplayPosition: {
        positions: {},
      },
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b> app',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira desde 90 min',
          cc_next_day: 'Retira mañana',
          hd_express: 'Retira en 2 horas',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver este producto es gratis',
            intl: 'Devolver este producto es gratis',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Producto sin derecho a retracto',
            intl: 'Producto sin derecho a retracto',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      topSortExperimentConfig: {
        categories: [],
        searchTerms: [],
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      tipoFacetAttributeBannerConfig: {
        visible: true,
        androidVersion: '2.6.39',
        iosVersion: '2.6.38',
      },
      sellerExpCookies: {
        seller_exp_1: 'exp_1',
        seller_exp_2: 'exp_2',
        seller_exp_3: 'exp_3',
        seller_exp_4: 'exp_4',
      },
      whiteLabelSitesEnabled: ['fa_america', 'fa_aldo'],
      CES_SEGMENT: {
        so_socl_plata: 'CES_PLATA',
        so_socl_oro: 'CES_ORO',
        so_socl_black: 'CES_BLACK',
      },
      TIME_OUT_SKELETON: 1000,
    },
  },
  tottus: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      BEIGE: '#cfb174',
      NEGRO: '#000000',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      COMBO_GTD_MANQUEHUE_LABEL: 'GTD Manquehue',
      HOME_DELI_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      ENVIO_GRATIS_LABEL_AMOUNT: '$59.990',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      SPONSORED_PRODUCT_SLOTS_APP: '[0, 14.28, 42.8, 71.2]',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL: 'https://fconnect.falabellatienda.com/web-bff/solicita/llamada',
      ADDING_TO_CART_1: 'Agregando',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      CURRENT_NUMBER_PLACEHOLDER: '9 8765 4321',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      VIEW_PLANES_LABEL_REBRANDING: 'Ver planes',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Juntos van mejor',
      CHIP: 'CHIP',
      COOKIES_PAIR_TO_REMOVE: 'bi_ab::oltr_enabled',
      REGIONS: 'Regiones',
      PDP_STARTS_FROM: 'A partir de: ',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo con plan desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '14:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      PDP_NO_THANKS: 'Sin garantía extendida',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ marca $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Envío a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$, conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Tienes 30 días desde que lo recibes. ',
      SELLER_SKU_ID: 'Cód. tienda',
      NEW_BADGE: 'Nuevo',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      CONNECT_GO_BACK: 'Volver atrás',
      COMBO_WOM_LABEL: 'WOM',
      SEE_COMMENTS: 'Ver comentarios',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK_MKP: 'No Retiro en tienda',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE',
      MORE_PRODUCTS_FROM_COLLECTION: 'Juntos van mejor',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      SELECTION_TIENDA: 'Selecciona la talla para ver disponibillidad en tienda:',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona un punto de retiro',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Encuentra $xlp_name$ de $facet_value$. Conoce nuestro catálogo de productos. Descubre buenas ofertas y promociones en Tottus $country$.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Adquiere $facet_value$ en $xlp_name$. Revisa la variedad de productos que tenemos para ti y aprovecha nuestras ofertas en Tottus $country$.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      ONLY_BUY_AT_STORE: 'Compra solo en tienda',
      MARKET_PLACE: 'Marketplace',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      COMBO_MOVIL_FALABELLA_LABEL: 'Movil Falabella',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      CONNECT_AGENT: 'EvalFalConnectj6S9B30n104f94g',
      PRODUCT_OUTOFSTOCK: '¡Qué mal! Justo se agotó',
      ERROR_SERVICE_TRY_AGAIN:
        '¡Intenta nuevamente! la conexión tardó más de lo esperado. Vuelve a intentar y revisa los planes que tenemos disponibles para ti.',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      CONNECT_ASSESSMENT_FORM_ERROR_CLIENT: 'ESTIMADO CLIENTE',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      OCULTAR_LABEL: 'Ocultar',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      CONNECT_CMR_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/cmr/consultaCmrInternet',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce los plazos y exclusiones',
      VENDOR_PRICE_LABEL: 'Precio',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      PDP_BI_AB_COOKIE: 'pdp_ab',
      CONNECT_OPERATOR_SERVICE_CALL:
        'https://fconnect.falabellatienda.com/api-txd/credito/consultaInformacionCreditoInternet',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      VOLVER_A_REVISAR: 'Volver a revisar',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Comuna',
      LOG_OUT_LABEL: 'Cerrar sesión',
      GOOGLE_ELEMENT_UNIQUE_ID: 'div-gpt-ad-3024305',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      HOW_WORKS_CONNECT: '¿Cómo funciona Falabella Connect?',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      NEED_RUT: 'Tenemos ofertas especiales. Solo necesitamos tu RUT para mostrártelas.',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      SLP_BI_AB_COOKIE: 'search_ab',
      READY: 'Aplicar',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos podrían agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Región',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      CONNECT_ERROR_MESSAGE_BUTTON: 'Aceptar',
      COMBO_OPERATOR_LABEL: 'Operador',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      CONNECT_IMPORTANT_THINGS:
        ' Esperamos ofrecerte los mejores planes y equipos, pero antes queremos recordarte dos cosas importantes:',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANES: 'PLANES',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      ERROR_COLOR_NOT_SELECTED: 'Seleccionar tu color para contratar el plan',
      sellerMuteValue: 'LINIO',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      COMBO_ENTEL_LABEL: 'Entel',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis app',
      FAILED_ADDING_TO_CART_LABEL: 'Este producto ya no está disponible.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      COMBO_VTR_LABEL: 'VTR',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      COMBO_PREPAGO_LABEL: 'Prepago',
      HOW_WORKS_CONNECT_TITLE: 'Términos y condiciones Falabella Connect',
      HOME_DELIVERY_SHIPPING: 'Despacho a domicilio.',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      SAME_DAY_FACET_MINUTES: 59,
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '19990',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      COMBO_MOVISTAR_LABEL: 'Movistar',
      ASSOCIATED_SELLER_INFO:
        'Este es un producto publicado directamente por un vendedor nacional o internacional y cuenta con el respaldo de Falabella. En algunos casos podría tener plazos de despacho diferentes a los habituales.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      CURRENT_NUMBER_PREFIX: '+56 ',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      REVIEW_CONTRACT: 'Revisa el mandato y contrato. Elige la modalidad de firma que más te acomode.',
      OUT_SERVICE:
        'En estos momentos no fue posible atender su solicitud. Por favor vuelve a intentar dentro de unos minutos.',
      CONNECT_IFRAME_WIDTH: 1080,
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      SELECT_PROMOTION_TEXT: 'Seleccionar Promoción',
      CONNECT_PLANS_CMR_ERROR_BLACK_LIST: 'No califica para comprar planes con falabella connect.',
      RETURN_POLICY_INFO_HARDLINE: 'Tienes 30 días desde que lo recibes. ',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      CONNECT_AUTENTIA_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/validaCliente/validaCi',
      isFastShippingTextEnabled: false,
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      CMR_MAPPING:
        'WwogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBDTVIiLAogICAgImRpdmlkZUZhY3RvciI6IDIwMCwKICAgICJsb2dvIjogImljb25zLmNtclRhcmpldGFJY29uIgogIH0sCiAgewogICAgInRpdGxlIjogIkNvbiBEw6liaXRvIEJhbmNvIEZhbGFiZWxsYSIsCiAgICAiZGl2aWRlRmFjdG9yIjogNTAwLAogICAgImxvZ28iOiAiY29ucy5iYW5jb0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIEN1ZW50YSBGcGF5IiwKICAgICJkaXZpZGVGYWN0b3IiOiA1MDAsCiAgICAibG9nbyI6ICJpY29ucy5mcGF5SWNvbiIKICB9LAogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBkZSBjcsOpZGl0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuY3JlZGl0b0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIHRhcmpldGEgZGUgZMOpYml0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuZGViaXRvSWNvbiIKICB9Cl0=',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      PICKUP_OR_DELIVERY:
        'Retira tu compra en cualquiera de nuestras tiendas. Si firmaste en línea, recibe tu Smartphone donde quieras y disfrútalo.',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      HIRE_YOUR_PLAN: 'Datos para contratar tu plan',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      CURRENT_NUMBER_LABEL: 'Número Actual',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$|^[0-9]{1,}[A-Z]?C$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción ',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      PICKUP_INSTORE_SO_TITLE: 'Retiro en tienda',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Puntos de retiro disponibles',
      CMSIZE: 'cm',
      BUY_CONNECT_ONLINE: '¡Ahorra tiempo! Compra un Smartphone y contrata un plan, todo en línea y de una sola vez.',
      OF: 'de',
      PICKUP_INSTORE_CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      CHECK_THE_OFFERS: '¡Revisa las ofertas!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Encuentra las más variadas alternativas en $xlp_name$con grandes ofertas online, entra a Tottus $country$ elige lo que más te guste a los mejores precios.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAN: 'Limpiar Filtro',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p> <p>Descubre un amplio catálogo de productos en Sodimac para %Category Name%. Encuentra todo lo que necesitas para renovar tu hogar. ¡Visítanos y encuentra inspiración para tus proyectos!</p> <p>Desde herramientas hasta accesorios, estamos aquí para ayudarte a hacer realidad tus ideas y renovar tus espacios, creando un ambiente único y personalizado. Explora nuestra selección de herramientas, materiales y accesorios de calidad que te ayudarán a crear un espacio más tú.</p> <p>Desde remodelaciones hasta proyectos de decoración, estamos aquí para hacer tus ideas realidad. ¡Visítanos y encuentra todo lo que tenemos para ofrecerte en %Category Name%!</p> <h2>Explora la variedad de productos de %Category Name% en Sodimac</h2> <p>Herramientas, materiales y accesorios de calidad para tus proyectos y renovación de espacios. ¡Visítanos y descubre todo lo que tenemos para ofrecerte!</p> <p>Encuentra una amplia variedad de productos de %Category Name% en Sodimac. Encuentra todo lo necesario para tus proyectos de renovación y decoración. ¡Visítanos y haz tus ideas realidad!</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Compra lo mejor de $xlp_name$ a un solo click. Encuentra esto y todo lo que necesitas en Falabella y Falabella.com!',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: ' Ábrela',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      CMR_DEFAULT_INSTALLMENTS: '10',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      SUMMARY_MODAL_NOTICE:
        'El valor del plan lo podrás pagar en el sitio web del operador o directamente en la tienda.',
      CONNECT_ERROR_MESSAGE:
        'Lo sentimos, se ha producido un error confirmando tu compra. Por favor, comunícate con nuestro Servicio al Cliente al 223907910 o escríbenos a contacto@falabella.cl',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $10.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $10.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      MORE_OPTIONS: 'Ver opciones',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      toggleViewButtonText: 'Visualizar por:',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      SKU_EQUIPMENT: 'SKU Equipo',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      BACK_ROOM: 'trastienda',
      EVALUATE_PLANS_BUTTON: 'REVISAR PLANES',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RECEIVE_AND_ENJOY: '¡Recibe y disfruta!',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devuelve gratis por Derecho a retracto o Satisfacción garantizada.',
      CONNECT_IFRAME_URL: 'https://txd-fconnect-prd.appspot.com/#/?data=',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      VIEW_PLAN_REBRANDING: 'Ver plan',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      NEXT_DAY_SHIPPING_MIN_MAX_HOURS: '19.5,4',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      ATC_ONLY_BUY_AT_STORE: 'Ver Producto',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      ERROR_SERVICE_NO_PLANS: 'Lo sentimos, no se han encontrado planes disponibles en esta evaluación',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      CONNECT_PLANS_CMR_INVALID: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      LOGIN_SIGN_UP: 'Regístrate',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_IMPORTANT_THING_3: 'Si quieres portar tú número a otra compañía tienes que ser el titular de la línea.',
      CONNECT_AUTENTIA_ERROR_MESSAGE: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$ compra online',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'REVISAR PLANES',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CONNECT_IMPORTANT_THING_2:
        'Para contratar un plan necesitamos hacer una previa evaluación financiera. Por esto Promotora CMR Falabella S.A nos proporciona información necesaria para que podamos ofrecerte un plan adecuado y especial para ti. Si todavía no tienes tu CMR no dudes en sacarla.',
      CONNECT_IMPORTANT_THING_1: 'Para contratar tu plan tienes que tener tarjeta',
      CONNECT_ERROR_MESSAGE_BASKET:
        'Lo sentimos, no es posible añadir más productos a la Bolsa. Ya tienes agregado un producto de Falabella Connect. Este tipo de producto debe ser comprado de manera independiente, ya que tiene un despacho preferente.',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      CONTRACT_PLAN: 'CONTRATAR PLAN',
      UKSIZE: 'UK',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      SKU_PLAN: 'SKU Plan',
      PLANS_DETAILS_FREE_LABEL: 'LIBRES',
      PRODUCT_ORCHESTRATOR_FLOW: 'false',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      HIRE: 'CONTRATA TU',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores que tenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CONNECT_LEGAL_TEXT:
        'Los términos y condiciones regulan la evaluación comercial de los planes de telefonía móvil ofrecidos por los operadores de telefonía móvil en nuestro sitio web www.falabella.com, que puedes contratar en conjunto con los teléfonos celulares comercializados por Falabella Retail S.A. Puedes revisar el contenido de los términos y condiciones de la evaluación comercial aqui.\n\nPara realizar la evaluación comercial, es necesario que seas titular de una tarjeta CMR, y que ésta haya sido emitida, con al menos, 90 días de antigüedad a la fecha de solicitud de evaluación o contratación del plan de telefonía móvil. Adicionalmente, validaremos la vigencia y la exactitud de los datos de tu cédula de identidad que nos proporciones.\n\nLos productos deben ser comprados de manera independiente y separada de otros productos que puedas tener en tu carro de compras. Si tienes productos adicionales en tu carro de compra, no te preocupes, éstos quedarán guardados para una compra futura.\n\nEl plan de telefonía y el precio del equipo pueden ser pagados con cualquier medio de pago disponible en falabella.com. El descuento en el precio del equipo está sujeto a la contratación del plan de telefonía respectivo y a la firma de un mandato para el cobro en tu tarjeta de crédito CMR, de la diferencia entre el precio del equipo y el precio prepago de este, según corresponda, el cual aplicará si das de baja el plan suscrito o contratas uno más económico dentro de un periodo de 18 meses para cada operador.\n\nDebido a los requerimientos y procesos del operador telefónico, existe un plazo máximo de 15 días para que recibas tu producto.',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      TRACK_ORDER: 'Seguimiento de mi orden',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      BOOM_SHIPPING: 'Boom',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      PLAN: 'PLAN',
      HOME_DELI_SO_TITLE: 'Despacho a domicilio',
      PRODUCT_CODE: 'Código del producto',
      SAME_DAY_FACET_HOURS: '15',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 600 390 4100',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN: 'https://fconnect.falabellatienda.com/api-txd/getTokenEncrypt',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'Agregar los {count} al Carro',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      TYPE_C_HOME_DELI_OUTOFSTOCK_MKP: 'No disponible para envío a domicilio',
      PICKUP_INSTORE_TITLE: 'Retiro en un punto',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '15:30 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ dentro de $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      FILL_YOUR_DETAILS: 'Completa tus datos y firma',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      WARNING_A11Y_LABEL: 'Warning',
      ERROR_SERVICE_SAME_OPERATOR:
        'No puedes realizar compra de un plan de tu misma compañía. ¡Revisa la oferta con otros operadores!',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      COMBO_PLAN_PREPAGO_LABEL: 'Plan / Prepago',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'REVISA TUS PLANES',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      COMBO_CLARO_LABEL: 'Claro',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON: 'PROBAR CON OTRO RUT',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      GO_BACK_TO_PLANS: 'Volver a planes',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      COMBO_NETLINE_LABEL: 'Netline',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en Tottus $country$. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G200401,G200402,G200403,G200405,G200406,G200407,G20040804,G20040809,G20040813,G20040901,G20040906,G20040908,G20040914,G200410,G200411,G200412,G20041303,G20041213,G20041405,G20041406,G20041407,G20041410,G200415,G200416,G200417,G200418,G200419,G20042002,G20042006,G200421,G200422,G200423,G200424',
      CIUDAD_TEXT: 'Partido',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      CMR_POINTS: 'CMR Puntos',
      CMRAPERTURATEXT_REQUEST: '¿Aún no tienes tu CMR Banco Falabella?',
      HOME_SHIPPING: 'Envío a domicilio',
      COMBO_SIMPLE_LABEL: 'Simple',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      COLLECTIONS_TO_SHOW_PLANS: 'connect-products,prueba-connect,falabella-connect',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      CONNECT_IFRAME_HEIGHT: 713,
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      CMR_Falabella: 'CMR Falabella.',
      WHY: '¿Porqué?',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PUM_AFFIX: ' a ',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      ACCEPT: 'ACEPTAR',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      COMBO_PLAN_LABEL: 'Plan',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 600 3904100',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      CHOOSE_YOUR_PLAN: 'Elige tu equipo y plan',
      COLORS_AVAILABLE_SMALL: 'Colores Disponibles',
      PICKUP_INSTORE_NOT_AVAILABLE_IN: 'No disponible en ',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      COMBO_VIRGIN_LABEL: 'Virgin',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_INFO_SHOES: 'Tienes 30 días desde que lo recibes. ',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      FREE_SHIPPING_PRICE: '59990',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      NEED_HELP_CALL_US_AT_PLAN: '¿Necesitas ayuda para contratar un plan? Llámanos al',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      ERROR_SERVICE_NO_CREDIT:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      OFFER_PRICE_WARRANTY_LABEL: '(Oferta)',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retiro desde 90 min',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SEARCH_TITLE: '$xlp_name$',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b> app,Llega <b>gratis</b> mañana,Retira desde 90 min,Retira mañana',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      darSectionLabel: 'Producto sin derecho a retracto',
      WARRANTY_LABEL_PREFIX: '',
      OVERRIDE_FACETS_COUNT: 'f.derived.variant.sellerId',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio mayorista',
      WHOLESALE_BANNER_BADGE_TEXT_2: '',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      FALLBACK_SEO_TITLE_TYPE: '$type_facet$ dentro de $category_name$ | Tottus $country$',
      FALLBACK_SEO_DESCRIPTION_BRAND:
        'Encuentra $category_name$ de $brand_name$. Conoce nuestro catálogo de productos. Descubre buenas ofertas y promociones en Tottus $country$.',
      FALLBACK_SEO_TITLE: '$category_name$ compra online | Tottus $country$',
      FALLBACK_SEO_DESCRIPTION_TYPE:
        'Adquiere $type_facet$ en $category_name$. Revisa la variedad de productos que tenemos para ti y aprovecha nuestras ofertas en Tottus $country$.',
      FALLBACK_SEO_TITLE_BRAND: '$category_name$ marca $brand_name$ | Tottus $country$',
      FALLBACK_SEO_DESCRIPTION:
        'Encuentra las más variadas alternativas en $category_name$ con grandes ofertas online, entra a Tottus $country$ elige lo que más te guste a los mejores precios.',
    },
    toggles: {
      isSearchWithSoCom: false,
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPositionPerCategoryEnabled: true,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isNewSearchVisible: true,
      isGenericCalculatorEnabled: true,
      IsSearchExperienceCheckbox: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isOneClickCheckoutEnabled: false,
      isEventFilterEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      isInhouseBundleWidgetActive: false,
      PDP_AB_TEST_OVERRIDE_VALUE: '',
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isAbCookieEnabled: false,
      isRelatedKeywordEnabled: false,
      showRatingDescription: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: false,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: false,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      showListToggleButtons: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isShippingAttributesEnabled: false,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isSurveyBarShowninPDP: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      showPricesForSodimacProducts: true,
      isActiveTabAssistentePersonal: false,
      isBestSellerEnabled: true,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      isSizeEquivalencyTableVisible: false,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isCMRAperturaUrlAddonsEnabled: true,
      isSisSodimacPdpEnabled: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: false,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      isComparativeTableSameSellerEnabled: false,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: false,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isRootCategoryGForFacetCategoriaDisabled: false,
      isSellerBusinessNameEnabled: true,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":false,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: false,
      isPhotoSlurpEnabled: false,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: false,
      isInternationalBuyVisiblePDP: true,
      isGoogleAdsBannerEnabled: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      identifyBuyAtStore: false,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: false,
      isOneClickButtonVisible: false,
      isPidAndPgidValidationDisabled: false,
      isShippingLabelsEnabledInPdp: false,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isNewSizeGroupService: false,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: false,
      isAddtionalSellerTextEnabled: true,
      isProductOrchestratorRecoEnabled: false,
      isCartQuantityLimitsEnabled: false,
      freeShippingOnZonesEnabled: true,
      isEventToggleVisible_SO_COM: false,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isSodimacFaviconTestActivated: false,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isEnabledSposoredVisitInPLP: true,
      isAIExperimentEnabled: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: false,
      isNormalPriceCrossedOut: true,
      isCustomPDPABTestFlagEnabled: false,
      isNewWarrantyOptionsEnabled: true,
      hasFreeShippingForInternationalProducts: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: true,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isReviewValidationWithOrder: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: true,
      isSizeChartDataVisible: true,
      is3PSellerSizeChartEnabled: false,
      isDemoUpVideoEnabled: false,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isEnabledSponsoredClickInPDP: true,
      isImageGalleryEnabled: false,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: false,
      isDebugAdsEnabled: false,
      showFacetsForCollectionRule: true,
      isDynamicFacetsEnabled: true,
      SHOW_SPONSORED_STRIP: true,
      addFeatureScriptsToLongDesc: true,
      allowLongDescScriptInjection: true,
      enableSponsoredInRecommendation: true,
      isEventToggleVisible_TO_COM: false,
      isKioskControlledSearchEnabled: false,
      popularBrandsStaticFacetsEnabled: false,
      IS_PROVIDER_EXPERIMENT_TURNED_ON: false,
      isSearchSpecialCharactersEnabled: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      isNewSearchOrchestratorEnabled: false,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isCustomBannerEnabled: true,
      isExpSellerFilterEnabled: true,
      isInstallmentWithoutInterestEnabled: true,
      popularBrandFacetsEnabled: true,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpconOU',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com/falabella-cl/myaccount/myLists',
      BASKET_PAGE_URI: 'https://www.falabella.com/falabella-cl/basket',
      WORKING_HOURS_SODIMAC: 'https://sodimac.falabella.com/sodimac-cl/page/tiendas-y-horarios-sodimac',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      WORKING_HOURS_TIENDA: 'https://tienda.falabella.com/falabella-cl/page/horarios-tienda-Falabella',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.cl/sodimac-cl/basket',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpsinOU',
      EXT_WARRANTY_LIGHTBOX_LINK: '/falabella-cl/page/garantia?staticPageId=11300003',
      SERVICES_CL_FALABELLA: 'https://www.falabella.com/falabella-cl/page/servicios-falabella',
      WORKING_HOURS_TOTTUS: 'https://tottus.falabella.com/tottus-cl/page/horario_tiendas',
      moreWarrantyBenefitsLink: 'https://www.falabella.com/falabella-cl/page/postventa-garantia-extendida',
    },
    facetLabels: {
      'f.shipping.hd_same_day_zones': '<p>Si compras hasta las&nbsp;<strong>16:00 horas</strong></p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>Hasta 04/05/2025</p>',
      'f.derived.variant.freeShipping': '',
      'f.derived.variant.activeEvent': '<p>Hasta el 04/05/2025</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>SOLO POR 72 HRS</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: false,
        labels: false,
        novios: {
          facets: false,
          labels: false,
        },
        default: {
          facets: false,
          labels: false,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1655991838659-03',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-03',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-16553991838659-0',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-16553991534231-0',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com/falabella-cl',
        sodimac: 'https://sodimac.falabella.com/sodimac-cl',
        tottus: 'https://tottus.falabella.com/tottus-cl',
        linio: 'https://linio.falabella.com/linio-cl',
        homecenter: 'https://homecenter.falabella.com/homecenter-cl',
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusion: 'dior',
      productTitleBrandRemovalExclusions: ['dior'],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      skipPositionCategories: [
        'cat20002',
        'cat850030',
        'cat14330023',
        'cat850036',
        'cat7330051',
        'cat1320008',
        'CATG34996',
        'cat850040',
        'cat1320010',
        'cat16580002',
        'cat13140017',
        'cat850034',
        'cat850042',
        'cat7350055',
        'cat850044',
        'cat11610008',
        'cat7350018',
        'cat7350012',
        'cat7350013',
        'cat7350017',
        'cat7350019',
        'cat18380042',
        'cat1320012',
        'cat7450073',
        'cat17980009',
        'cat7500027',
        'cat13620025',
        'cat7450062',
        'cat1640033',
        'cat5260002',
        'cat7450083',
        'cat7450088',
        'cat7450086',
        'cat7450065',
        'cat660024',
        'cat2083',
        'cat850068',
        'cat850064',
        'cat12440001',
        'cat690245',
        'cat13680004',
        'cat14730004',
        'cat6930168',
        'cat6930003',
        'CATG35031',
        'CATG12010',
        'cat7280122',
        'cat5620004',
        'cat12850003',
        'cat12850002',
        'cat12270016',
        'CATG34995',
        'cat7480104',
        'cat2017',
        'cat3207',
        'cat690235',
        'cat5880085',
        'cat3208',
        'cat6050003',
        'cat3143',
        'cat6050008',
        'cat590028',
        'cat570195',
        'cat6050011',
        'cat13990004',
        'CATG34994',
        'cat6930019',
        'cat12650001',
        'cat6930011',
        'cat6930180',
        'cat6930190',
        'cat6930014',
        'cat6930181',
        'cat6930018',
        'CATG19087',
        'cat6930191',
        'cat12650004',
        'cat12650002',
        'CATG33917',
        'cat190004',
        'cat7660148',
        'cat16400020',
        'cat16400012',
        'cat16400016',
        'cat16400014',
        'cat16400019',
        'cat16400015',
        'cat19280010',
        'cat16400013',
        'cat16400018',
        'cat17010032',
        'cat17010033',
        'cat19280007',
        'cat14370004',
        'cat17180020',
        'cat17180021',
        'cat7530038',
        'cat7530010',
        'cat15330001',
        'cat15330018',
        'cat15330005',
        'cat15330021',
        'cat15330022',
        'cat15330003',
        'cat15330006',
        'cat15330023',
        'cat15330011',
        'cat15330027',
        'cat15330009',
        'cat15330025',
        'cat15330030',
        'cat15330017',
        'cat15330019',
        'cat15330010',
        'cat15330026',
        'cat15330012',
        'cat15330029',
        'cat15330004',
        'cat15330020',
      ],
      SponsoredDisplayPosition: {
        positions: {},
      },
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b> app',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira desde 90 min',
          cc_next_day: 'Retira mañana',
          hd_express: 'Retira en 2 horas',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver este producto es gratis',
            intl: 'Devolver este producto es gratis',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Producto sin derecho a retracto',
            intl: 'Producto sin derecho a retracto',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      topSortExperimentConfig: {
        categories: [],
        searchTerms: [],
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      tipoFacetAttributeBannerConfig: {
        visible: true,
        androidVersion: '2.6.39',
        iosVersion: '2.6.38',
      },
      sellerExpCookies: {
        seller_exp_1: 'exp_1',
        seller_exp_2: 'exp_2',
        seller_exp_3: 'exp_3',
        seller_exp_4: 'exp_4',
      },
      whiteLabelSitesEnabled: ['fa_america', 'fa_aldo'],
    },
  },
  linio: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      BEIGE: '#cfb174',
      NEGRO: '#000000',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      COMBO_GTD_MANQUEHUE_LABEL: 'GTD Manquehue',
      HOME_DELI_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      ENVIO_GRATIS_LABEL_AMOUNT: '$59.990',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      SPONSORED_PRODUCT_SLOTS_APP: '[0, 14.28, 42.8, 71.2]',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL: 'https://fconnect.falabellatienda.com/web-bff/solicita/llamada',
      ADDING_TO_CART_1: 'Agregando',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      CURRENT_NUMBER_PLACEHOLDER: '9 8765 4321',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      VIEW_PLANES_LABEL_REBRANDING: 'Ver planes',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Juntos van mejor',
      CHIP: 'CHIP',
      COOKIES_PAIR_TO_REMOVE: 'bi_ab::oltr_enabled',
      REGIONS: 'Regiones',
      PDP_STARTS_FROM: 'A partir de: ',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo con plan desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '14:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      PDP_NO_THANKS: 'Sin garantía extendida',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ de la marca $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Envío a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$, conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Tienes 30 días desde que lo recibes. ',
      SELLER_SKU_ID: 'Cód. tienda',
      NEW_BADGE: 'Nuevo',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      CONNECT_GO_BACK: 'Volver atrás',
      COMBO_WOM_LABEL: 'WOM',
      SEE_COMMENTS: 'Ver comentarios',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK_MKP: 'No Retiro en tienda',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE',
      MORE_PRODUCTS_FROM_COLLECTION: 'Juntos van mejor',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      SELECTION_TIENDA: 'Selecciona la talla para ver disponibillidad en tienda:',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona un punto de retiro',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Encuentra $xlp_name$ $facet_value$ y elige el mejor precio para ti. Conoce nuestras ofertas y promociones online. Ahorra comprando de manera fácil y segura en Linio $country$.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Conoce los modelos de $facet_value$ en $xlp_name$. Elige la opción perfecta y adquiere tus productos favoritos con descuentos en Linio $country$.',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      ONLY_BUY_AT_STORE: 'Compra solo en tienda',
      MARKET_PLACE: 'Marketplace',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      COMBO_MOVIL_FALABELLA_LABEL: 'Movil Falabella',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      CONNECT_AGENT: 'EvalFalConnectj6S9B30n104f94g',
      PRODUCT_OUTOFSTOCK: '¡Qué mal! Justo se agotó',
      ERROR_SERVICE_TRY_AGAIN:
        '¡Intenta nuevamente! la conexión tardó más de lo esperado. Vuelve a intentar y revisa los planes que tenemos disponibles para ti.',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      CONNECT_ASSESSMENT_FORM_ERROR_CLIENT: 'ESTIMADO CLIENTE',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      OCULTAR_LABEL: 'Ocultar',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      CONNECT_CMR_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/cmr/consultaCmrInternet',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce los plazos y exclusiones',
      VENDOR_PRICE_LABEL: 'Precio',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      PDP_BI_AB_COOKIE: 'pdp_ab',
      CONNECT_OPERATOR_SERVICE_CALL:
        'https://fconnect.falabellatienda.com/api-txd/credito/consultaInformacionCreditoInternet',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      VOLVER_A_REVISAR: 'Volver a revisar',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Comuna',
      LOG_OUT_LABEL: 'Cerrar sesión',
      GOOGLE_ELEMENT_UNIQUE_ID: 'div-gpt-ad-3024305',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      HOW_WORKS_CONNECT: '¿Cómo funciona Falabella Connect?',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      NEED_RUT: 'Tenemos ofertas especiales. Solo necesitamos tu RUT para mostrártelas.',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      SLP_BI_AB_COOKIE: 'search_ab',
      READY: 'Aplicar',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos podrían agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Región',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      CONNECT_ERROR_MESSAGE_BUTTON: 'Aceptar',
      COMBO_OPERATOR_LABEL: 'Operador',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      CONNECT_IMPORTANT_THINGS:
        ' Esperamos ofrecerte los mejores planes y equipos, pero antes queremos recordarte dos cosas importantes:',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANES: 'PLANES',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      ERROR_COLOR_NOT_SELECTED: 'Seleccionar tu color para contratar el plan',
      sellerMuteValue: 'LINIO',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      COMBO_ENTEL_LABEL: 'Entel',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis app',
      FAILED_ADDING_TO_CART_LABEL: 'Este producto ya no está disponible.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      COMBO_VTR_LABEL: 'VTR',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      COMBO_PREPAGO_LABEL: 'Prepago',
      HOW_WORKS_CONNECT_TITLE: 'Términos y condiciones Falabella Connect',
      HOME_DELIVERY_SHIPPING: 'Despacho a domicilio.',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      SAME_DAY_FACET_MINUTES: 59,
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '19990',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      COMBO_MOVISTAR_LABEL: 'Movistar',
      ASSOCIATED_SELLER_INFO:
        'Este es un producto publicado directamente por un vendedor nacional o internacional y cuenta con el respaldo de Falabella. En algunos casos podría tener plazos de despacho diferentes a los habituales.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      CURRENT_NUMBER_PREFIX: '+56 ',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      REVIEW_CONTRACT: 'Revisa el mandato y contrato. Elige la modalidad de firma que más te acomode.',
      OUT_SERVICE:
        'En estos momentos no fue posible atender su solicitud. Por favor vuelve a intentar dentro de unos minutos.',
      CONNECT_IFRAME_WIDTH: 1080,
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      SELECT_PROMOTION_TEXT: 'Seleccionar Promoción',
      CONNECT_PLANS_CMR_ERROR_BLACK_LIST: 'No califica para comprar planes con falabella connect.',
      RETURN_POLICY_INFO_HARDLINE: 'Tienes 30 días desde que lo recibes. ',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      CONNECT_AUTENTIA_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/validaCliente/validaCi',
      isFastShippingTextEnabled: false,
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      CMR_MAPPING:
        'WwogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBDTVIiLAogICAgImRpdmlkZUZhY3RvciI6IDIwMCwKICAgICJsb2dvIjogImljb25zLmNtclRhcmpldGFJY29uIgogIH0sCiAgewogICAgInRpdGxlIjogIkNvbiBEw6liaXRvIEJhbmNvIEZhbGFiZWxsYSIsCiAgICAiZGl2aWRlRmFjdG9yIjogNTAwLAogICAgImxvZ28iOiAiY29ucy5iYW5jb0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIEN1ZW50YSBGcGF5IiwKICAgICJkaXZpZGVGYWN0b3IiOiA1MDAsCiAgICAibG9nbyI6ICJpY29ucy5mcGF5SWNvbiIKICB9LAogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBkZSBjcsOpZGl0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuY3JlZGl0b0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIHRhcmpldGEgZGUgZMOpYml0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuZGViaXRvSWNvbiIKICB9Cl0=',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      PICKUP_OR_DELIVERY:
        'Retira tu compra en cualquiera de nuestras tiendas. Si firmaste en línea, recibe tu Smartphone donde quieras y disfrútalo.',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      HIRE_YOUR_PLAN: 'Datos para contratar tu plan',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      CURRENT_NUMBER_LABEL: 'Número Actual',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$|^[0-9]{1,}[A-Z]?C$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción ',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      PICKUP_INSTORE_SO_TITLE: 'Retiro en tienda',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Puntos de retiro disponibles',
      CMSIZE: 'cm',
      BUY_CONNECT_ONLINE: '¡Ahorra tiempo! Compra un Smartphone y contrata un plan, todo en línea y de una sola vez.',
      OF: 'de',
      PICKUP_INSTORE_CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      CHECK_THE_OFFERS: '¡Revisa las ofertas!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Conoce nuestra variedad de $xlp_name$ y elige el mejor modelo para ti. Realiza tus compras de manera segura y ahorra haciendo tus compras online en Linio $country$.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAN: 'Limpiar Filtro',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p> <p>Descubre un amplio catálogo de productos en Sodimac para %Category Name%. Encuentra todo lo que necesitas para renovar tu hogar. ¡Visítanos y encuentra inspiración para tus proyectos!</p> <p>Desde herramientas hasta accesorios, estamos aquí para ayudarte a hacer realidad tus ideas y renovar tus espacios, creando un ambiente único y personalizado. Explora nuestra selección de herramientas, materiales y accesorios de calidad que te ayudarán a crear un espacio más tú.</p> <p>Desde remodelaciones hasta proyectos de decoración, estamos aquí para hacer tus ideas realidad. ¡Visítanos y encuentra todo lo que tenemos para ofrecerte en %Category Name%!</p> <h2>Explora la variedad de productos de %Category Name% en Sodimac</h2> <p>Herramientas, materiales y accesorios de calidad para tus proyectos y renovación de espacios. ¡Visítanos y descubre todo lo que tenemos para ofrecerte!</p> <p>Encuentra una amplia variedad de productos de %Category Name% en Sodimac. Encuentra todo lo necesario para tus proyectos de renovación y decoración. ¡Visítanos y haz tus ideas realidad!</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Compra lo mejor de $xlp_name$ a un solo click. Encuentra esto y todo lo que necesitas en Falabella y Falabella.com!',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: ' Ábrela',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      CMR_DEFAULT_INSTALLMENTS: '10',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      SUMMARY_MODAL_NOTICE:
        'El valor del plan lo podrás pagar en el sitio web del operador o directamente en la tienda.',
      CONNECT_ERROR_MESSAGE:
        'Lo sentimos, se ha producido un error confirmando tu compra. Por favor, comunícate con nuestro Servicio al Cliente al 223907910 o escríbenos a contacto@falabella.cl',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $10.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $10.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      MORE_OPTIONS: 'Ver opciones',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      toggleViewButtonText: 'Visualizar por:',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      SKU_EQUIPMENT: 'SKU Equipo',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      BACK_ROOM: 'trastienda',
      EVALUATE_PLANS_BUTTON: 'REVISAR PLANES',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RECEIVE_AND_ENJOY: '¡Recibe y disfruta!',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devuelve gratis por Derecho a retracto o Satisfacción garantizada.',
      CONNECT_IFRAME_URL: 'https://txd-fconnect-prd.appspot.com/#/?data=',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      VIEW_PLAN_REBRANDING: 'Ver plan',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      NEXT_DAY_SHIPPING_MIN_MAX_HOURS: '19.5,4',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      ATC_ONLY_BUY_AT_STORE: 'Ver Producto',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      ERROR_SERVICE_NO_PLANS: 'Lo sentimos, no se han encontrado planes disponibles en esta evaluación',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      CONNECT_PLANS_CMR_INVALID: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      LOGIN_SIGN_UP: 'Regístrate',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_IMPORTANT_THING_3: 'Si quieres portar tú número a otra compañía tienes que ser el titular de la línea.',
      CONNECT_AUTENTIA_ERROR_MESSAGE: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$ grandes ofertas',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'REVISAR PLANES',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CONNECT_IMPORTANT_THING_2:
        'Para contratar un plan necesitamos hacer una previa evaluación financiera. Por esto Promotora CMR Falabella S.A nos proporciona información necesaria para que podamos ofrecerte un plan adecuado y especial para ti. Si todavía no tienes tu CMR no dudes en sacarla.',
      CONNECT_IMPORTANT_THING_1: 'Para contratar tu plan tienes que tener tarjeta',
      CONNECT_ERROR_MESSAGE_BASKET:
        'Lo sentimos, no es posible añadir más productos a la Bolsa. Ya tienes agregado un producto de Falabella Connect. Este tipo de producto debe ser comprado de manera independiente, ya que tiene un despacho preferente.',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      CONTRACT_PLAN: 'CONTRATAR PLAN',
      UKSIZE: 'UK',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      SKU_PLAN: 'SKU Plan',
      PLANS_DETAILS_FREE_LABEL: 'LIBRES',
      PRODUCT_ORCHESTRATOR_FLOW: 'false',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      HIRE: 'CONTRATA TU',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores que tenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CONNECT_LEGAL_TEXT:
        'Los términos y condiciones regulan la evaluación comercial de los planes de telefonía móvil ofrecidos por los operadores de telefonía móvil en nuestro sitio web www.falabella.com, que puedes contratar en conjunto con los teléfonos celulares comercializados por Falabella Retail S.A. Puedes revisar el contenido de los términos y condiciones de la evaluación comercial aqui.\n\nPara realizar la evaluación comercial, es necesario que seas titular de una tarjeta CMR, y que ésta haya sido emitida, con al menos, 90 días de antigüedad a la fecha de solicitud de evaluación o contratación del plan de telefonía móvil. Adicionalmente, validaremos la vigencia y la exactitud de los datos de tu cédula de identidad que nos proporciones.\n\nLos productos deben ser comprados de manera independiente y separada de otros productos que puedas tener en tu carro de compras. Si tienes productos adicionales en tu carro de compra, no te preocupes, éstos quedarán guardados para una compra futura.\n\nEl plan de telefonía y el precio del equipo pueden ser pagados con cualquier medio de pago disponible en falabella.com. El descuento en el precio del equipo está sujeto a la contratación del plan de telefonía respectivo y a la firma de un mandato para el cobro en tu tarjeta de crédito CMR, de la diferencia entre el precio del equipo y el precio prepago de este, según corresponda, el cual aplicará si das de baja el plan suscrito o contratas uno más económico dentro de un periodo de 18 meses para cada operador.\n\nDebido a los requerimientos y procesos del operador telefónico, existe un plazo máximo de 15 días para que recibas tu producto.',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      TRACK_ORDER: 'Seguimiento de mi orden',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      BOOM_SHIPPING: 'Boom',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      PLAN: 'PLAN',
      HOME_DELI_SO_TITLE: 'Despacho a domicilio',
      PRODUCT_CODE: 'Código del producto',
      SAME_DAY_FACET_HOURS: '15',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 600 390 4100',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN: 'https://fconnect.falabellatienda.com/api-txd/getTokenEncrypt',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'Agregar los {count} al Carro',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      TYPE_C_HOME_DELI_OUTOFSTOCK_MKP: 'No disponible para envío a domicilio',
      PICKUP_INSTORE_TITLE: 'Retiro en un punto',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '15:30 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$facet_value$ encuéntralo en $xlp_name$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      FILL_YOUR_DETAILS: 'Completa tus datos y firma',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      WARNING_A11Y_LABEL: 'Warning',
      ERROR_SERVICE_SAME_OPERATOR:
        'No puedes realizar compra de un plan de tu misma compañía. ¡Revisa la oferta con otros operadores!',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      COMBO_PLAN_PREPAGO_LABEL: 'Plan / Prepago',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ $country$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'REVISA TUS PLANES',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      COMBO_CLARO_LABEL: 'Claro',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON: 'PROBAR CON OTRO RUT',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      GO_BACK_TO_PLANS: 'Volver a planes',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      COMBO_NETLINE_LABEL: 'Netline',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en Linio $country$. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G200401,G200402,G200403,G200405,G200406,G200407,G20040804,G20040809,G20040813,G20040901,G20040906,G20040908,G20040914,G200410,G200411,G200412,G20041303,G20041213,G20041405,G20041406,G20041407,G20041410,G200415,G200416,G200417,G200418,G200419,G20042002,G20042006,G200421,G200422,G200423,G200424',
      CIUDAD_TEXT: 'Partido',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      CMR_POINTS: 'CMR Puntos',
      CMRAPERTURATEXT_REQUEST: '¿Aún no tienes tu CMR Banco Falabella?',
      HOME_SHIPPING: 'Envío a domicilio',
      COMBO_SIMPLE_LABEL: 'Simple',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      COLLECTIONS_TO_SHOW_PLANS: 'connect-products,prueba-connect,falabella-connect',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      CONNECT_IFRAME_HEIGHT: 713,
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      CMR_Falabella: 'CMR Falabella.',
      WHY: '¿Porqué?',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PUM_AFFIX: ' a ',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      ACCEPT: 'ACEPTAR',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      COMBO_PLAN_LABEL: 'Plan',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 600 3904100',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      CHOOSE_YOUR_PLAN: 'Elige tu equipo y plan',
      COLORS_AVAILABLE_SMALL: 'Colores Disponibles',
      PICKUP_INSTORE_NOT_AVAILABLE_IN: 'No disponible en ',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      COMBO_VIRGIN_LABEL: 'Virgin',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$ $country$',
      RETURN_POLICY_INFO_SHOES: 'Tienes 30 días desde que lo recibes. ',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$ $country$',
      FREE_SHIPPING_PRICE: '59990',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      NEED_HELP_CALL_US_AT_PLAN: '¿Necesitas ayuda para contratar un plan? Llámanos al',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      ERROR_SERVICE_NO_CREDIT:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      OFFER_PRICE_WARRANTY_LABEL: '(Oferta)',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retiro desde 90 min',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SEARCH_TITLE: '$xlp_name$',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b> app,Llega <b>gratis</b> mañana,Retira desde 90 min,Retira mañana',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      darSectionLabel: 'Producto sin derecho a retracto',
      WARRANTY_LABEL_PREFIX: '',
      OVERRIDE_FACETS_COUNT: 'f.derived.variant.sellerId',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio mayorista',
      WHOLESALE_BANNER_BADGE_TEXT_2: '',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      FALLBACK_SEO_TITLE_TYPE: '$type_facet$ encuéntralo en $category_name$ | Linio $country$',
      FALLBACK_SEO_DESCRIPTION_BRAND:
        'Encuentra $category_name$ $brand_name$ y elige el mejor precio para ti. Conoce nuestras ofertas y promociones online. Ahorra comprando de manera fácil y segura en Linio $country$.',
      FALLBACK_SEO_TITLE: '$category_name$ grandes ofertas | Linio $country$',
      FALLBACK_SEO_DESCRIPTION_TYPE:
        'Conoce los modelos de $type_facet$ en $category_name$. Elige la opción perfecta y adquiere tus productos favoritos con descuentos en Linio $country$.',
      FALLBACK_SEO_TITLE_BRAND: '$category_name$ de la marca $brand_name$ | Linio $country$',
      FALLBACK_SEO_DESCRIPTION:
        'Conoce nuestra variedad de $category_name$ y elige el mejor modelo para ti. Realiza tus compras de manera segura y ahorra haciendo tus compras online en Linio $country$.',
    },
    toggles: {
      isSearchWithSoCom: false,
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPositionPerCategoryEnabled: true,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isNewSearchVisible: true,
      isGenericCalculatorEnabled: true,
      IsSearchExperienceCheckbox: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isOneClickCheckoutEnabled: false,
      isEventFilterEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      isInhouseBundleWidgetActive: false,
      PDP_AB_TEST_OVERRIDE_VALUE: '',
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isAbCookieEnabled: false,
      isRelatedKeywordEnabled: false,
      showRatingDescription: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: false,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: false,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      showListToggleButtons: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isShippingAttributesEnabled: false,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isSurveyBarShowninPDP: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      showPricesForSodimacProducts: true,
      isActiveTabAssistentePersonal: false,
      isBestSellerEnabled: true,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      isSizeEquivalencyTableVisible: false,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isCMRAperturaUrlAddonsEnabled: true,
      isSisSodimacPdpEnabled: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: false,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      isComparativeTableSameSellerEnabled: false,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: false,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isRootCategoryGForFacetCategoriaDisabled: false,
      isSellerBusinessNameEnabled: true,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":false,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: false,
      isPhotoSlurpEnabled: false,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: false,
      isInternationalBuyVisiblePDP: true,
      isGoogleAdsBannerEnabled: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      identifyBuyAtStore: false,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: false,
      isOneClickButtonVisible: false,
      isPidAndPgidValidationDisabled: false,
      isShippingLabelsEnabledInPdp: false,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isNewSizeGroupService: false,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: false,
      isAddtionalSellerTextEnabled: true,
      isProductOrchestratorRecoEnabled: false,
      isCartQuantityLimitsEnabled: false,
      freeShippingOnZonesEnabled: true,
      isEventToggleVisible_SO_COM: false,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isSodimacFaviconTestActivated: false,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isEnabledSposoredVisitInPLP: true,
      isAIExperimentEnabled: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: false,
      isNormalPriceCrossedOut: true,
      isCustomPDPABTestFlagEnabled: false,
      isNewWarrantyOptionsEnabled: true,
      hasFreeShippingForInternationalProducts: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: true,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isReviewValidationWithOrder: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: true,
      isSizeChartDataVisible: true,
      is3PSellerSizeChartEnabled: false,
      isDemoUpVideoEnabled: false,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isEnabledSponsoredClickInPDP: true,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDebugAdsEnabled: false,
      showFacetsForCollectionRule: true,
      isDynamicFacetsEnabled: true,
      SHOW_SPONSORED_STRIP: true,
      addFeatureScriptsToLongDesc: true,
      allowLongDescScriptInjection: true,
      enableSponsoredInRecommendation: true,
      isEventToggleVisible_TO_COM: false,
      isKioskControlledSearchEnabled: false,
      popularBrandsStaticFacetsEnabled: false,
      IS_PROVIDER_EXPERIMENT_TURNED_ON: false,
      isSearchSpecialCharactersEnabled: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      isNewSearchOrchestratorEnabled: false,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isCustomBannerEnabled: true,
      isExpSellerFilterEnabled: true,
      isInstallmentWithoutInterestEnabled: true,
      popularBrandFacetsEnabled: true,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpconOU',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com/falabella-cl/myaccount/myLists',
      BASKET_PAGE_URI: 'https://www.falabella.com/falabella-cl/basket',
      WORKING_HOURS_SODIMAC: 'https://sodimac.falabella.com/sodimac-cl/page/tiendas-y-horarios-sodimac',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      WORKING_HOURS_TIENDA: 'https://tienda.falabella.com/falabella-cl/page/horarios-tienda-Falabella',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.cl/sodimac-cl/basket',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpsinOU',
      EXT_WARRANTY_LIGHTBOX_LINK: '/falabella-cl/page/garantia?staticPageId=11300003',
      SERVICES_CL_FALABELLA: 'https://www.falabella.com/falabella-cl/page/servicios-falabella',
      WORKING_HOURS_TOTTUS: 'https://tottus.falabella.com/tottus-cl/page/horario_tiendas',
      moreWarrantyBenefitsLink: 'https://www.falabella.com/falabella-cl/page/postventa-garantia-extendida',
    },
    facetLabels: {
      'f.shipping.hd_same_day_zones': '<p>Si compras hasta las&nbsp;<strong>16:00 horas</strong></p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>Hasta 04/05/2025</p>',
      'f.derived.variant.freeShipping': '',
      'f.derived.variant.activeEvent': '<p>Hasta el 04/05/2025</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>SOLO POR 72 HRS</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: false,
        labels: false,
        novios: {
          facets: false,
          labels: false,
        },
        default: {
          facets: false,
          labels: false,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1655991838659-03',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-03',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-16553991838659-0',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-16553991534231-0',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com/falabella-cl',
        sodimac: 'https://sodimac.falabella.com/sodimac-cl',
        tottus: 'https://tottus.falabella.com/tottus-cl',
        linio: 'https://linio.falabella.com/linio-cl',
        homecenter: 'https://homecenter.falabella.com/homecenter-cl',
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusion: 'dior',
      productTitleBrandRemovalExclusions: ['dior'],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      skipPositionCategories: [
        'cat20002',
        'cat850030',
        'cat14330023',
        'cat850036',
        'cat7330051',
        'cat1320008',
        'CATG34996',
        'cat850040',
        'cat1320010',
        'cat16580002',
        'cat13140017',
        'cat850034',
        'cat850042',
        'cat7350055',
        'cat850044',
        'cat11610008',
        'cat7350018',
        'cat7350012',
        'cat7350013',
        'cat7350017',
        'cat7350019',
        'cat18380042',
        'cat1320012',
        'cat7450073',
        'cat17980009',
        'cat7500027',
        'cat13620025',
        'cat7450062',
        'cat1640033',
        'cat5260002',
        'cat7450083',
        'cat7450088',
        'cat7450086',
        'cat7450065',
        'cat660024',
        'cat2083',
        'cat850068',
        'cat850064',
        'cat12440001',
        'cat690245',
        'cat13680004',
        'cat14730004',
        'cat6930168',
        'cat6930003',
        'CATG35031',
        'CATG12010',
        'cat7280122',
        'cat5620004',
        'cat12850003',
        'cat12850002',
        'cat12270016',
        'CATG34995',
        'cat7480104',
        'cat2017',
        'cat3207',
        'cat690235',
        'cat5880085',
        'cat3208',
        'cat6050003',
        'cat3143',
        'cat6050008',
        'cat590028',
        'cat570195',
        'cat6050011',
        'cat13990004',
        'CATG34994',
        'cat6930019',
        'cat12650001',
        'cat6930011',
        'cat6930180',
        'cat6930190',
        'cat6930014',
        'cat6930181',
        'cat6930018',
        'CATG19087',
        'cat6930191',
        'cat12650004',
        'cat12650002',
        'CATG33917',
        'cat190004',
        'cat7660148',
        'cat16400020',
        'cat16400012',
        'cat16400016',
        'cat16400014',
        'cat16400019',
        'cat16400015',
        'cat19280010',
        'cat16400013',
        'cat16400018',
        'cat17010032',
        'cat17010033',
        'cat19280007',
        'cat14370004',
        'cat17180020',
        'cat17180021',
        'cat7530038',
        'cat7530010',
        'cat15330001',
        'cat15330018',
        'cat15330005',
        'cat15330021',
        'cat15330022',
        'cat15330003',
        'cat15330006',
        'cat15330023',
        'cat15330011',
        'cat15330027',
        'cat15330009',
        'cat15330025',
        'cat15330030',
        'cat15330017',
        'cat15330019',
        'cat15330010',
        'cat15330026',
        'cat15330012',
        'cat15330029',
        'cat15330004',
        'cat15330020',
      ],
      SponsoredDisplayPosition: {
        positions: {},
      },
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b> app',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira desde 90 min',
          cc_next_day: 'Retira mañana',
          hd_express: 'Retira en 2 horas',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver este producto es gratis',
            intl: 'Devolver este producto es gratis',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Producto sin derecho a retracto',
            intl: 'Producto sin derecho a retracto',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      topSortExperimentConfig: {
        categories: [],
        searchTerms: [],
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      tipoFacetAttributeBannerConfig: {
        visible: true,
        androidVersion: '2.6.39',
        iosVersion: '2.6.38',
      },
      sellerExpCookies: {
        seller_exp_1: 'exp_1',
        seller_exp_2: 'exp_2',
        seller_exp_3: 'exp_3',
        seller_exp_4: 'exp_4',
      },
      whiteLabelSitesEnabled: ['fa_america', 'fa_aldo'],
    },
  },
  marketplace: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      BEIGE: '#cfb174',
      NEGRO: '#000000',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      COMBO_GTD_MANQUEHUE_LABEL: 'GTD Manquehue',
      HOME_DELI_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      ENVIO_GRATIS_LABEL_AMOUNT: '$59.990',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      SPONSORED_PRODUCT_SLOTS_APP: '[0, 14.28, 42.8, 71.2]',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL: 'https://fconnect.falabellatienda.com/web-bff/solicita/llamada',
      ADDING_TO_CART_1: 'Agregando',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      CURRENT_NUMBER_PLACEHOLDER: '9 8765 4321',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      VIEW_PLANES_LABEL_REBRANDING: 'Ver planes',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Juntos van mejor',
      CHIP: 'CHIP',
      COOKIES_PAIR_TO_REMOVE: 'bi_ab::oltr_enabled',
      REGIONS: 'Regiones',
      PDP_STARTS_FROM: 'A partir de: ',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo con plan desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '14:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      PDP_NO_THANKS: 'Sin garantía extendida',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Envío a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$, conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Tienes 30 días desde que lo recibes. ',
      SELLER_SKU_ID: 'Cód. tienda',
      NEW_BADGE: 'Nuevo',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      CONNECT_GO_BACK: 'Volver atrás',
      COMBO_WOM_LABEL: 'WOM',
      SEE_COMMENTS: 'Ver comentarios',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK_MKP: 'No Retiro en tienda',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE',
      MORE_PRODUCTS_FROM_COLLECTION: 'Juntos van mejor',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      SELECTION_TIENDA: 'Selecciona la talla para ver disponibillidad en tienda:',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona un punto de retiro',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Adquiere $xlp_name$ $facet_value$ de manera segura y fácil en falabella.com Conoce nuestro cátalogo online y haz la mejor elección.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Encuentra lo último de $facet_value$ en $xlp_name$. Elige el modelo perfecto para ti y realiza tus compras online de manera segura en falabella.com',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      ONLY_BUY_AT_STORE: 'Compra solo en tienda',
      MARKET_PLACE: 'Marketplace',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      COMBO_MOVIL_FALABELLA_LABEL: 'Movil Falabella',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      CONNECT_AGENT: 'EvalFalConnectj6S9B30n104f94g',
      PRODUCT_OUTOFSTOCK: '¡Qué mal! Justo se agotó',
      ERROR_SERVICE_TRY_AGAIN:
        '¡Intenta nuevamente! la conexión tardó más de lo esperado. Vuelve a intentar y revisa los planes que tenemos disponibles para ti.',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      CONNECT_ASSESSMENT_FORM_ERROR_CLIENT: 'ESTIMADO CLIENTE',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      OCULTAR_LABEL: 'Ocultar',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      CONNECT_CMR_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/cmr/consultaCmrInternet',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce los plazos y exclusiones',
      VENDOR_PRICE_LABEL: 'Precio',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      PDP_BI_AB_COOKIE: 'pdp_ab',
      CONNECT_OPERATOR_SERVICE_CALL:
        'https://fconnect.falabellatienda.com/api-txd/credito/consultaInformacionCreditoInternet',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      VOLVER_A_REVISAR: 'Volver a revisar',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Comuna',
      LOG_OUT_LABEL: 'Cerrar sesión',
      GOOGLE_ELEMENT_UNIQUE_ID: 'div-gpt-ad-3024305',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      HOW_WORKS_CONNECT: '¿Cómo funciona Falabella Connect?',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      NEED_RUT: 'Tenemos ofertas especiales. Solo necesitamos tu RUT para mostrártelas.',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      SLP_BI_AB_COOKIE: 'search_ab',
      READY: 'Aplicar',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos podrían agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Región',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      CONNECT_ERROR_MESSAGE_BUTTON: 'Aceptar',
      COMBO_OPERATOR_LABEL: 'Operador',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      CONNECT_IMPORTANT_THINGS:
        ' Esperamos ofrecerte los mejores planes y equipos, pero antes queremos recordarte dos cosas importantes:',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANES: 'PLANES',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      ERROR_COLOR_NOT_SELECTED: 'Seleccionar tu color para contratar el plan',
      sellerMuteValue: 'LINIO',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      COMBO_ENTEL_LABEL: 'Entel',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis app',
      FAILED_ADDING_TO_CART_LABEL: 'Este producto ya no está disponible.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      COMBO_VTR_LABEL: 'VTR',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      COMBO_PREPAGO_LABEL: 'Prepago',
      HOW_WORKS_CONNECT_TITLE: 'Términos y condiciones Falabella Connect',
      HOME_DELIVERY_SHIPPING: 'Despacho a domicilio.',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      SAME_DAY_FACET_MINUTES: 59,
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '19990',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      COMBO_MOVISTAR_LABEL: 'Movistar',
      ASSOCIATED_SELLER_INFO:
        'Este es un producto publicado directamente por un vendedor nacional o internacional y cuenta con el respaldo de Falabella. En algunos casos podría tener plazos de despacho diferentes a los habituales.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      CURRENT_NUMBER_PREFIX: '+56 ',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      REVIEW_CONTRACT: 'Revisa el mandato y contrato. Elige la modalidad de firma que más te acomode.',
      OUT_SERVICE:
        'En estos momentos no fue posible atender su solicitud. Por favor vuelve a intentar dentro de unos minutos.',
      CONNECT_IFRAME_WIDTH: 1080,
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      SELECT_PROMOTION_TEXT: 'Seleccionar Promoción',
      CONNECT_PLANS_CMR_ERROR_BLACK_LIST: 'No califica para comprar planes con falabella connect.',
      RETURN_POLICY_INFO_HARDLINE: 'Tienes 30 días desde que lo recibes. ',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      CONNECT_AUTENTIA_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/validaCliente/validaCi',
      isFastShippingTextEnabled: false,
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      CMR_MAPPING:
        'WwogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBDTVIiLAogICAgImRpdmlkZUZhY3RvciI6IDIwMCwKICAgICJsb2dvIjogImljb25zLmNtclRhcmpldGFJY29uIgogIH0sCiAgewogICAgInRpdGxlIjogIkNvbiBEw6liaXRvIEJhbmNvIEZhbGFiZWxsYSIsCiAgICAiZGl2aWRlRmFjdG9yIjogNTAwLAogICAgImxvZ28iOiAiY29ucy5iYW5jb0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIEN1ZW50YSBGcGF5IiwKICAgICJkaXZpZGVGYWN0b3IiOiA1MDAsCiAgICAibG9nbyI6ICJpY29ucy5mcGF5SWNvbiIKICB9LAogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBkZSBjcsOpZGl0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuY3JlZGl0b0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIHRhcmpldGEgZGUgZMOpYml0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuZGViaXRvSWNvbiIKICB9Cl0=',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      PICKUP_OR_DELIVERY:
        'Retira tu compra en cualquiera de nuestras tiendas. Si firmaste en línea, recibe tu Smartphone donde quieras y disfrútalo.',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      HIRE_YOUR_PLAN: 'Datos para contratar tu plan',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      CURRENT_NUMBER_LABEL: 'Número Actual',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$|^[0-9]{1,}[A-Z]?C$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción ',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      PICKUP_INSTORE_SO_TITLE: 'Retiro en tienda',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Puntos de retiro disponibles',
      CMSIZE: 'cm',
      BUY_CONNECT_ONLINE: '¡Ahorra tiempo! Compra un Smartphone y contrata un plan, todo en línea y de una sola vez.',
      OF: 'de',
      PICKUP_INSTORE_CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      CHECK_THE_OFFERS: '¡Revisa las ofertas!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com Conoce nuestro catálogo de $xlp_name$ y elige la opción perfecta para ti.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAN: 'Limpiar Filtro',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p> <p>Descubre un amplio catálogo de productos en Sodimac para %Category Name%. Encuentra todo lo que necesitas para renovar tu hogar. ¡Visítanos y encuentra inspiración para tus proyectos!</p> <p>Desde herramientas hasta accesorios, estamos aquí para ayudarte a hacer realidad tus ideas y renovar tus espacios, creando un ambiente único y personalizado. Explora nuestra selección de herramientas, materiales y accesorios de calidad que te ayudarán a crear un espacio más tú.</p> <p>Desde remodelaciones hasta proyectos de decoración, estamos aquí para hacer tus ideas realidad. ¡Visítanos y encuentra todo lo que tenemos para ofrecerte en %Category Name%!</p> <h2>Explora la variedad de productos de %Category Name% en Sodimac</h2> <p>Herramientas, materiales y accesorios de calidad para tus proyectos y renovación de espacios. ¡Visítanos y descubre todo lo que tenemos para ofrecerte!</p> <p>Encuentra una amplia variedad de productos de %Category Name% en Sodimac. Encuentra todo lo necesario para tus proyectos de renovación y decoración. ¡Visítanos y haz tus ideas realidad!</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Compra lo mejor de $xlp_name$ a un solo click. Encuentra esto y todo lo que necesitas en Falabella y Falabella.com!',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: ' Ábrela',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      CMR_DEFAULT_INSTALLMENTS: '10',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      SUMMARY_MODAL_NOTICE:
        'El valor del plan lo podrás pagar en el sitio web del operador o directamente en la tienda.',
      CONNECT_ERROR_MESSAGE:
        'Lo sentimos, se ha producido un error confirmando tu compra. Por favor, comunícate con nuestro Servicio al Cliente al 223907910 o escríbenos a contacto@falabella.cl',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $10.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $10.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      MORE_OPTIONS: 'Ver opciones',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      toggleViewButtonText: 'Visualizar por:',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      SKU_EQUIPMENT: 'SKU Equipo',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      BACK_ROOM: 'trastienda',
      EVALUATE_PLANS_BUTTON: 'REVISAR PLANES',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RECEIVE_AND_ENJOY: '¡Recibe y disfruta!',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devuelve gratis por Derecho a retracto o Satisfacción garantizada.',
      CONNECT_IFRAME_URL: 'https://txd-fconnect-prd.appspot.com/#/?data=',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      VIEW_PLAN_REBRANDING: 'Ver plan',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      NEXT_DAY_SHIPPING_MIN_MAX_HOURS: '19.5,4',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      ATC_ONLY_BUY_AT_STORE: 'Ver Producto',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      ERROR_SERVICE_NO_PLANS: 'Lo sentimos, no se han encontrado planes disponibles en esta evaluación',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      CONNECT_PLANS_CMR_INVALID: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      LOGIN_SIGN_UP: 'Regístrate',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_IMPORTANT_THING_3: 'Si quieres portar tú número a otra compañía tienes que ser el titular de la línea.',
      CONNECT_AUTENTIA_ERROR_MESSAGE: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'REVISAR PLANES',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CONNECT_IMPORTANT_THING_2:
        'Para contratar un plan necesitamos hacer una previa evaluación financiera. Por esto Promotora CMR Falabella S.A nos proporciona información necesaria para que podamos ofrecerte un plan adecuado y especial para ti. Si todavía no tienes tu CMR no dudes en sacarla.',
      CONNECT_IMPORTANT_THING_1: 'Para contratar tu plan tienes que tener tarjeta',
      CONNECT_ERROR_MESSAGE_BASKET:
        'Lo sentimos, no es posible añadir más productos a la Bolsa. Ya tienes agregado un producto de Falabella Connect. Este tipo de producto debe ser comprado de manera independiente, ya que tiene un despacho preferente.',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      CONTRACT_PLAN: 'CONTRATAR PLAN',
      UKSIZE: 'UK',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      SKU_PLAN: 'SKU Plan',
      PLANS_DETAILS_FREE_LABEL: 'LIBRES',
      PRODUCT_ORCHESTRATOR_FLOW: 'false',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      HIRE: 'CONTRATA TU',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores que tenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CONNECT_LEGAL_TEXT:
        'Los términos y condiciones regulan la evaluación comercial de los planes de telefonía móvil ofrecidos por los operadores de telefonía móvil en nuestro sitio web www.falabella.com, que puedes contratar en conjunto con los teléfonos celulares comercializados por Falabella Retail S.A. Puedes revisar el contenido de los términos y condiciones de la evaluación comercial aqui.\n\nPara realizar la evaluación comercial, es necesario que seas titular de una tarjeta CMR, y que ésta haya sido emitida, con al menos, 90 días de antigüedad a la fecha de solicitud de evaluación o contratación del plan de telefonía móvil. Adicionalmente, validaremos la vigencia y la exactitud de los datos de tu cédula de identidad que nos proporciones.\n\nLos productos deben ser comprados de manera independiente y separada de otros productos que puedas tener en tu carro de compras. Si tienes productos adicionales en tu carro de compra, no te preocupes, éstos quedarán guardados para una compra futura.\n\nEl plan de telefonía y el precio del equipo pueden ser pagados con cualquier medio de pago disponible en falabella.com. El descuento en el precio del equipo está sujeto a la contratación del plan de telefonía respectivo y a la firma de un mandato para el cobro en tu tarjeta de crédito CMR, de la diferencia entre el precio del equipo y el precio prepago de este, según corresponda, el cual aplicará si das de baja el plan suscrito o contratas uno más económico dentro de un periodo de 18 meses para cada operador.\n\nDebido a los requerimientos y procesos del operador telefónico, existe un plazo máximo de 15 días para que recibas tu producto.',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      TRACK_ORDER: 'Seguimiento de mi orden',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      BOOM_SHIPPING: 'Boom',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      PLAN: 'PLAN',
      HOME_DELI_SO_TITLE: 'Despacho a domicilio',
      PRODUCT_CODE: 'Código del producto',
      SAME_DAY_FACET_HOURS: '15',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 600 390 4100',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN: 'https://fconnect.falabellatienda.com/api-txd/getTokenEncrypt',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'Agregar los {count} al Carro',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      TYPE_C_HOME_DELI_OUTOFSTOCK_MKP: 'No disponible para envío a domicilio',
      PICKUP_INSTORE_TITLE: 'Retiro en un punto',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '15:30 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$xlp_name$ $facet_value$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      FILL_YOUR_DETAILS: 'Completa tus datos y firma',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      WARNING_A11Y_LABEL: 'Warning',
      ERROR_SERVICE_SAME_OPERATOR:
        'No puedes realizar compra de un plan de tu misma compañía. ¡Revisa la oferta con otros operadores!',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      COMBO_PLAN_PREPAGO_LABEL: 'Plan / Prepago',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'REVISA TUS PLANES',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      COMBO_CLARO_LABEL: 'Claro',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON: 'PROBAR CON OTRO RUT',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      GO_BACK_TO_PLANS: 'Volver a planes',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      COMBO_NETLINE_LABEL: 'Netline',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G200401,G200402,G200403,G200405,G200406,G200407,G20040804,G20040809,G20040813,G20040901,G20040906,G20040908,G20040914,G200410,G200411,G200412,G20041303,G20041213,G20041405,G20041406,G20041407,G20041410,G200415,G200416,G200417,G200418,G200419,G20042002,G20042006,G200421,G200422,G200423,G200424',
      CIUDAD_TEXT: 'Partido',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      CMR_POINTS: 'CMR Puntos',
      CMRAPERTURATEXT_REQUEST: '¿Aún no tienes tu CMR Banco Falabella?',
      HOME_SHIPPING: 'Envío a domicilio',
      COMBO_SIMPLE_LABEL: 'Simple',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      COLLECTIONS_TO_SHOW_PLANS: 'connect-products,prueba-connect,falabella-connect',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      CONNECT_IFRAME_HEIGHT: 713,
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      CMR_Falabella: 'CMR Falabella.',
      WHY: '¿Porqué?',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PUM_AFFIX: ' a ',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      ACCEPT: 'ACEPTAR',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      COMBO_PLAN_LABEL: 'Plan',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 600 3904100',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      CHOOSE_YOUR_PLAN: 'Elige tu equipo y plan',
      COLORS_AVAILABLE_SMALL: 'Colores Disponibles',
      PICKUP_INSTORE_NOT_AVAILABLE_IN: 'No disponible en ',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      COMBO_VIRGIN_LABEL: 'Virgin',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: 'Tienes 30 días desde que lo recibes. ',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      FREE_SHIPPING_PRICE: '59990',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      NEED_HELP_CALL_US_AT_PLAN: '¿Necesitas ayuda para contratar un plan? Llámanos al',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      ERROR_SERVICE_NO_CREDIT:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      OFFER_PRICE_WARRANTY_LABEL: '(Oferta)',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retiro desde 90 min',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SEARCH_TITLE: '$xlp_name$',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b> app,Llega <b>gratis</b> mañana,Retira desde 90 min,Retira mañana',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      darSectionLabel: 'Producto sin derecho a retracto',
      WARRANTY_LABEL_PREFIX: '',
      OVERRIDE_FACETS_COUNT: 'f.derived.variant.sellerId',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio mayorista',
      WHOLESALE_BANNER_BADGE_TEXT_2: '',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
    },
    toggles: {
      isSearchWithSoCom: false,
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPositionPerCategoryEnabled: true,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isNewSearchVisible: true,
      isGenericCalculatorEnabled: true,
      IsSearchExperienceCheckbox: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isOneClickCheckoutEnabled: false,
      isEventFilterEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      isInhouseBundleWidgetActive: false,
      PDP_AB_TEST_OVERRIDE_VALUE: '',
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isAbCookieEnabled: false,
      isRelatedKeywordEnabled: false,
      showRatingDescription: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: false,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: false,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      showListToggleButtons: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isShippingAttributesEnabled: false,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isSurveyBarShowninPDP: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      showPricesForSodimacProducts: true,
      isActiveTabAssistentePersonal: false,
      isBestSellerEnabled: true,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      isSizeEquivalencyTableVisible: false,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isCMRAperturaUrlAddonsEnabled: true,
      isSisSodimacPdpEnabled: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: false,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      isComparativeTableSameSellerEnabled: false,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: false,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isRootCategoryGForFacetCategoriaDisabled: false,
      isSellerBusinessNameEnabled: true,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":false,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: false,
      isPhotoSlurpEnabled: false,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: false,
      isInternationalBuyVisiblePDP: true,
      isGoogleAdsBannerEnabled: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      identifyBuyAtStore: false,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: false,
      isOneClickButtonVisible: false,
      isPidAndPgidValidationDisabled: false,
      isShippingLabelsEnabledInPdp: false,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isNewSizeGroupService: false,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: false,
      isAddtionalSellerTextEnabled: true,
      isProductOrchestratorRecoEnabled: false,
      isCartQuantityLimitsEnabled: false,
      freeShippingOnZonesEnabled: true,
      isEventToggleVisible_SO_COM: false,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isSodimacFaviconTestActivated: false,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isEnabledSposoredVisitInPLP: true,
      isAIExperimentEnabled: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: false,
      isNormalPriceCrossedOut: true,
      isCustomPDPABTestFlagEnabled: false,
      isNewWarrantyOptionsEnabled: true,
      hasFreeShippingForInternationalProducts: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: true,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isReviewValidationWithOrder: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: true,
      isSizeChartDataVisible: true,
      is3PSellerSizeChartEnabled: false,
      isDemoUpVideoEnabled: false,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isEnabledSponsoredClickInPDP: true,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDebugAdsEnabled: false,
      showFacetsForCollectionRule: true,
      isDynamicFacetsEnabled: true,
      SHOW_SPONSORED_STRIP: true,
      addFeatureScriptsToLongDesc: true,
      allowLongDescScriptInjection: true,
      enableSponsoredInRecommendation: true,
      isEventToggleVisible_TO_COM: false,
      isKioskControlledSearchEnabled: false,
      popularBrandsStaticFacetsEnabled: false,
      IS_PROVIDER_EXPERIMENT_TURNED_ON: false,
      isSearchSpecialCharactersEnabled: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      isNewSearchOrchestratorEnabled: false,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isCustomBannerEnabled: true,
      isExpSellerFilterEnabled: true,
      isInstallmentWithoutInterestEnabled: true,
      popularBrandFacetsEnabled: true,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpconOU',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com/falabella-cl/myaccount/myLists',
      BASKET_PAGE_URI: 'https://www.falabella.com/falabella-cl/basket',
      WORKING_HOURS_SODIMAC: 'https://sodimac.falabella.com/sodimac-cl/page/tiendas-y-horarios-sodimac',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      WORKING_HOURS_TIENDA: 'https://tienda.falabella.com/falabella-cl/page/horarios-tienda-Falabella',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.cl/sodimac-cl/basket',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpsinOU',
      EXT_WARRANTY_LIGHTBOX_LINK: '/falabella-cl/page/garantia?staticPageId=11300003',
      SERVICES_CL_FALABELLA: 'https://www.falabella.com/falabella-cl/page/servicios-falabella',
      WORKING_HOURS_TOTTUS: 'https://tottus.falabella.com/tottus-cl/page/horario_tiendas',
      moreWarrantyBenefitsLink: 'https://www.falabella.com/falabella-cl/page/postventa-garantia-extendida',
    },
    facetLabels: {
      'f.shipping.hd_same_day_zones': '<p>Si compras hasta las&nbsp;<strong>16:00 horas</strong></p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>Hasta 04/05/2025</p>',
      'f.derived.variant.freeShipping': '',
      'f.derived.variant.activeEvent': '<p>Hasta el 04/05/2025</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>SOLO POR 72 HRS</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: false,
        labels: false,
        novios: {
          facets: false,
          labels: false,
        },
        default: {
          facets: false,
          labels: false,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1655991838659-03',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-03',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-16553991838659-0',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-16553991534231-0',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com/falabella-cl',
        sodimac: 'https://sodimac.falabella.com/sodimac-cl',
        tottus: 'https://tottus.falabella.com/tottus-cl',
        linio: 'https://linio.falabella.com/linio-cl',
        homecenter: 'https://homecenter.falabella.com/homecenter-cl',
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusion: 'dior',
      productTitleBrandRemovalExclusions: ['dior'],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      skipPositionCategories: [
        'cat20002',
        'cat850030',
        'cat14330023',
        'cat850036',
        'cat7330051',
        'cat1320008',
        'CATG34996',
        'cat850040',
        'cat1320010',
        'cat16580002',
        'cat13140017',
        'cat850034',
        'cat850042',
        'cat7350055',
        'cat850044',
        'cat11610008',
        'cat7350018',
        'cat7350012',
        'cat7350013',
        'cat7350017',
        'cat7350019',
        'cat18380042',
        'cat1320012',
        'cat7450073',
        'cat17980009',
        'cat7500027',
        'cat13620025',
        'cat7450062',
        'cat1640033',
        'cat5260002',
        'cat7450083',
        'cat7450088',
        'cat7450086',
        'cat7450065',
        'cat660024',
        'cat2083',
        'cat850068',
        'cat850064',
        'cat12440001',
        'cat690245',
        'cat13680004',
        'cat14730004',
        'cat6930168',
        'cat6930003',
        'CATG35031',
        'CATG12010',
        'cat7280122',
        'cat5620004',
        'cat12850003',
        'cat12850002',
        'cat12270016',
        'CATG34995',
        'cat7480104',
        'cat2017',
        'cat3207',
        'cat690235',
        'cat5880085',
        'cat3208',
        'cat6050003',
        'cat3143',
        'cat6050008',
        'cat590028',
        'cat570195',
        'cat6050011',
        'cat13990004',
        'CATG34994',
        'cat6930019',
        'cat12650001',
        'cat6930011',
        'cat6930180',
        'cat6930190',
        'cat6930014',
        'cat6930181',
        'cat6930018',
        'CATG19087',
        'cat6930191',
        'cat12650004',
        'cat12650002',
        'CATG33917',
        'cat190004',
        'cat7660148',
        'cat16400020',
        'cat16400012',
        'cat16400016',
        'cat16400014',
        'cat16400019',
        'cat16400015',
        'cat19280010',
        'cat16400013',
        'cat16400018',
        'cat17010032',
        'cat17010033',
        'cat19280007',
        'cat14370004',
        'cat17180020',
        'cat17180021',
        'cat7530038',
        'cat7530010',
        'cat15330001',
        'cat15330018',
        'cat15330005',
        'cat15330021',
        'cat15330022',
        'cat15330003',
        'cat15330006',
        'cat15330023',
        'cat15330011',
        'cat15330027',
        'cat15330009',
        'cat15330025',
        'cat15330030',
        'cat15330017',
        'cat15330019',
        'cat15330010',
        'cat15330026',
        'cat15330012',
        'cat15330029',
        'cat15330004',
        'cat15330020',
      ],
      SponsoredDisplayPosition: {
        positions: {},
      },
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b> app',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira desde 90 min',
          cc_next_day: 'Retira mañana',
          hd_express: 'Retira en 2 horas',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver este producto es gratis',
            intl: 'Devolver este producto es gratis',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Producto sin derecho a retracto',
            intl: 'Producto sin derecho a retracto',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      topSortExperimentConfig: {
        categories: [],
        searchTerms: [],
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      tipoFacetAttributeBannerConfig: {
        visible: true,
        androidVersion: '2.6.39',
        iosVersion: '2.6.38',
      },
      sellerExpCookies: {
        seller_exp_1: 'exp_1',
        seller_exp_2: 'exp_2',
        seller_exp_3: 'exp_3',
        seller_exp_4: 'exp_4',
      },
      whiteLabelSitesEnabled: ['fa_america', 'fa_aldo'],
    },
  },
  homecenter: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      BEIGE: '#cfb174',
      NEGRO: '#000000',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      COMBO_GTD_MANQUEHUE_LABEL: 'GTD Manquehue',
      HOME_DELI_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      ENVIO_GRATIS_LABEL_AMOUNT: '$59.990',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      SPONSORED_PRODUCT_SLOTS_APP: '[0, 14.28, 42.8, 71.2]',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL: 'https://fconnect.falabellatienda.com/web-bff/solicita/llamada',
      ADDING_TO_CART_1: 'Agregando',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      CURRENT_NUMBER_PLACEHOLDER: '9 8765 4321',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      VIEW_PLANES_LABEL_REBRANDING: 'Ver planes',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Juntos van mejor',
      CHIP: 'CHIP',
      COOKIES_PAIR_TO_REMOVE: 'bi_ab::oltr_enabled',
      REGIONS: 'Regiones',
      PDP_STARTS_FROM: 'A partir de: ',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo con plan desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '14:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      PDP_NO_THANKS: 'Sin garantía extendida',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Envío a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$, conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Tienes 30 días desde que lo recibes. ',
      SELLER_SKU_ID: 'Cód. tienda',
      NEW_BADGE: 'Nuevo',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      CONNECT_GO_BACK: 'Volver atrás',
      COMBO_WOM_LABEL: 'WOM',
      SEE_COMMENTS: 'Ver comentarios',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK_MKP: 'No Retiro en tienda',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE',
      MORE_PRODUCTS_FROM_COLLECTION: 'Juntos van mejor',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      SELECTION_TIENDA: 'Selecciona la talla para ver disponibillidad en tienda:',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona un punto de retiro',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Adquiere $xlp_name$ $facet_value$ de manera segura y fácil en falabella.com Conoce nuestro cátalogo online y haz la mejor elección.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Encuentra lo último de $facet_value$ en $xlp_name$. Elige el modelo perfecto para ti y realiza tus compras online de manera segura en falabella.com',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      ONLY_BUY_AT_STORE: 'Compra solo en tienda',
      MARKET_PLACE: 'Marketplace',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      COMBO_MOVIL_FALABELLA_LABEL: 'Movil Falabella',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      CONNECT_AGENT: 'EvalFalConnectj6S9B30n104f94g',
      PRODUCT_OUTOFSTOCK: '¡Qué mal! Justo se agotó',
      ERROR_SERVICE_TRY_AGAIN:
        '¡Intenta nuevamente! la conexión tardó más de lo esperado. Vuelve a intentar y revisa los planes que tenemos disponibles para ti.',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      CONNECT_ASSESSMENT_FORM_ERROR_CLIENT: 'ESTIMADO CLIENTE',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      OCULTAR_LABEL: 'Ocultar',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      CONNECT_CMR_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/cmr/consultaCmrInternet',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce los plazos y exclusiones',
      VENDOR_PRICE_LABEL: 'Precio',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      PDP_BI_AB_COOKIE: 'pdp_ab',
      CONNECT_OPERATOR_SERVICE_CALL:
        'https://fconnect.falabellatienda.com/api-txd/credito/consultaInformacionCreditoInternet',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      VOLVER_A_REVISAR: 'Volver a revisar',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Comuna',
      LOG_OUT_LABEL: 'Cerrar sesión',
      GOOGLE_ELEMENT_UNIQUE_ID: 'div-gpt-ad-3024305',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      HOW_WORKS_CONNECT: '¿Cómo funciona Falabella Connect?',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      NEED_RUT: 'Tenemos ofertas especiales. Solo necesitamos tu RUT para mostrártelas.',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      SLP_BI_AB_COOKIE: 'search_ab',
      READY: 'Aplicar',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos podrían agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Región',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      CONNECT_ERROR_MESSAGE_BUTTON: 'Aceptar',
      COMBO_OPERATOR_LABEL: 'Operador',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      CONNECT_IMPORTANT_THINGS:
        ' Esperamos ofrecerte los mejores planes y equipos, pero antes queremos recordarte dos cosas importantes:',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANES: 'PLANES',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      ERROR_COLOR_NOT_SELECTED: 'Seleccionar tu color para contratar el plan',
      sellerMuteValue: 'LINIO',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      COMBO_ENTEL_LABEL: 'Entel',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis app',
      FAILED_ADDING_TO_CART_LABEL: 'Este producto ya no está disponible.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      COMBO_VTR_LABEL: 'VTR',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      COMBO_PREPAGO_LABEL: 'Prepago',
      HOW_WORKS_CONNECT_TITLE: 'Términos y condiciones Falabella Connect',
      HOME_DELIVERY_SHIPPING: 'Despacho a domicilio.',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      SAME_DAY_FACET_MINUTES: 59,
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '19990',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      COMBO_MOVISTAR_LABEL: 'Movistar',
      ASSOCIATED_SELLER_INFO:
        'Este es un producto publicado directamente por un vendedor nacional o internacional y cuenta con el respaldo de Falabella. En algunos casos podría tener plazos de despacho diferentes a los habituales.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      CURRENT_NUMBER_PREFIX: '+56 ',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      REVIEW_CONTRACT: 'Revisa el mandato y contrato. Elige la modalidad de firma que más te acomode.',
      OUT_SERVICE:
        'En estos momentos no fue posible atender su solicitud. Por favor vuelve a intentar dentro de unos minutos.',
      CONNECT_IFRAME_WIDTH: 1080,
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      SELECT_PROMOTION_TEXT: 'Seleccionar Promoción',
      CONNECT_PLANS_CMR_ERROR_BLACK_LIST: 'No califica para comprar planes con falabella connect.',
      RETURN_POLICY_INFO_HARDLINE: 'Tienes 30 días desde que lo recibes. ',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      CONNECT_AUTENTIA_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/validaCliente/validaCi',
      isFastShippingTextEnabled: false,
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      CMR_MAPPING:
        'WwogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBDTVIiLAogICAgImRpdmlkZUZhY3RvciI6IDIwMCwKICAgICJsb2dvIjogImljb25zLmNtclRhcmpldGFJY29uIgogIH0sCiAgewogICAgInRpdGxlIjogIkNvbiBEw6liaXRvIEJhbmNvIEZhbGFiZWxsYSIsCiAgICAiZGl2aWRlRmFjdG9yIjogNTAwLAogICAgImxvZ28iOiAiY29ucy5iYW5jb0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIEN1ZW50YSBGcGF5IiwKICAgICJkaXZpZGVGYWN0b3IiOiA1MDAsCiAgICAibG9nbyI6ICJpY29ucy5mcGF5SWNvbiIKICB9LAogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBkZSBjcsOpZGl0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuY3JlZGl0b0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIHRhcmpldGEgZGUgZMOpYml0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuZGViaXRvSWNvbiIKICB9Cl0=',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      PICKUP_OR_DELIVERY:
        'Retira tu compra en cualquiera de nuestras tiendas. Si firmaste en línea, recibe tu Smartphone donde quieras y disfrútalo.',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      HIRE_YOUR_PLAN: 'Datos para contratar tu plan',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      CURRENT_NUMBER_LABEL: 'Número Actual',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$|^[0-9]{1,}[A-Z]?C$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción ',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      PICKUP_INSTORE_SO_TITLE: 'Retiro en tienda',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Puntos de retiro disponibles',
      CMSIZE: 'cm',
      BUY_CONNECT_ONLINE: '¡Ahorra tiempo! Compra un Smartphone y contrata un plan, todo en línea y de una sola vez.',
      OF: 'de',
      PICKUP_INSTORE_CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      CHECK_THE_OFFERS: '¡Revisa las ofertas!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com Conoce nuestro catálogo de $xlp_name$ y elige la opción perfecta para ti.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAN: 'Limpiar Filtro',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p> <p>Descubre un amplio catálogo de productos en Sodimac para %Category Name%. Encuentra todo lo que necesitas para renovar tu hogar. ¡Visítanos y encuentra inspiración para tus proyectos!</p> <p>Desde herramientas hasta accesorios, estamos aquí para ayudarte a hacer realidad tus ideas y renovar tus espacios, creando un ambiente único y personalizado. Explora nuestra selección de herramientas, materiales y accesorios de calidad que te ayudarán a crear un espacio más tú.</p> <p>Desde remodelaciones hasta proyectos de decoración, estamos aquí para hacer tus ideas realidad. ¡Visítanos y encuentra todo lo que tenemos para ofrecerte en %Category Name%!</p> <h2>Explora la variedad de productos de %Category Name% en Sodimac</h2> <p>Herramientas, materiales y accesorios de calidad para tus proyectos y renovación de espacios. ¡Visítanos y descubre todo lo que tenemos para ofrecerte!</p> <p>Encuentra una amplia variedad de productos de %Category Name% en Sodimac. Encuentra todo lo necesario para tus proyectos de renovación y decoración. ¡Visítanos y haz tus ideas realidad!</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Compra lo mejor de $xlp_name$ a un solo click. Encuentra esto y todo lo que necesitas en Falabella y Falabella.com!',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: ' Ábrela',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      CMR_DEFAULT_INSTALLMENTS: '10',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      SUMMARY_MODAL_NOTICE:
        'El valor del plan lo podrás pagar en el sitio web del operador o directamente en la tienda.',
      CONNECT_ERROR_MESSAGE:
        'Lo sentimos, se ha producido un error confirmando tu compra. Por favor, comunícate con nuestro Servicio al Cliente al 223907910 o escríbenos a contacto@falabella.cl',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $10.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $10.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      MORE_OPTIONS: 'Ver opciones',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      toggleViewButtonText: 'Visualizar por:',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      SKU_EQUIPMENT: 'SKU Equipo',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      BACK_ROOM: 'trastienda',
      EVALUATE_PLANS_BUTTON: 'REVISAR PLANES',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RECEIVE_AND_ENJOY: '¡Recibe y disfruta!',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devuelve gratis por Derecho a retracto o Satisfacción garantizada.',
      CONNECT_IFRAME_URL: 'https://txd-fconnect-prd.appspot.com/#/?data=',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      VIEW_PLAN_REBRANDING: 'Ver plan',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      NEXT_DAY_SHIPPING_MIN_MAX_HOURS: '19.5,4',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      ATC_ONLY_BUY_AT_STORE: 'Ver Producto',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      ERROR_SERVICE_NO_PLANS: 'Lo sentimos, no se han encontrado planes disponibles en esta evaluación',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      CONNECT_PLANS_CMR_INVALID: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      LOGIN_SIGN_UP: 'Regístrate',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_IMPORTANT_THING_3: 'Si quieres portar tú número a otra compañía tienes que ser el titular de la línea.',
      CONNECT_AUTENTIA_ERROR_MESSAGE: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'REVISAR PLANES',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CONNECT_IMPORTANT_THING_2:
        'Para contratar un plan necesitamos hacer una previa evaluación financiera. Por esto Promotora CMR Falabella S.A nos proporciona información necesaria para que podamos ofrecerte un plan adecuado y especial para ti. Si todavía no tienes tu CMR no dudes en sacarla.',
      CONNECT_IMPORTANT_THING_1: 'Para contratar tu plan tienes que tener tarjeta',
      CONNECT_ERROR_MESSAGE_BASKET:
        'Lo sentimos, no es posible añadir más productos a la Bolsa. Ya tienes agregado un producto de Falabella Connect. Este tipo de producto debe ser comprado de manera independiente, ya que tiene un despacho preferente.',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      CONTRACT_PLAN: 'CONTRATAR PLAN',
      UKSIZE: 'UK',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      SKU_PLAN: 'SKU Plan',
      PLANS_DETAILS_FREE_LABEL: 'LIBRES',
      PRODUCT_ORCHESTRATOR_FLOW: 'false',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      HIRE: 'CONTRATA TU',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores que tenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CONNECT_LEGAL_TEXT:
        'Los términos y condiciones regulan la evaluación comercial de los planes de telefonía móvil ofrecidos por los operadores de telefonía móvil en nuestro sitio web www.falabella.com, que puedes contratar en conjunto con los teléfonos celulares comercializados por Falabella Retail S.A. Puedes revisar el contenido de los términos y condiciones de la evaluación comercial aqui.\n\nPara realizar la evaluación comercial, es necesario que seas titular de una tarjeta CMR, y que ésta haya sido emitida, con al menos, 90 días de antigüedad a la fecha de solicitud de evaluación o contratación del plan de telefonía móvil. Adicionalmente, validaremos la vigencia y la exactitud de los datos de tu cédula de identidad que nos proporciones.\n\nLos productos deben ser comprados de manera independiente y separada de otros productos que puedas tener en tu carro de compras. Si tienes productos adicionales en tu carro de compra, no te preocupes, éstos quedarán guardados para una compra futura.\n\nEl plan de telefonía y el precio del equipo pueden ser pagados con cualquier medio de pago disponible en falabella.com. El descuento en el precio del equipo está sujeto a la contratación del plan de telefonía respectivo y a la firma de un mandato para el cobro en tu tarjeta de crédito CMR, de la diferencia entre el precio del equipo y el precio prepago de este, según corresponda, el cual aplicará si das de baja el plan suscrito o contratas uno más económico dentro de un periodo de 18 meses para cada operador.\n\nDebido a los requerimientos y procesos del operador telefónico, existe un plazo máximo de 15 días para que recibas tu producto.',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      TRACK_ORDER: 'Seguimiento de mi orden',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      BOOM_SHIPPING: 'Boom',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      PLAN: 'PLAN',
      HOME_DELI_SO_TITLE: 'Despacho a domicilio',
      PRODUCT_CODE: 'Código del producto',
      SAME_DAY_FACET_HOURS: '15',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 600 390 4100',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN: 'https://fconnect.falabellatienda.com/api-txd/getTokenEncrypt',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'Agregar los {count} al Carro',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      TYPE_C_HOME_DELI_OUTOFSTOCK_MKP: 'No disponible para envío a domicilio',
      PICKUP_INSTORE_TITLE: 'Retiro en un punto',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '15:30 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$xlp_name$ $facet_value$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      FILL_YOUR_DETAILS: 'Completa tus datos y firma',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      WARNING_A11Y_LABEL: 'Warning',
      ERROR_SERVICE_SAME_OPERATOR:
        'No puedes realizar compra de un plan de tu misma compañía. ¡Revisa la oferta con otros operadores!',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      COMBO_PLAN_PREPAGO_LABEL: 'Plan / Prepago',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'REVISA TUS PLANES',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      COMBO_CLARO_LABEL: 'Claro',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON: 'PROBAR CON OTRO RUT',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      GO_BACK_TO_PLANS: 'Volver a planes',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      COMBO_NETLINE_LABEL: 'Netline',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G200401,G200402,G200403,G200405,G200406,G200407,G20040804,G20040809,G20040813,G20040901,G20040906,G20040908,G20040914,G200410,G200411,G200412,G20041303,G20041213,G20041405,G20041406,G20041407,G20041410,G200415,G200416,G200417,G200418,G200419,G20042002,G20042006,G200421,G200422,G200423,G200424',
      CIUDAD_TEXT: 'Partido',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      CMR_POINTS: 'CMR Puntos',
      CMRAPERTURATEXT_REQUEST: '¿Aún no tienes tu CMR Banco Falabella?',
      HOME_SHIPPING: 'Envío a domicilio',
      COMBO_SIMPLE_LABEL: 'Simple',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      COLLECTIONS_TO_SHOW_PLANS: 'connect-products,prueba-connect,falabella-connect',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      CONNECT_IFRAME_HEIGHT: 713,
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      CMR_Falabella: 'CMR Falabella.',
      WHY: '¿Porqué?',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PUM_AFFIX: ' a ',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      ACCEPT: 'ACEPTAR',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      COMBO_PLAN_LABEL: 'Plan',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 600 3904100',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      CHOOSE_YOUR_PLAN: 'Elige tu equipo y plan',
      COLORS_AVAILABLE_SMALL: 'Colores Disponibles',
      PICKUP_INSTORE_NOT_AVAILABLE_IN: 'No disponible en ',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      COMBO_VIRGIN_LABEL: 'Virgin',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: 'Tienes 30 días desde que lo recibes. ',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      FREE_SHIPPING_PRICE: '59990',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      NEED_HELP_CALL_US_AT_PLAN: '¿Necesitas ayuda para contratar un plan? Llámanos al',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      ERROR_SERVICE_NO_CREDIT:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      OFFER_PRICE_WARRANTY_LABEL: '(Oferta)',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retiro desde 90 min',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SEARCH_TITLE: '$xlp_name$',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b> app,Llega <b>gratis</b> mañana,Retira desde 90 min,Retira mañana',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      darSectionLabel: 'Producto sin derecho a retracto',
      WARRANTY_LABEL_PREFIX: '',
      OVERRIDE_FACETS_COUNT: 'f.derived.variant.sellerId',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio mayorista',
      WHOLESALE_BANNER_BADGE_TEXT_2: '',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
    },
    toggles: {
      isSearchWithSoCom: false,
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPositionPerCategoryEnabled: true,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isNewSearchVisible: true,
      isGenericCalculatorEnabled: true,
      IsSearchExperienceCheckbox: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isOneClickCheckoutEnabled: false,
      isEventFilterEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      isInhouseBundleWidgetActive: false,
      PDP_AB_TEST_OVERRIDE_VALUE: '',
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isAbCookieEnabled: false,
      isRelatedKeywordEnabled: false,
      showRatingDescription: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: false,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: false,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      showListToggleButtons: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isShippingAttributesEnabled: false,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isSurveyBarShowninPDP: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      showPricesForSodimacProducts: true,
      isActiveTabAssistentePersonal: false,
      isBestSellerEnabled: true,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      isSizeEquivalencyTableVisible: false,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isCMRAperturaUrlAddonsEnabled: true,
      isSisSodimacPdpEnabled: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: false,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      isComparativeTableSameSellerEnabled: false,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: false,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isRootCategoryGForFacetCategoriaDisabled: false,
      isSellerBusinessNameEnabled: true,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":false,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: false,
      isPhotoSlurpEnabled: false,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: false,
      isInternationalBuyVisiblePDP: true,
      isGoogleAdsBannerEnabled: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      identifyBuyAtStore: false,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: false,
      isOneClickButtonVisible: false,
      isPidAndPgidValidationDisabled: false,
      isShippingLabelsEnabledInPdp: false,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isNewSizeGroupService: false,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: false,
      isAddtionalSellerTextEnabled: true,
      isProductOrchestratorRecoEnabled: false,
      isCartQuantityLimitsEnabled: false,
      freeShippingOnZonesEnabled: true,
      isEventToggleVisible_SO_COM: false,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isSodimacFaviconTestActivated: false,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isEnabledSposoredVisitInPLP: true,
      isAIExperimentEnabled: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: false,
      isNormalPriceCrossedOut: true,
      isCustomPDPABTestFlagEnabled: false,
      isNewWarrantyOptionsEnabled: true,
      hasFreeShippingForInternationalProducts: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: true,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isReviewValidationWithOrder: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: true,
      isSizeChartDataVisible: true,
      is3PSellerSizeChartEnabled: false,
      isDemoUpVideoEnabled: false,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isEnabledSponsoredClickInPDP: true,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDebugAdsEnabled: false,
      showFacetsForCollectionRule: true,
      isDynamicFacetsEnabled: true,
      SHOW_SPONSORED_STRIP: true,
      addFeatureScriptsToLongDesc: true,
      allowLongDescScriptInjection: true,
      enableSponsoredInRecommendation: true,
      isEventToggleVisible_TO_COM: false,
      isKioskControlledSearchEnabled: false,
      popularBrandsStaticFacetsEnabled: false,
      IS_PROVIDER_EXPERIMENT_TURNED_ON: false,
      isSearchSpecialCharactersEnabled: true,
      newFreeShippingEnabled: true,
      isNewOmniChannelExperience: true,
      isNewSearchOrchestratorEnabled: false,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isCustomBannerEnabled: true,
      isExpSellerFilterEnabled: true,
      isInstallmentWithoutInterestEnabled: true,
      popularBrandFacetsEnabled: true,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpconOU',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      CATALYST_AUTH_BASEURL: 'https://www.falabella.com',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com/falabella-cl/myaccount/myLists',
      BASKET_PAGE_URI: 'https://www.falabella.com/falabella-cl/basket',
      WORKING_HOURS_SODIMAC: 'https://sodimac.falabella.com/sodimac-cl/page/tiendas-y-horarios-sodimac',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      WORKING_HOURS_TIENDA: 'https://tienda.falabella.com/falabella-cl/page/horarios-tienda-Falabella',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.cl/sodimac-cl/basket',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpsinOU',
      EXT_WARRANTY_LIGHTBOX_LINK: '/falabella-cl/page/garantia?staticPageId=11300003',
      SERVICES_CL_FALABELLA: 'https://www.falabella.com/falabella-cl/page/servicios-falabella',
      WORKING_HOURS_TOTTUS: 'https://tottus.falabella.com/tottus-cl/page/horario_tiendas',
      moreWarrantyBenefitsLink: 'https://www.falabella.com/falabella-cl/page/postventa-garantia-extendida',
    },
    facetLabels: {
      'f.shipping.hd_same_day_zones': '<p>Si compras hasta las&nbsp;<strong>16:00 horas</strong></p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>Hasta 04/05/2025</p>',
      'f.derived.variant.freeShipping': '',
      'f.derived.variant.activeEvent': '<p>Hasta el 04/05/2025</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>SOLO POR 72 HRS</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: false,
        labels: false,
        novios: {
          facets: false,
          labels: false,
        },
        default: {
          facets: false,
          labels: false,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1655991838659-03',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-03',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-16553991838659-0',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-16553991534231-0',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com/falabella-cl',
        sodimac: 'https://sodimac.falabella.com/sodimac-cl',
        tottus: 'https://tottus.falabella.com/tottus-cl',
        linio: 'https://linio.falabella.com/linio-cl',
        homecenter: 'https://homecenter.falabella.com/homecenter-cl',
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusion: 'dior',
      productTitleBrandRemovalExclusions: ['dior'],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      skipPositionCategories: [
        'cat20002',
        'cat850030',
        'cat14330023',
        'cat850036',
        'cat7330051',
        'cat1320008',
        'CATG34996',
        'cat850040',
        'cat1320010',
        'cat16580002',
        'cat13140017',
        'cat850034',
        'cat850042',
        'cat7350055',
        'cat850044',
        'cat11610008',
        'cat7350018',
        'cat7350012',
        'cat7350013',
        'cat7350017',
        'cat7350019',
        'cat18380042',
        'cat1320012',
        'cat7450073',
        'cat17980009',
        'cat7500027',
        'cat13620025',
        'cat7450062',
        'cat1640033',
        'cat5260002',
        'cat7450083',
        'cat7450088',
        'cat7450086',
        'cat7450065',
        'cat660024',
        'cat2083',
        'cat850068',
        'cat850064',
        'cat12440001',
        'cat690245',
        'cat13680004',
        'cat14730004',
        'cat6930168',
        'cat6930003',
        'CATG35031',
        'CATG12010',
        'cat7280122',
        'cat5620004',
        'cat12850003',
        'cat12850002',
        'cat12270016',
        'CATG34995',
        'cat7480104',
        'cat2017',
        'cat3207',
        'cat690235',
        'cat5880085',
        'cat3208',
        'cat6050003',
        'cat3143',
        'cat6050008',
        'cat590028',
        'cat570195',
        'cat6050011',
        'cat13990004',
        'CATG34994',
        'cat6930019',
        'cat12650001',
        'cat6930011',
        'cat6930180',
        'cat6930190',
        'cat6930014',
        'cat6930181',
        'cat6930018',
        'CATG19087',
        'cat6930191',
        'cat12650004',
        'cat12650002',
        'CATG33917',
        'cat190004',
        'cat7660148',
        'cat16400020',
        'cat16400012',
        'cat16400016',
        'cat16400014',
        'cat16400019',
        'cat16400015',
        'cat19280010',
        'cat16400013',
        'cat16400018',
        'cat17010032',
        'cat17010033',
        'cat19280007',
        'cat14370004',
        'cat17180020',
        'cat17180021',
        'cat7530038',
        'cat7530010',
        'cat15330001',
        'cat15330018',
        'cat15330005',
        'cat15330021',
        'cat15330022',
        'cat15330003',
        'cat15330006',
        'cat15330023',
        'cat15330011',
        'cat15330027',
        'cat15330009',
        'cat15330025',
        'cat15330030',
        'cat15330017',
        'cat15330019',
        'cat15330010',
        'cat15330026',
        'cat15330012',
        'cat15330029',
        'cat15330004',
        'cat15330020',
      ],
      SponsoredDisplayPosition: {
        positions: {},
      },
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b> app',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira desde 90 min',
          cc_next_day: 'Retira mañana',
          hd_express: 'Retira en 2 horas',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver este producto es gratis',
            intl: 'Devolver este producto es gratis',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Producto sin derecho a retracto',
            intl: 'Producto sin derecho a retracto',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      topSortExperimentConfig: {
        categories: [],
        searchTerms: [],
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      tipoFacetAttributeBannerConfig: {
        visible: true,
        androidVersion: '2.6.39',
        iosVersion: '2.6.38',
      },
      sellerExpCookies: {
        seller_exp_1: 'exp_1',
        seller_exp_2: 'exp_2',
        seller_exp_3: 'exp_3',
        seller_exp_4: 'exp_4',
      },
      whiteLabelSitesEnabled: ['fa_america', 'fa_aldo'],
    },
  },
  so_com: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      BEIGE: '#cfb174',
      NEGRO: '#000000',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      COMBO_GTD_MANQUEHUE_LABEL: 'GTD Manquehue',
      HOME_DELI_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      ENVIO_GRATIS_LABEL_AMOUNT: '$59.990',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      SPONSORED_PRODUCT_SLOTS_APP: '[0, 14.28, 42.8, 71.2]',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL: 'https://fconnect.falabellatienda.com/web-bff/solicita/llamada',
      ADDING_TO_CART_1: 'Agregando',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      CURRENT_NUMBER_PLACEHOLDER: '9 8765 4321',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      VIEW_PLANES_LABEL_REBRANDING: 'Ver planes',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Juntos van mejor',
      CHIP: 'CHIP',
      COOKIES_PAIR_TO_REMOVE: 'bi_ab::oltr_enabled',
      REGIONS: 'Regiones',
      PDP_STARTS_FROM: 'A partir de: ',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo con plan desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '18:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      PDP_NO_THANKS: 'Sin garantía extendida',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Envío a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$, conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Tienes 30 días desde que lo recibes. ',
      SELLER_SKU_ID: 'Cód. tienda',
      NEW_BADGE: 'Nuevo',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      CONNECT_GO_BACK: 'Volver atrás',
      COMBO_WOM_LABEL: 'WOM',
      SEE_COMMENTS: 'Ver comentarios',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK_MKP: 'No Retiro en tienda',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE',
      MORE_PRODUCTS_FROM_COLLECTION: 'Juntos van mejor',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      SELECTION_TIENDA: 'Selecciona la talla para ver disponibillidad en tienda:',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona un punto de retiro',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Adquiere $xlp_name$ $facet_value$ de manera segura y fácil en falabella.com Conoce nuestro cátalogo online y haz la mejor elección.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Encuentra lo último de $facet_value$ en $xlp_name$. Elige el modelo perfecto para ti y realiza tus compras online de manera segura en falabella.com',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      ONLY_BUY_AT_STORE: 'Compra solo en tienda',
      MARKET_PLACE: 'Marketplace',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      COMBO_MOVIL_FALABELLA_LABEL: 'Movil Falabella',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      CONNECT_AGENT: 'EvalFalConnectj6S9B30n104f94g',
      PRODUCT_OUTOFSTOCK: '¡Qué mal! Justo se agotó',
      ERROR_SERVICE_TRY_AGAIN:
        '¡Intenta nuevamente! la conexión tardó más de lo esperado. Vuelve a intentar y revisa los planes que tenemos disponibles para ti.',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      CONNECT_ASSESSMENT_FORM_ERROR_CLIENT: 'ESTIMADO CLIENTE',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      OCULTAR_LABEL: 'Ocultar',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      CONNECT_CMR_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/cmr/consultaCmrInternet',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce los plazos y exclusiones',
      VENDOR_PRICE_LABEL: 'Precio',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      PDP_BI_AB_COOKIE: 'pdp_ab',
      CONNECT_OPERATOR_SERVICE_CALL:
        'https://fconnect.falabellatienda.com/api-txd/credito/consultaInformacionCreditoInternet',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      VOLVER_A_REVISAR: 'Volver a revisar',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Comuna',
      LOG_OUT_LABEL: 'Cerrar sesión',
      GOOGLE_ELEMENT_UNIQUE_ID: 'div-gpt-ad-3024305',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      HOW_WORKS_CONNECT: '¿Cómo funciona Falabella Connect?',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      NEED_RUT: 'Tenemos ofertas especiales. Solo necesitamos tu RUT para mostrártelas.',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      SLP_BI_AB_COOKIE: 'search_ab',
      READY: 'Aplicar',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos podrían agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Región',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      CONNECT_ERROR_MESSAGE_BUTTON: 'Aceptar',
      COMBO_OPERATOR_LABEL: 'Operador',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      CONNECT_IMPORTANT_THINGS:
        ' Esperamos ofrecerte los mejores planes y equipos, pero antes queremos recordarte dos cosas importantes:',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANES: 'PLANES',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      ERROR_COLOR_NOT_SELECTED: 'Seleccionar tu color para contratar el plan',
      sellerMuteValue: 'LINIO',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      COMBO_ENTEL_LABEL: 'Entel',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,',
      FAILED_ADDING_TO_CART_LABEL: 'Este producto ya no está disponible.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      COMBO_VTR_LABEL: 'VTR',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      COMBO_PREPAGO_LABEL: 'Prepago',
      HOW_WORKS_CONNECT_TITLE: 'Términos y condiciones Falabella Connect',
      HOME_DELIVERY_SHIPPING: 'Despacho a domicilio.',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      SAME_DAY_FACET_MINUTES: 59,
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '19990',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      COMBO_MOVISTAR_LABEL: 'Movistar',
      ASSOCIATED_SELLER_INFO:
        'Este es un producto publicado directamente por un vendedor nacional o internacional y cuenta con el respaldo de Falabella. En algunos casos podría tener plazos de despacho diferentes a los habituales.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      CURRENT_NUMBER_PREFIX: '+56 ',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      REVIEW_CONTRACT: 'Revisa el mandato y contrato. Elige la modalidad de firma que más te acomode.',
      OUT_SERVICE:
        'En estos momentos no fue posible atender su solicitud. Por favor vuelve a intentar dentro de unos minutos.',
      CONNECT_IFRAME_WIDTH: 1080,
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      SELECT_PROMOTION_TEXT: 'Seleccionar Promoción',
      CONNECT_PLANS_CMR_ERROR_BLACK_LIST: 'No califica para comprar planes con falabella connect.',
      RETURN_POLICY_INFO_HARDLINE: 'Tienes 30 días desde que lo recibes. ',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      CONNECT_AUTENTIA_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/validaCliente/validaCi',
      isFastShippingTextEnabled: false,
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      CMR_MAPPING:
        'WwogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBDTVIiLAogICAgImRpdmlkZUZhY3RvciI6IDIwMCwKICAgICJsb2dvIjogImljb25zLmNtclRhcmpldGFJY29uIgogIH0sCiAgewogICAgInRpdGxlIjogIkNvbiBEw6liaXRvIEJhbmNvIEZhbGFiZWxsYSIsCiAgICAiZGl2aWRlRmFjdG9yIjogNTAwLAogICAgImxvZ28iOiAiY29ucy5iYW5jb0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIEN1ZW50YSBGcGF5IiwKICAgICJkaXZpZGVGYWN0b3IiOiA1MDAsCiAgICAibG9nbyI6ICJpY29ucy5mcGF5SWNvbiIKICB9LAogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBkZSBjcsOpZGl0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuY3JlZGl0b0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIHRhcmpldGEgZGUgZMOpYml0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuZGViaXRvSWNvbiIKICB9Cl0=',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      PICKUP_OR_DELIVERY:
        'Retira tu compra en cualquiera de nuestras tiendas. Si firmaste en línea, recibe tu Smartphone donde quieras y disfrútalo.',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      HIRE_YOUR_PLAN: 'Datos para contratar tu plan',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      CURRENT_NUMBER_LABEL: 'Número Actual',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$|^[0-9]{1,}[A-Z]?C$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción ',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      PICKUP_INSTORE_SO_TITLE: 'Retiro en tienda',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Puntos de retiro disponibles',
      CMSIZE: 'cm',
      BUY_CONNECT_ONLINE: '¡Ahorra tiempo! Compra un Smartphone y contrata un plan, todo en línea y de una sola vez.',
      OF: 'de',
      PICKUP_INSTORE_CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      CHECK_THE_OFFERS: '¡Revisa las ofertas!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com Conoce nuestro catálogo de $xlp_name$ y elige la opción perfecta para ti.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAN: 'Limpiar Filtro',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT:
        '<p>%Category Name%</p> <p>Descubre un amplio catálogo de productos en Sodimac para %Category Name%. Encuentra todo lo que necesitas para renovar tu hogar. ¡Visítanos y encuentra inspiración para tus proyectos!</p> <p>Desde herramientas hasta accesorios, estamos aquí para ayudarte a hacer realidad tus ideas y renovar tus espacios, creando un ambiente único y personalizado. Explora nuestra selección de herramientas, materiales y accesorios de calidad que te ayudarán a crear un espacio más tú.</p> <p>Desde remodelaciones hasta proyectos de decoración, estamos aquí para hacer tus ideas realidad. ¡Visítanos y encuentra todo lo que tenemos para ofrecerte en %Category Name%!</p> <h2>Explora la variedad de productos de %Category Name% en Sodimac</h2> <p>Herramientas, materiales y accesorios de calidad para tus proyectos y renovación de espacios. ¡Visítanos y descubre todo lo que tenemos para ofrecerte!</p> <p>Encuentra una amplia variedad de productos de %Category Name% en Sodimac. Encuentra todo lo necesario para tus proyectos de renovación y decoración. ¡Visítanos y haz tus ideas realidad!</p>',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Compra lo mejor de $xlp_name$ a un solo click. Encuentra esto y todo lo que necesitas en Falabella y Falabella.com!',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: ' Ábrela',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      CMR_DEFAULT_INSTALLMENTS: '10',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      SUMMARY_MODAL_NOTICE:
        'El valor del plan lo podrás pagar en el sitio web del operador o directamente en la tienda.',
      CONNECT_ERROR_MESSAGE:
        'Lo sentimos, se ha producido un error confirmando tu compra. Por favor, comunícate con nuestro Servicio al Cliente al 223907910 o escríbenos a contacto@falabella.cl',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $10.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $10.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      MORE_OPTIONS: 'Ver opciones',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      toggleViewButtonText: 'Visualizar por:',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      SKU_EQUIPMENT: 'SKU Equipo',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      BACK_ROOM: 'trastienda',
      EVALUATE_PLANS_BUTTON: 'REVISAR PLANES',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RECEIVE_AND_ENJOY: '¡Recibe y disfruta!',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devuelve gratis por Derecho a retracto o Satisfacción garantizada.',
      CONNECT_IFRAME_URL: 'https://txd-fconnect-prd.appspot.com/#/?data=',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Información adicional',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      VIEW_PLAN_REBRANDING: 'Ver plan',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      NEXT_DAY_SHIPPING_MIN_MAX_HOURS: '19.5,4',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      ATC_ONLY_BUY_AT_STORE: 'Ver Producto',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      ERROR_SERVICE_NO_PLANS: 'Lo sentimos, no se han encontrado planes disponibles en esta evaluación',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      CONNECT_PLANS_CMR_INVALID: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      LOGIN_SIGN_UP: 'Regístrate',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_IMPORTANT_THING_3: 'Si quieres portar tú número a otra compañía tienes que ser el titular de la línea.',
      CONNECT_AUTENTIA_ERROR_MESSAGE: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'REVISAR PLANES',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CONNECT_IMPORTANT_THING_2:
        'Para contratar un plan necesitamos hacer una previa evaluación financiera. Por esto Promotora CMR Falabella S.A nos proporciona información necesaria para que podamos ofrecerte un plan adecuado y especial para ti. Si todavía no tienes tu CMR no dudes en sacarla.',
      CONNECT_IMPORTANT_THING_1: 'Para contratar tu plan tienes que tener tarjeta',
      CONNECT_ERROR_MESSAGE_BASKET:
        'Lo sentimos, no es posible añadir más productos a la Bolsa. Ya tienes agregado un producto de Falabella Connect. Este tipo de producto debe ser comprado de manera independiente, ya que tiene un despacho preferente.',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      CONTRACT_PLAN: 'CONTRATAR PLAN',
      UKSIZE: 'UK',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      SKU_PLAN: 'SKU Plan',
      PLANS_DETAILS_FREE_LABEL: 'LIBRES',
      PRODUCT_ORCHESTRATOR_FLOW: 'false',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      HIRE: 'CONTRATA TU',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores que tenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CONNECT_LEGAL_TEXT:
        'Los términos y condiciones regulan la evaluación comercial de los planes de telefonía móvil ofrecidos por los operadores de telefonía móvil en nuestro sitio web www.falabella.com, que puedes contratar en conjunto con los teléfonos celulares comercializados por Falabella Retail S.A. Puedes revisar el contenido de los términos y condiciones de la evaluación comercial aqui.\n\nPara realizar la evaluación comercial, es necesario que seas titular de una tarjeta CMR, y que ésta haya sido emitida, con al menos, 90 días de antigüedad a la fecha de solicitud de evaluación o contratación del plan de telefonía móvil. Adicionalmente, validaremos la vigencia y la exactitud de los datos de tu cédula de identidad que nos proporciones.\n\nLos productos deben ser comprados de manera independiente y separada de otros productos que puedas tener en tu carro de compras. Si tienes productos adicionales en tu carro de compra, no te preocupes, éstos quedarán guardados para una compra futura.\n\nEl plan de telefonía y el precio del equipo pueden ser pagados con cualquier medio de pago disponible en falabella.com. El descuento en el precio del equipo está sujeto a la contratación del plan de telefonía respectivo y a la firma de un mandato para el cobro en tu tarjeta de crédito CMR, de la diferencia entre el precio del equipo y el precio prepago de este, según corresponda, el cual aplicará si das de baja el plan suscrito o contratas uno más económico dentro de un periodo de 18 meses para cada operador.\n\nDebido a los requerimientos y procesos del operador telefónico, existe un plazo máximo de 15 días para que recibas tu producto.',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      TRACK_ORDER: 'Seguimiento de mi orden',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      BOOM_SHIPPING: 'Boom',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      PLAN: 'PLAN',
      HOME_DELI_SO_TITLE: 'Despacho a domicilio',
      PRODUCT_CODE: 'Código del producto',
      SAME_DAY_FACET_HOURS: '15',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 600 390 4100',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN: 'https://fconnect.falabellatienda.com/api-txd/getTokenEncrypt',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'Agregar los {count} al Carro',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      TYPE_C_HOME_DELI_OUTOFSTOCK_MKP: 'No disponible para envío a domicilio',
      PICKUP_INSTORE_TITLE: 'Retiro en un punto',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '15:30 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$xlp_name$ $facet_value$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      FILL_YOUR_DETAILS: 'Completa tus datos y firma',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      WARNING_A11Y_LABEL: 'Warning',
      ERROR_SERVICE_SAME_OPERATOR:
        'No puedes realizar compra de un plan de tu misma compañía. ¡Revisa la oferta con otros operadores!',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      COMBO_PLAN_PREPAGO_LABEL: 'Plan / Prepago',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'REVISA TUS PLANES',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      COMBO_CLARO_LABEL: 'Claro',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON: 'PROBAR CON OTRO RUT',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      GO_BACK_TO_PLANS: 'Volver a planes',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      COMBO_NETLINE_LABEL: 'Netline',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G200401,G200402,G200403,G200405,G200406,G200407,G20040804,G20040809,G20040813,G20040901,G20040906,G20040908,G20040914,G200410,G200411,G200412,G20041303,G20041213,G20041405,G20041406,G20041407,G20041410,G200415,G200416,G200417,G200418,G200419,G20042002,G20042006,G200421,G200422,G200423,G200424',
      CIUDAD_TEXT: 'Partido',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      CMR_POINTS: 'CMR Puntos',
      CMRAPERTURATEXT_REQUEST: '¿Aún no tienes tu CMR Banco Falabella?',
      HOME_SHIPPING: 'Envío a domicilio',
      COMBO_SIMPLE_LABEL: 'Simple',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      COLLECTIONS_TO_SHOW_PLANS: 'connect-products,prueba-connect,falabella-connect',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      CONNECT_IFRAME_HEIGHT: 713,
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      CMR_Falabella: 'CMR Falabella.',
      WHY: '¿Porqué?',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PUM_AFFIX: ' a ',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      ACCEPT: 'ACEPTAR',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      COMBO_PLAN_LABEL: 'Plan',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 600 3904100',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      CHOOSE_YOUR_PLAN: 'Elige tu equipo y plan',
      COLORS_AVAILABLE_SMALL: 'Colores Disponibles',
      PICKUP_INSTORE_NOT_AVAILABLE_IN: 'No disponible en ',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      COMBO_VIRGIN_LABEL: 'Virgin',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: 'Tienes 30 días desde que lo recibes. ',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      FREE_SHIPPING_PRICE: '59990',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      NEED_HELP_CALL_US_AT_PLAN: '¿Necesitas ayuda para contratar un plan? Llámanos al',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      ERROR_SERVICE_NO_CREDIT:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      OFFER_PRICE_WARRANTY_LABEL: '(Oferta)',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retiro desde 90 min',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Encuentra todo lo que buscas en $xlp_name$. Visita Sodimac - Homecenter y aprovecha nuestras increíbles ofertas.',
      FALLBACK_SEO_SEARCH_TITLE: '$xlp_name$',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,,,Llega <b>gratis</b> mañana,Retira desde 90 min,Retira mañana,Llega en 2 h',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Encuentra todo lo que buscas en $xlp_name$. Visita Sodimac - Homecenter y aprovecha nuestras increíbles ofertas',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      darSectionLabel: 'Producto sin derecho a retracto',
      WARRANTY_LABEL_PREFIX: '',
      OVERRIDE_FACETS_COUNT: 'f.derived.variant.sellerId',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1,,PDP-BT-1',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio mayorista',
      WHOLESALE_BANNER_BADGE_TEXT_2: '',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      DRIVER_BADGE_LABEL: 'Estás viendo',
      PDP_SLOTS_SOCOM: 'PDP-CMP-1',
    },
    toggles: {
      isSearchWithSoCom: false,
      isSellerInfoVisibleInPDP: true,
      isHomeDeliveryVisibleInPod: false,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPositionPerCategoryEnabled: true,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: true,
      isRedirect301EnabledForPLP: true,
      isNewSearchVisible: true,
      isGenericCalculatorEnabled: true,
      IsSearchExperienceCheckbox: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isOneClickCheckoutEnabled: false,
      isEventFilterEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: false,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      isInhouseBundleWidgetActive: false,
      PDP_AB_TEST_OVERRIDE_VALUE: '',
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isAbCookieEnabled: false,
      isRelatedKeywordEnabled: false,
      showRatingDescription: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: false,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: false,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      showListToggleButtons: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isShippingAttributesEnabled: false,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isSurveyBarShowninPDP: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      showPricesForSodimacProducts: true,
      isActiveTabAssistentePersonal: false,
      isBestSellerEnabled: true,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      isSizeEquivalencyTableVisible: false,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isCMRAperturaUrlAddonsEnabled: true,
      isSisSodimacPdpEnabled: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: false,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      isComparativeTableSameSellerEnabled: false,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: false,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isRootCategoryGForFacetCategoriaDisabled: false,
      isSellerBusinessNameEnabled: true,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":false,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: false,
      isPhotoSlurpEnabled: false,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: false,
      isInternationalBuyVisiblePDP: true,
      isGoogleAdsBannerEnabled: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      identifyBuyAtStore: false,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: false,
      isOneClickButtonVisible: false,
      isPidAndPgidValidationDisabled: false,
      isShippingLabelsEnabledInPdp: false,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isNewSizeGroupService: false,
      isCMRAperturaEnabled: true,
      showCustomPlaceHolderForPriceRange: true,
      isSellerPopupEnabled: true,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: false,
      isAddtionalSellerTextEnabled: true,
      isProductOrchestratorRecoEnabled: false,
      isCartQuantityLimitsEnabled: false,
      freeShippingOnZonesEnabled: true,
      isEventToggleVisible_SO_COM: false,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isSodimacFaviconTestActivated: false,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isEnabledSposoredVisitInPLP: true,
      isAIExperimentEnabled: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: true,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: false,
      isNormalPriceCrossedOut: true,
      isCustomPDPABTestFlagEnabled: false,
      isNewWarrantyOptionsEnabled: true,
      hasFreeShippingForInternationalProducts: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: true,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isReviewValidationWithOrder: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: false,
      isSizeChartDataVisible: true,
      is3PSellerSizeChartEnabled: false,
      isDemoUpVideoEnabled: false,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isEnabledSponsoredClickInPDP: true,
      isImageGalleryEnabled: true,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: true,
      isDebugAdsEnabled: false,
      showFacetsForCollectionRule: true,
      isDynamicFacetsEnabled: true,
      SHOW_SPONSORED_STRIP: false,
      addFeatureScriptsToLongDesc: true,
      allowLongDescScriptInjection: true,
      enableSponsoredInRecommendation: true,
      isEventToggleVisible_TO_COM: false,
      isKioskControlledSearchEnabled: true,
      popularBrandsStaticFacetsEnabled: false,
      IS_PROVIDER_EXPERIMENT_TURNED_ON: false,
      isSearchSpecialCharactersEnabled: true,
      newFreeShippingEnabled: false,
      isNewOmniChannelExperience: true,
      isNewSearchOrchestratorEnabled: false,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: true,
      NEW_PROMOTION_CALL: false,
      isCustomBannerEnabled: true,
      isExpSellerFilterEnabled: true,
      isInstallmentWithoutInterestEnabled: true,
      popularBrandFacetsEnabled: true,
      hideOtherStoreFacets: true,
      SHOW_SKELETON: true,
      isBuyTogetherEnabled: true,
      isShopTheProjectEnabled: true,
      showDriverInComparativeTable: true,
      showComparativeTable: true,
      showRecommendedProducts: false,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpconOU',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      CATALYST_AUTH_BASEURL: 'https://www.sodimac.cl',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com/falabella-cl/myaccount/myLists',
      BASKET_PAGE_URI: 'https://www.falabella.com/falabella-cl/basket',
      WORKING_HOURS_SODIMAC: 'https://sodimac.falabella.com/sodimac-cl/page/tiendas-y-horarios-sodimac',
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      WORKING_HOURS_TIENDA: 'https://tienda.falabella.com/falabella-cl/page/horarios-tienda-Falabella',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.cl/sodimac-cl/basket',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpsinOU',
      EXT_WARRANTY_LIGHTBOX_LINK: '/falabella-cl/page/garantia?staticPageId=11300003',
      SERVICES_CL_FALABELLA: 'https://www.falabella.com/falabella-cl/page/servicios-falabella',
      WORKING_HOURS_TOTTUS: 'https://tottus.falabella.com/tottus-cl/page/horario_tiendas',
      moreWarrantyBenefitsLink: 'https://www.sodimac.cl/sodimac-cl/content/postventa-garantia-extendida',
    },
    facetLabels: {
      'f.shipping.hd_same_day_zones': '<p>Si compras hasta las&nbsp;<strong>16:00 horas</strong></p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>Hasta 04/05/2025</p>',
      'f.derived.variant.freeShipping': '',
      'f.derived.variant.activeEvent': '<p>Hasta el 04/05/2025</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>SOLO POR 72 HRS</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: false,
        labels: false,
        novios: {
          facets: false,
          labels: false,
        },
        default: {
          facets: false,
          labels: false,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1655991838659-03',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-03',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-16553991838659-0',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-16553991534231-0',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      sellerRedirectionMap: {
        falabella: 'https://www.falabella.com/falabella-cl',
        sodimac: 'https://sodimac.falabella.com/sodimac-cl',
        tottus: 'https://www.falabella.com/falabella-cl/seller/TOTTUS',
        linio: 'https://linio.falabella.com/linio-cl',
        homecenter: 'https://homecenter.falabella.com/homecenter-cl',
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: true,
        details: true,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusion: 'dior',
      productTitleBrandRemovalExclusions: ['dior'],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022: 'Superaste la cantidad máxima de unidades permitida… Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Has superado la cantidad máxima de unidades permi… Por favor, ajusta la cantidad antes de proceder.',
      },
      facetsWithLink: [
        'product.attribute.Aro',
        'product.attribute.Número_de_quemadores',
        'product.attribute.Cantidad_de_puertas',
        'product.attribute.Número_de_puestos',
        'product.attribute.Procesador',
        'product.attribute.Memoria_RAM',
        'product.attribute.Capacidad_de_lavado',
        'product.attribute.Tamaño_de_la_pantalla',
        'product.attribute.Resolución_de_pantalla',
        'product.attribute.Tamaño_del_respaldo',
        'product.attribute.Material_del_tapiz',
        'product.attribute.Tipo',
        'product.brandName',
        'product.attribute.Material_de_la_estructura',
      ],
      skipPositionCategories: [
        'cat20002',
        'cat850030',
        'cat14330023',
        'cat850036',
        'cat7330051',
        'cat1320008',
        'CATG34996',
        'cat850040',
        'cat1320010',
        'cat16580002',
        'cat13140017',
        'cat850034',
        'cat850042',
        'cat7350055',
        'cat850044',
        'cat11610008',
        'cat7350018',
        'cat7350012',
        'cat7350013',
        'cat7350017',
        'cat7350019',
        'cat18380042',
        'cat1320012',
        'cat7450073',
        'cat17980009',
        'cat7500027',
        'cat13620025',
        'cat7450062',
        'cat1640033',
        'cat5260002',
        'cat7450083',
        'cat7450088',
        'cat7450086',
        'cat7450065',
        'cat660024',
        'cat2083',
        'cat850068',
        'cat850064',
        'cat12440001',
        'cat690245',
        'cat13680004',
        'cat14730004',
        'cat6930168',
        'cat6930003',
        'CATG35031',
        'CATG12010',
        'cat7280122',
        'cat5620004',
        'cat12850003',
        'cat12850002',
        'cat12270016',
        'CATG34995',
        'cat7480104',
        'cat2017',
        'cat3207',
        'cat690235',
        'cat5880085',
        'cat3208',
        'cat6050003',
        'cat3143',
        'cat6050008',
        'cat590028',
        'cat570195',
        'cat6050011',
        'cat13990004',
        'CATG34994',
        'cat6930019',
        'cat12650001',
        'cat6930011',
        'cat6930180',
        'cat6930190',
        'cat6930014',
        'cat6930181',
        'cat6930018',
        'CATG19087',
        'cat6930191',
        'cat12650004',
        'cat12650002',
        'CATG33917',
        'cat190004',
        'cat7660148',
        'cat16400020',
        'cat16400012',
        'cat16400016',
        'cat16400014',
        'cat16400019',
        'cat16400015',
        'cat19280010',
        'cat16400013',
        'cat16400018',
        'cat17010032',
        'cat17010033',
        'cat19280007',
        'cat14370004',
        'cat17180020',
        'cat17180021',
        'cat7530038',
        'cat7530010',
        'cat15330001',
        'cat15330018',
        'cat15330005',
        'cat15330021',
        'cat15330022',
        'cat15330003',
        'cat15330006',
        'cat15330023',
        'cat15330011',
        'cat15330027',
        'cat15330009',
        'cat15330025',
        'cat15330030',
        'cat15330017',
        'cat15330019',
        'cat15330010',
        'cat15330026',
        'cat15330012',
        'cat15330029',
        'cat15330004',
        'cat15330020',
      ],
      SponsoredDisplayPosition: {
        positions: {},
      },
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega mañana',
          free_shipping_app: '',
          free_shipping_web: '',
          promo_free_shipping: '',
          cc_same_day: 'Retira desde 90 min',
          cc_next_day: 'Retira mañana',
          hd_express: 'Llega en <b>2 horas</b>',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver este producto es gratis',
            intl: 'Devolver este producto es gratis',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Producto sin derecho a retracto',
            intl: 'Producto sin derecho a retracto',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      topSortExperimentConfig: {
        categories: [],
        searchTerms: [],
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      tipoFacetAttributeBannerConfig: {
        visible: true,
        androidVersion: '2.6.39',
        iosVersion: '2.6.38',
      },
      sellerExpCookies: {
        seller_exp_1: 'exp_1',
        seller_exp_2: 'exp_2',
        seller_exp_3: 'exp_3',
        seller_exp_4: 'exp_4',
      },
      whiteLabelSitesEnabled: ['fa_america', 'fa_aldo'],
      CES_SEGMENT: {
        so_socl_plata: 'CES_PLATA',
        so_socl_oro: 'CES_ORO',
        so_socl_black: 'CES_BLACK',
      },
      TIME_OUT_SKELETON: 1000,
      allowedStoreFacetOperators: ['sodimac', 'homecenter'],
      driverBadgeConfig: {
        type: 'DRIVER_BADGE',
        backgroundColor: '#717171',
        textColor: '#ffffff',
      },
    },
  },
  to_com: {
    colorGroupMapping: {
      NARANJO: '#fc930a',
      ROJO: '#ba2d1e',
      'AZUL CLARO': '#94bfdc',
      CELESTE: '#94bfdc',
      BEIGE: '#cfb174',
      NEGRO: '#000000',
      BLANCO: '#ffffff',
      AZUL: '#0b108c',
      GRIS: '#dddddd',
      FUCSIA: '#d90073',
      MORADO: '#6d165a',
      VERDE: '#519548',
      ROSADO: '#fcd9e5',
      CREMA: '#fff8d4',
      BURDEO: '#5f021f',
      CAFÉ: '#8e5b3e',
      AMARILLO: '#fdec6f',
    },
    textDictionary: {
      COMBO_GTD_MANQUEHUE_LABEL: 'GTD Manquehue',
      HOME_DELI_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRAPERTURATEXT_SAVE: 'AHORRA',
      ENVIO_GRATIS_LABEL_AMOUNT: '$59.990',
      CMRAPERTURATEXT_OPEN_YOUR_CMR: '¿Aún no tienes tu tarjeta CMR?',
      SPONSORED_PRODUCT_SLOTS_APP: '[0, 14.28, 42.8, 71.2]',
      PRODUCT_WITHOUT_RESULT_TITLE: 'El producto que estás buscando ya no está disponible.',
      PRICE_RANGE_FILTER_BUTTON: 'Filtrar',
      CMR_INSTALLMENT_ERROR_MESSAGE: 'Error al cargar. Intenta nuevamente.',
      VENDOR_LOADING_LABEL: 'Buscando..',
      SIZE_CHART_NAME: 'TABLA DE TALLAS',
      CHAT_BOT: 'ChatBot',
      BUNDLED_PRODUCT_TOTAL_PRICE_LABEL: 'Llévalos por',
      VENDOR_SCAN_LABEL: 'Scan',
      SIZE: 'TALLA',
      VIEW_RESULTS_FACET_MODAL: 'Ver resultados',
      PICKUP_INSTORE_AVAILABLEFROM: 'Disponible a partir',
      CATEGORIES: 'Categorías',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_REQUEST_CALL: 'https://fconnect.falabellatienda.com/web-bff/solicita/llamada',
      ADDING_TO_CART_1: 'Agregando',
      VENDOR_CLIENT_LABEL: 'Cliente',
      SELECT_VARIANT_CHOOSE_OPTIONS: 'ELIGE TUS OPCIONES',
      VENDER_CANCEL_BUTTON_LABEL: 'CANCELAR',
      CURRENT_NUMBER_PLACEHOLDER: '9 8765 4321',
      SEARCH_WITHOUT_RESULT_DESCRIPTION:
        'Tal vez su búsqueda fue demasiado específica, intente buscar con un término más general.',
      CONNECT_ASSESSMENT_FORM_TERMS: 'Términos y condiciones',
      PAGE_TITLE: 'Falabella.com - Mejor Compra Online',
      VIEW_PLANES_LABEL_REBRANDING: 'Ver planes',
      DESPACHO: 'Despacho',
      SEE_MORE_FACET_VALUES: '+ Ver más',
      CONTRACT_PLAN_REBRANDING: 'Contratar plan',
      ACCUMULATE: 'Acumula hasta',
      LOCATION_DIALOG_HEADER: 'Cambia tu región',
      CONNECT_CLICK_TO_GET_CALLED_UNAVAILABLE_TIME:
        'Nuestros ejecutivos no están disponibles en este momento. Te contactaremos próximamente para que puedas escoger el mejor plan para ti.',
      COLORS_AVAILABLE: 'COLORES DISPONIBLES',
      ADD_TO_BAG: 'Agregar al Carro',
      PREVIOUS: 'Anterior',
      SUBSCRIPTION_EMPTY_ERROR: 'Por favor ingresa un mail',
      A2C_EXT_WARRANTY: 'Ver beneficios',
      SUBSCRIPTION_ACCEPT_TERMS: 'Debes aceptar los terminos y condiciones',
      BUNDLED_PRODUCT_LABEL: 'Juntos van mejor',
      CHIP: 'CHIP',
      COOKIES_PAIR_TO_REMOVE: 'bi_ab::oltr_enabled',
      REGIONS: 'Regiones',
      PDP_STARTS_FROM: 'A partir de: ',
      LOGIN_PASSWORD_PLACEHOLDER: 'Ingresa tu contraseña',
      TEAM_FROM_LABEL: 'Equipo con plan desde',
      CLEAR_FILTERS: 'Quitar filtros',
      WITHDRAW_AT_STORE_LABEL_AMOUNT: '14:00 horas',
      FALLBACK_SEO_COLLECTION_TITLE: '$xlp_name$',
      EMPTY_SEARCH_ERROR_TITLE: 'Busqueda Vacia',
      PDP_NO_THANKS: 'Sin garantía extendida',
      STORE_PICKUP_SAVE: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_TITLE_BRAND: '$xlp_name$ $facet_value$',
      MONTHLY_PLAN_LABEL: 'Plan mensual desde',
      AVAILABILITY: 'Disponibilidad',
      HOME_DELI_TITLE: 'Envío a domicilio',
      CANCEL: 'Cancelar',
      EMPTY_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      ADD_TO_CART_ERROR:
        'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      RETURN_POLICY_MOBILE_HEADER: 'Politica de cambios y devoluciones',
      CONNECT_ASSESSMENT_FORM_OPTION_NEW_NUMBER: 'Número nuevo',
      PRICE_RANGE_TO: 'Hasta',
      PRODUCT_ADDED: 'Producto(s) agregado',
      XLP_VIEW_PRODUCT_MOBILE: 'Ver más',
      CHOOSE_LOCATION: 'Selecciona tu región',
      HOME_DELI_SEE_MORE_OPTIONS: 'Ver más opciones',
      HOME_DELI_OUTOFSTOCK: 'No disponible para envío',
      CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      VENDOR_STORE_LABEL: 'Tienda',
      CONNECT_PLANS_LABEL: 'Planes',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NAME: 'JUANA RÍOS',
      COLOR: 'Color',
      FALLBACK_SEO_BRAND_DESCRIPTION:
        'Compra online artículos y productos de $xlp_name$, conoce las diferentes opciones que tenemos para ti en tus marcas favoritas.',
      A2C_ERROR_AL013: 'No se pudo agregar el ID de producto',
      CMR_CALCULATOR_ERROR_LOADING_TRY_AGAIN: 'Error al cargar. Intenta nuevamente.',
      RETURN_POLICY_INFO_SOFTLINE: 'Tienes 30 días desde que lo recibes. ',
      SELLER_SKU_ID: 'Cód. tienda',
      NEW_BADGE: 'Nuevo',
      ADD_TO_CART: 'Ver producto',
      LOADER_MESSAGE: 'Estamos procesando tu solicitud. Por favor espera un momento',
      CONNECT_GO_BACK: 'Volver atrás',
      COMBO_WOM_LABEL: 'WOM',
      SEE_COMMENTS: 'Ver comentarios',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK_MKP: 'No Retiro en tienda',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_TEXT: 'NÚMERO DE SERIE',
      MORE_PRODUCTS_FROM_COLLECTION: 'Juntos van mejor',
      SELECTED_FILTERS: 'Filtro seleccionado',
      A2C_ERROR_REMOVE_ITEM: 'Error al eliminar el artículo del carrito',
      SELECTION_TIENDA: 'Selecciona la talla para ver disponibillidad en tienda:',
      PICKUP_INSTORE_PLEASE_SELECT: 'Selecciona un punto de retiro',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_BRAND:
        'Adquiere $xlp_name$ $facet_value$ de manera segura y fácil en tottus.cl Conoce nuestro cátalogo online y haz la mejor elección.',
      CLOSE_A11Y_LABEL: 'Close',
      VENDOR_INVALID_CODE_LABEL: 'Lo sentimos, no hemos podido encontrar el producto escaneado.',
      LOGIN_LOG_IN: 'Iniciar sesión',
      TYPE_C_HOME_DELI_OUTOFSTOCK: 'No disponible para despacho a domicilio',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_TYPE:
        'Encuentra lo último de $facet_value$ en $xlp_name$. Elige el modelo perfecto para ti y realiza tus compras online de manera segura en tottus.cl',
      PLANS_CARD_SUBTITLE:
        'Ingresa tus datos y descubre las mejores ofertas para ti. (Necesitas tu cédula de identidad)',
      MY_ACCOUNT_LABEL: 'Mi Cuenta',
      SELECTED_FILTERS_MOBILE: 'Filtros:',
      SEE_MORE: 'ver más',
      AVAILABILITY_DOWNLOADABLE: 'Descargable',
      ONLY_BUY_AT_STORE: 'Compra solo en tienda',
      MARKET_PLACE: 'Marketplace',
      PICKUP_INSTORE_SUB_PREFIX: 'En',
      COMBO_MOVIL_FALABELLA_LABEL: 'Movil Falabella',
      CONNECT_ASSESSMENT_FORM_TITLE: 'Datos para la evaluación',
      CONNECT_AGENT: 'EvalFalConnectj6S9B30n104f94g',
      PRODUCT_OUTOFSTOCK: '¡Qué mal! Justo se agotó',
      ERROR_SERVICE_TRY_AGAIN:
        '¡Intenta nuevamente! la conexión tardó más de lo esperado. Vuelve a intentar y revisa los planes que tenemos disponibles para ti.',
      INTERNATIONAL_SHIPPING_XLP: 'Compra internacional',
      MAXIMUM_QUANTITY_LIMIT_LABEL: 'La cantidad ingresada excede el stock del producto.',
      CONNECT_ASSESSMENT_FORM_ERROR_CLIENT: 'ESTIMADO CLIENTE',
      VENDOR_NEW_CUSTOMER_SEARCH_LABEL: 'Buscar nuevo cliente',
      EXTENDED_WARRANTY_LABEL: 'Garantía extendida',
      PLANS_CLICK_TO_GET_CALLED_FORM_NUMBER: 'Número de contacto',
      FALLBACK_SEO_BRAND_TITLE: '$xlp_name$',
      PLANS_CLICK_TO_GET_CALLED_OK_SUBTITLE:
        'En minutos un ejecutivo estará contactándose para que puedas escoger el mejor plan para ti.',
      WANT_THIS_PLAN_BUTTON_REBRANDING: 'Quiero este plan',
      HOME_DELI_DATE_RANGE: 'Opción rango de fechas:',
      OCULTAR_LABEL: 'Ocultar',
      STOCK_IN_STORE: 'Stock en tienda',
      HOME: 'Home',
      searchPlaceholder: '¿Qué buscas?',
      CONNECT_CMR_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/cmr/consultaCmrInternet',
      COMBO_PHONE_PRICE_LABEL: 'Precio de equipo',
      PRICE_NO_RESULTS_ERROR_LABEL: 'Rango sin resultados. Por favor ingresa otros valores.',
      RETURN_POLICY_LINK_TEXT: 'Conoce los plazos y exclusiones',
      VENDOR_PRICE_LABEL: 'Precio',
      PLANS_CLICK_TO_GET_CALLED_SUBTITLE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos.',
      VENDOR_BARCODE_CENTER_LABEL: 'Centra tu código de barras y evita mover tu teléfono.',
      relatedCategories: 'CATEGORÍAS RELACIONADAS',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_REBRANDING: 'Comunícate ahora',
      SEE_LESS: 'ver menos',
      PDP_BI_AB_COOKIE: 'pdp_ab',
      CONNECT_OPERATOR_SERVICE_CALL:
        'https://fconnect.falabellatienda.com/api-txd/credito/consultaInformacionCreditoInternet',
      WITHDRAWAL_AT_STORE_TIMELINE: 'retira hoy',
      SEARCH_RESULTS_FOR: 'Resultados de la búsqueda',
      ADDITIONAL_SERVICES_LABEL: 'Servicios adicionales',
      VOLVER_A_REVISAR: 'Volver a revisar',
      PLANS_CARD_ONLINE: 'ONLINE',
      COMUNA: 'Comuna',
      LOG_OUT_LABEL: 'Cerrar sesión',
      GOOGLE_ELEMENT_UNIQUE_ID: 'div-gpt-ad-3024305',
      CMRONLINESUCCESSNOTENROLLED:
        'Tu tarjeta CMR fue creada, pero no pudo ser anadida a tu cuenta, favor dirígete a una sucursal CMR',
      HOW_WORKS_CONNECT: '¿Cómo funciona Falabella Connect?',
      EXPERT_ADVICE: 'ASESORÍA DE EXPERTOS',
      NEED_RUT: 'Tenemos ofertas especiales. Solo necesitamos tu RUT para mostrártelas.',
      IOS_VERSION_SINGLE_SELECT: '2.5.24',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE: '¡Te llamamos!',
      SLP_BI_AB_COOKIE: 'search_ab',
      READY: 'Aplicar',
      SHOW_OFFER_BUTTON: 'VER TODA LA OFERTA',
      LOW_STOCK_WARNING: 'Los productos podrían agotarse próximamente. Cómpralos pronto.',
      LOGIN_INVALID_PASSWORD: 'Formato de contraseña inválido',
      CHOOSE_VARIANTS: 'ELIGE TUS OPCIONES',
      FAILED_ADDING_TO_CART_SERVICE:
        'En este momento no podemos agregar el Servicio adicional seleccionado. Por favor inténtalo nuevamente más tarde.',
      MODEL_CHARACTERISTICS_PREFIX_MOBILE: 'Medidas de modelo',
      AB_TEST_MATCH_VALUE: 'rltr_enabled',
      REGION: 'Región',
      ADD_X_ITEM_TO_BAG_REBRAND: 'Agregar al Carro',
      LOGIN_FACEBOOK: 'Ingresa Con Facebook',
      CONNECT_ERROR_MESSAGE_BUTTON: 'Aceptar',
      COMBO_OPERATOR_LABEL: 'Operador',
      FALLBACK_SEO_SELLER_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      FALLBACK_SEO_SELLER_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      CONNECT_IMPORTANT_THINGS:
        ' Esperamos ofrecerte los mejores planes y equipos, pero antes queremos recordarte dos cosas importantes:',
      LOGIN_FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      OTHER_SEARCHES_LABEL: 'Otras posibles búsquedas:',
      CMRAPERTURATEXT_USING_CMR: 'USANDO TU CMR',
      PLANES: 'PLANES',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON_REBRANDING: 'Probar con otro RUT',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_END: 'recibimos tu solicitud!',
      COMBO_GIGAS_LABEL: 'Gigas',
      INCORRECT_SEARCH_ERROR_TITLE: 'Busqueda Incorrecta',
      TYPE_C_PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro en tienda',
      ERROR_COLOR_NOT_SELECTED: 'Seleccionar tu color para contratar el plan',
      sellerMuteValue: 'LINIO',
      CONNECT_OPERATORS_OPTION: 'Selecciona un operador',
      CHAT_BOT_NAME_AR: 'Lucía',
      COMBO_ENTEL_LABEL: 'Entel',
      CMR_REMINDER: 'Planes disponibles solo con tu tarjeta CMR',
      SAVE: 'Guardar',
      SHIPPING_LABELS: 'Llega hoy,Llega mañana,Envío gratis app',
      FAILED_ADDING_TO_CART_LABEL: 'Este producto ya no está disponible.',
      CONNECT_ASSESSMENT_FORM_QUE_QUIERES_HACER: '¿QUÉ QUIERES HACER CON TU NÚMERO?',
      product: 'Product',
      COMBO_VTR_LABEL: 'VTR',
      CLICK_TO_GET_CALL_BUTTON: '¿NECESITAS ASESORÍA?',
      MY_ACCOUNT: 'Mis ordenes',
      COMBO_PREPAGO_LABEL: 'Prepago',
      HOW_WORKS_CONNECT_TITLE: 'Términos y condiciones Falabella Connect',
      HOME_DELIVERY_SHIPPING: 'Despacho a domicilio.',
      IOS_FACET_SUPPORT_VERSION: '10.0.0',
      SAME_DAY_FACET_MINUTES: 59,
      RETURN_POLICY_LINK_URL: 'https://www.falabella.com/falabella-cl/page/excepciones-devoluciones-cambios',
      FREE_SHIPPING_PRICE_3P: '19990',
      WANT_THIS_PLAN_BUTTON: 'QUIERO ESTE PLAN',
      TYPE_C_HOME_DELI_TITLE_MKP: 'Envío a domicilio',
      INCORRECT_SEARCH_ERROR_MESSAGE: 'INGRESA LA PALABRA, PRODUCTO O CÓDIGO DE LO QUE QUIERES BUSCAR',
      COMBO_ORDER_BY_LABEL: 'Ordenar por',
      MENU: 'Menu',
      CONNECT_ASSESSMENT_FORM_RUT_TEXT: 'RUT',
      CLICK_TO_GET_CALL_BUTTON_SUBTITLE: '¡Te llamamos! Haz click',
      COMBO_PLAN_PRICE_LABEL: 'Precio de plan',
      MAX_FACET_LIMIT: 1500,
      COMBO_MOVISTAR_LABEL: 'Movistar',
      ASSOCIATED_SELLER_INFO:
        'Este es un producto publicado directamente por un vendedor nacional o internacional y cuenta con el respaldo de Falabella. En algunos casos podría tener plazos de despacho diferentes a los habituales.',
      ANDROID_FACET_SUPPORT_VERSION: '10.0.0',
      CURRENT_NUMBER_PREFIX: '+56 ',
      XLP_VIEW_PRODUCT_DESKTOP: 'Ver producto',
      PICKUP_INSTORE_SEE_AVAILABILITY: 'Retiro en un punto',
      REVIEW_CONTRACT: 'Revisa el mandato y contrato. Elige la modalidad de firma que más te acomode.',
      OUT_SERVICE:
        'En estos momentos no fue posible atender su solicitud. Por favor vuelve a intentar dentro de unos minutos.',
      CONNECT_IFRAME_WIDTH: 1080,
      CMRAPERTURATEXT_DONT_HAVE_IT: '¿Aún no la tienes?',
      SELECT_PROMOTION_TEXT: 'Seleccionar Promoción',
      CONNECT_PLANS_CMR_ERROR_BLACK_LIST: 'No califica para comprar planes con falabella connect.',
      RETURN_POLICY_INFO_HARDLINE: 'Tienes 30 días desde que lo recibes. ',
      CONNECT_ASSESSMENT_FORM_TERMS_LINK:
        'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt03833e32eb76ba73/Terminos-y-condiciones-cotizar-telefonia.pdf',
      PLANS_DETAILS_FREE_MINUTES_LABEL: 'MINUTOS LIBRES',
      UNITS_AVAILABLE_LABEL: 'Unidades disponibles',
      THIRD_PARTY_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor nacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.",
      CONNECT_AUTENTIA_SERVICE_CALL: 'https://fconnect.falabellatienda.com/api-txd/validaCliente/validaCi',
      isFastShippingTextEnabled: false,
      LOGIN_OR: 'ó',
      REQUEST_PRODUCT: 'Solicitar Producto',
      CONTACT_OUR_SPECIALISTS: 'Te asesoramos por chat o teléfono',
      INTERNATIONAL_DELIVERY: 'Compra internacional.',
      HOME_DELI_SAVE: 'GUARDAR DIRECCIÓN',
      CONNECT_QUESTION_THIRD_MODULE: '¿Tienes dudas?',
      CHOOSE_OPTION: 'Selecciona una opción',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      REQUEST_ACCEPTED: 'SOLICITUD ACEPTADA',
      CMR_MAPPING:
        'WwogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBDTVIiLAogICAgImRpdmlkZUZhY3RvciI6IDIwMCwKICAgICJsb2dvIjogImljb25zLmNtclRhcmpldGFJY29uIgogIH0sCiAgewogICAgInRpdGxlIjogIkNvbiBEw6liaXRvIEJhbmNvIEZhbGFiZWxsYSIsCiAgICAiZGl2aWRlRmFjdG9yIjogNTAwLAogICAgImxvZ28iOiAiY29ucy5iYW5jb0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIEN1ZW50YSBGcGF5IiwKICAgICJkaXZpZGVGYWN0b3IiOiA1MDAsCiAgICAibG9nbyI6ICJpY29ucy5mcGF5SWNvbiIKICB9LAogIHsKICAgICJ0aXRsZSI6ICJDb24gdGFyamV0YSBkZSBjcsOpZGl0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuY3JlZGl0b0ljb24iCiAgfSwKICB7CiAgICAidGl0bGUiOiAiQ29uIHRhcmpldGEgZGUgZMOpYml0byIsCiAgICAiZGl2aWRlRmFjdG9yIjogNzUwLAogICAgImxvZ28iOiAiaWNvbnMuZGViaXRvSWNvbiIKICB9Cl0=',
      TYPE_C_PICKUP_INSTORE_TITLE: 'Disponible para retiro en tienda',
      PICKUP_OR_DELIVERY:
        'Retira tu compra en cualquiera de nuestras tiendas. Si firmaste en línea, recibe tu Smartphone donde quieras y disfrútalo.',
      FALLBACK_SEO_COLLECTION_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FILTERS_TITLE_REBRANDING_MOBILE: 'Filtrar por:',
      LOGIN_INVALID_EMAIL: 'Formato de email inválido nombre@ejemplo.com',
      HIRE_YOUR_PLAN: 'Datos para contratar tu plan',
      PICKUP_INSTORE_INFO_CAN_VARY: 'La información de disponibilidad puede variar durante lacompra.',
      PREPAID_DEVICE: 'Equipo prepago desde',
      CURRENT_NUMBER_LABEL: 'Número Actual',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SKU_SEARCH_REGEX:
        '(^[0-9]{5,})+$|(^prod[0-9]+$)|(^sku[0-9]+$)|(^[0-9]{4,}X+$)|(^[0-9]{7,})+C$|C[0-9]{1,2}$|(^[0-9]{3,6})+XC$|XC[0-9]$|^[0-9]{1,}[A-Z]?C$',
      TYPE_C_PICKUP_INSTORE_TITLE_MKP: 'Retiro en tienda',
      BIG_TICKETS_UNAVAILABLE:
        'Debido a su tamaño, este producto no está disponible para retiro en tienda, pero nosotros te lo llevamos sin problemas, intenta la opción ',
      SEARCH_WITHOUT_RESULT_TITLE: 'Lo sentimos, no encontramos resultados para',
      FALLBACK_SEO_CATEGORY_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      PICKUP_INSTORE_SO_TITLE: 'Retiro en tienda',
      REGISTER_LABEL: 'Registrate',
      PICKUP_INSTORE_STORES_AVAILABLE: 'Puntos de retiro disponibles',
      CMSIZE: 'cm',
      BUY_CONNECT_ONLINE: '¡Ahorra tiempo! Compra un Smartphone y contrata un plan, todo en línea y de una sola vez.',
      OF: 'de',
      PICKUP_INSTORE_CHECK_ANOTHER_STORE: 'Revisar otra tienda',
      SPECIFICATIONS_LABEL: 'Especificaciones',
      SELLER_RATING_RECOMMENDED_SOCOM: '¡Recomendado por Sodimac!',
      CHECK_THE_OFFERS: '¡Revisa las ofertas!',
      VIEW_MORE_SPECIFICATONS: 'Ver más especificaciones',
      FALLBACK_SEO_CATEGORY_DESCRIPTION:
        'Compra online $xlp_name$ de tu marca favorita en falabella.com Conoce nuestro catálogo de $xlp_name$ y elige la opción perfecta para ti.',
      ADDING_TO_CART: 'Agregando...',
      FALLBACK_SEO_SELLER_TITLE: '$xlp_name$',
      WHY_PDP: '¿Por qué?',
      EVALUATE_PLANS_BUTTON_REBRANDING: 'Revisar planes',
      COMBO_MINUTES_LABEL: 'Minutos',
      A2C_ERROR_CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
      ITEM_ADDED_A11Y_LABEL: 'Item Added',
      SEARCH_IN_FACETS_LABEL: 'search in facets',
      VIEW_PLANES_LABEL: 'VER PLANES',
      PAY_AT_BOX: 'PAGAR EN LA CAJA',
      SHOW_OFFER_BUTTON_REBRANDING: 'Ver toda la oferta',
      SURVEY_TEXT_ANY_MISTAKE: '¿Encontraste algún error?',
      CLEAN: 'Limpiar Filtro',
      CLEAR: 'Cerrar',
      IDEAL_PLAN_LABEL: 'Tenemos tu plan ideal',
      PICKUP_INSTORE_OUTOFSTOCK: 'No disponible para retiro',
      SELLER_SOLD_BY: 'Vendido por',
      REQUEST_ACCEPTED_MSG_1: 'Favor retirar sus productos en',
      PRODUCT_OUTOFSTOCK_TRY_OTHERS: 'Prueba buscando otros productos en',
      CATEGORY_LATERAL_TEXT: '',
      FALLBACK_SEO_SELLER_DESCRIPTION:
        'Compra lo mejor de $xlp_name$ a un solo click. Encuentra esto y todo lo que necesitas en Falabella y Falabella.com!',
      HOME_DELI_SEE_AVAILABILITY: 'Envío a domicilio',
      VENDOR_INFORMATION_NOT_AVAILABLE_LABEL: 'Informacion no disponible',
      ENTER_VALID_PRICE_ERROR_LABEL: 'Ingresa un rango de precios válido.',
      SHARE_FIND_IN: 'Encuéntralo en',
      ACTIVATE_ADD_TO_BAG: 'HABILITAR AGREGAR AL CARRO',
      MY_ORDERS: 'Mis órdenes',
      PLANS_CLICK_TO_GET_CALLED_FORM_NAME: 'Nombre',
      ADD_TO_BAG_MKP: 'Agregar al Carro',
      SAME_DAY_DELIVERY_TIMELINE: 'llega hoy',
      CMRAPERTURATEXT_OPEN_IT: ' Ábrela',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      PICKUP_INSTORE_SEE_MORE_OPTIONS: 'Ver más opciones',
      RATINGS_STAR_MORE_TEXT: 'y más',
      CMR_DEFAULT_INSTALLMENTS: '10',
      PLANS_DETAILS_MONTH_LABEL: ' meses',
      SUMMARY_MODAL_NOTICE:
        'El valor del plan lo podrás pagar en el sitio web del operador o directamente en la tienda.',
      CONNECT_ERROR_MESSAGE:
        'Lo sentimos, se ha producido un error confirmando tu compra. Por favor, comunícate con nuestro Servicio al Cliente al 223907910 o escríbenos a contacto@falabella.cl',
      CMRAPERTURATEXT_ALREADY_HAVE: 'Pídela y obtén $10.000 de descuento.',
      NEED_HELP_CALL_US_AT: '¿Necesitas ayuda? Llámanos al',
      SELECT_OPERATOR_LABEL: 'Selecciona Chip prepago (incluido):',
      CMRAPERTURATEXT_BENEFITS: 'Ábrela ahora y obtén $10.000 de descuento.',
      BADGE_TYPES_ALLOWED_TO_SHIPPING_PRICE: 'next_day, same_day',
      PAGE_ERROR_TITLE:
        'Lo sentimos, estamos presentando problemas técnicos. Por favor usa la navegación por categorías.',
      CONNECT_ASSESSMENT_FORM_SERIAL_NUMBER_PLACEHOLDER: '123.123.123',
      relatedBrands: 'MARCAS RELACIONADAS',
      STOCK: 'STOCK',
      MORE_OPTIONS: 'Ver opciones',
      A2C_CONTINUE_SHOPPING: 'Seguir comprando',
      SHARE_I_WANT: '¡Lo quiero!',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_ERROR: '¡Ha ocurrido un error vuelve a intentarlo mas tarde!',
      toggleViewButtonText: 'Visualizar por:',
      THIRD_PARTY_INT_SELLER_INFO:
        "Este producto está publicado directamente por un vendedor internacional y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PER_UNIT_PRICE_PREFIX: 'Unidad a',
      SKU_EQUIPMENT: 'SKU Equipo',
      OFFER_PRICE_LABEL: '',
      USSIZE: 'US',
      BACK_ROOM: 'trastienda',
      EVALUATE_PLANS_BUTTON: 'REVISAR PLANES',
      FEATURE_FILTER_MODAL_TITLE: 'Selecciona un filtro',
      VIEW_PREPAID: 'Ver Prepago',
      RECEIVE_AND_ENJOY: '¡Recibe y disfruta!',
      ANDROID_VERSION_SINGLE_SELECT: '2.5.28',
      RETURN_POLICY_HEADING: 'Devuelve gratis por Derecho a retracto o Satisfacción garantizada.',
      CONNECT_IFRAME_URL: 'https://txd-fconnect-prd.appspot.com/#/?data=',
      OWN_SELLER_INFO:
        "Producto publicado directamente por <b style='font-weight: bold; text-transform: capitalize;'>{{tienda}}</b>.",
      CMRAPERTURATEXT_ONTHIS_PURCHASE: 'en esta compra',
      FAILED_ADDING_TO_CART_BUNDLED_PRODUCTS_LABEL_MKP:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder',
      SIZE_CHART: 'Tabla de tallas',
      TEAM: 'EQUIPO',
      PRODUCT_INFORMATION_LABEL: 'Descripción',
      CART_ASSEMBLY_OPTION_SEC_LABEL: '(Sólo RM radio urbano)',
      VIEW_PLAN_REBRANDING: 'Ver plan',
      PREPAID_OPTION: 'Ver la opción prepago',
      VENDOR_LOGOUT_LABEL: 'Cerrar sesión',
      CONNECT_CLICK_TO_GET_CALLED_END_TIME: '21',
      ADD_TO_CART_TEXT_ALONE: 'Agregar',
      A11Y_VIDEO_LABEL: 'Play Video',
      NEXT_DAY_SHIPPING_MIN_MAX_HOURS: '19.5,4',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PICKUP_INSTORE_SAVESTORE_BUTTON: 'GUARDAR TIENDA',
      FALLBACK_SEO_CATEGORY_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      PLANS_CARD_SUBTITLE_MODAL: 'Ingresa tus datos y encuentra las mejores ofertas para ti, con todas las compañias.',
      ATC_ONLY_BUY_AT_STORE: 'Ver Producto',
      LOGIN_EMAIL_PLACEHOLDER: 'Ingresa tu e-mail',
      VIEW_PLAN: 'Ver Plan',
      ERROR_SERVICE_NO_PLANS: 'Lo sentimos, no se han encontrado planes disponibles en esta evaluación',
      SHOWING_RESULT_FOR_LABEL: 'Mostrando resultados para',
      VENDOR_HOME_LABEL: 'VENDOR HOME',
      PICKUP_INSTORE_AVAILABLE_RESULT: 'Fechas y horarios de despacho disponibles',
      CMRONLINESUCCESS: 'Tu Tarjeta CMR fue añadida a tus medios de pago.',
      MODEL_CHARACTERISTICS_PREFIX: 'Medidas de modelo',
      CONNECT_PLANS_CMR_INVALID: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      RECOMMENDED_PRODUCT_LABEL: 'Clientes que vieron este producto tambieñ vieron',
      LOGIN_SIGN_UP: 'Regístrate',
      ITEM_ADDED_IN_CART: 'Producto(s) agregado(s) al carro',
      CONNECT_IMPORTANT_THING_3: 'Si quieres portar tú número a otra compañía tienes que ser el titular de la línea.',
      CONNECT_AUTENTIA_ERROR_MESSAGE: 'Su cédula de identidad se encuentra vencida o numero de serie es incorrecto',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_DESKTOP: '¡Te llamamos!',
      SEE_COLLECTION_BUTTON_LABEL: 'VER COLECCIÓN',
      SAME_DAY_DELIVERY_LABEL: 'Si compras hasta las',
      FALLBACK_SEO_CATEGORY_TITLE: '$xlp_name$',
      LOCATION_DIALOG_BODY: 'Selecciona la región donde quieres ver la disponibilidad de productos.',
      CONNECT_ASSESSMENT_FORM_ACCEPT_BUTTON: 'REVISAR PLANES',
      REACONDITIONED_LINK:
        'https://assets.contentstack.io/v3/assets/blt7c5c2f2f888a7cc3/blt6e6552e1707e37fd/productos-reacondicionados.pdf',
      NEED_HELP: '¿Necesitas ayuda?',
      ADD_TO_CART_TEXT_REBRANDING: 'Agregar al Carro',
      CONNECT_IMPORTANT_THING_2:
        'Para contratar un plan necesitamos hacer una previa evaluación financiera. Por esto Promotora CMR Falabella S.A nos proporciona información necesaria para que podamos ofrecerte un plan adecuado y especial para ti. Si todavía no tienes tu CMR no dudes en sacarla.',
      CONNECT_IMPORTANT_THING_1: 'Para contratar tu plan tienes que tener tarjeta',
      CONNECT_ERROR_MESSAGE_BASKET:
        'Lo sentimos, no es posible añadir más productos a la Bolsa. Ya tienes agregado un producto de Falabella Connect. Este tipo de producto debe ser comprado de manera independiente, ya que tiene un despacho preferente.',
      SELECT_OPTION: 'ELIGE TUS OPCIONES',
      CLEAR_FACET_VALUES_MODAL: 'Limpiar filtros',
      HOME_DELI_STORE_PLEASE_SELECT: 'Revisar disponibilidad',
      CONTRACT_PLAN: 'CONTRATAR PLAN',
      UKSIZE: 'UK',
      CONNECT_ASSESSMENT_FORM_ACCEPT: 'Acepto los ',
      PLANS_CLICK_TO_GET_CALLED_FORM_PH_NUMBER: '987654321',
      SKU_PLAN: 'SKU Plan',
      PLANS_DETAILS_FREE_LABEL: 'LIBRES',
      PRODUCT_ORCHESTRATOR_FLOW: 'false',
      PICKUP_INSTORE_NO_RESULT_AVAILABLE: 'Lo sentimos, no se encontraron tiendas disponibles',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_BRAND_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      HIRE: 'CONTRATA TU',
      ADD_TO_CART_TEXT_MKP: 'Agregar al Carro',
      VENDOR_STOCK_LABEL: 'Stock',
      NEXT: 'Siguiente',
      HOME_DELI_SUB_PREFIX: 'A',
      PLAN_REVIEW_LABEL:
        'Revisa los planes disponibles de los distintos operadores que tenemos para ti con este teléfono.',
      ORDER_BY_DESKTOP: 'Ordenar por',
      POD_BOOM_SHIPPING_LABEL: 'Boom',
      A11Y_USER_LABEL: 'user info',
      CMRONLINEDECLINED: 'No se pudo terminar la solicitud. Para mas información dirígete a una sucursal CMR',
      PURCHASE_ONLINE_OUTOFSTOCK: 'No Disponible para compra en internet',
      CONNECT_LEGAL_TEXT:
        'Los términos y condiciones regulan la evaluación comercial de los planes de telefonía móvil ofrecidos por los operadores de telefonía móvil en nuestro sitio web www.falabella.com, que puedes contratar en conjunto con los teléfonos celulares comercializados por Falabella Retail S.A. Puedes revisar el contenido de los términos y condiciones de la evaluación comercial aqui.\n\nPara realizar la evaluación comercial, es necesario que seas titular de una tarjeta CMR, y que ésta haya sido emitida, con al menos, 90 días de antigüedad a la fecha de solicitud de evaluación o contratación del plan de telefonía móvil. Adicionalmente, validaremos la vigencia y la exactitud de los datos de tu cédula de identidad que nos proporciones.\n\nLos productos deben ser comprados de manera independiente y separada de otros productos que puedas tener en tu carro de compras. Si tienes productos adicionales en tu carro de compra, no te preocupes, éstos quedarán guardados para una compra futura.\n\nEl plan de telefonía y el precio del equipo pueden ser pagados con cualquier medio de pago disponible en falabella.com. El descuento en el precio del equipo está sujeto a la contratación del plan de telefonía respectivo y a la firma de un mandato para el cobro en tu tarjeta de crédito CMR, de la diferencia entre el precio del equipo y el precio prepago de este, según corresponda, el cual aplicará si das de baja el plan suscrito o contratas uno más económico dentro de un periodo de 18 meses para cada operador.\n\nDebido a los requerimientos y procesos del operador telefónico, existe un plazo máximo de 15 días para que recibas tu producto.',
      WITHDRAWAL_AT_STORE: 'Retiro en un punto',
      PICKUP_INSTORE_CLOSE_BUTTON: 'CERRAR',
      ADD_TO_CART_ERROR_AL022:
        'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
      TRACK_ORDER: 'Seguimiento de mi orden',
      A2C_VIEW_BASKET: 'IR AL CARRO DE COMPRAS',
      ADD_TO_CART_ERROR_AL023:
        'Has superado la cantidad máxima de unidades permitidas para este producto en el carrito. Por favor, ajusta la cantidad antes de proceder.',
      VENDOR_PRODUCT_AVAILABLE_LABEL: 'Producto disponible en tienda',
      PRICE_RANGE_FROM: 'Desde',
      CONNECT_ASSESSMENT_FORM_RUT_PLACEHOLDER: '12.345.678-9',
      BOOM_SHIPPING: 'Boom',
      LOGIN_HEADER_DESC: 'Compra más rápido y revisa los detalles de tus órdenes',
      PLAN: 'PLAN',
      HOME_DELI_SO_TITLE: 'Despacho a domicilio',
      PRODUCT_CODE: 'Código del producto',
      SAME_DAY_FACET_HOURS: '15',
      LOGIN_LABEL: 'Inicia Sesión',
      CONNECT_TEXT_THIRD_MODULE:
        'Si necesitas asistencia de un especialista ingresa tus datos de contacto y te llamaremos dentro de unos minutos. Recuerda que también puedes comunicarte directamente llamando al 600 390 4100',
      CONNECT_CLICK_TO_GET_CALLED_SERVICE_TOKEN: 'https://fconnect.falabellatienda.com/api-txd/getTokenEncrypt',
      SPONSORED_PRODUCT_SLOTS: '[0, 10.9, 50, 100]',
      LOGIN: 'Inicia sesión',
      SELLER_RATING_RANGE_LIMITS: '3,4',
      ADD_X_ITEM_TO_BAG: 'Agregar los {count} al Carro',
      VENDOR_SCAN_ANOTHER_PRODUCT_LABEL: 'ESCANEAR OTRO PRODUCTO',
      TYPE_C_HOME_DELI_OUTOFSTOCK_MKP: 'No disponible para envío a domicilio',
      PICKUP_INSTORE_TITLE: 'Retiro en un punto',
      NO_ACCOUNT_LABEL: '¿No tienes cuenta?',
      SAME_DAY_DELIVERY_LABEL_AMOUNT: '15:30 horas',
      FALLBACK_SEO_CATEGORY_TITLE_TYPE: '$xlp_name$ $facet_value$',
      PERFUME_MERCHANT_CATEGORY_IDS: 'J08020101,J08020102,J08050101',
      FILL_YOUR_DETAILS: 'Completa tus datos y firma',
      PLANS_DETAILS_GB_LABEL: 'GB',
      ORDER_BY: 'Ordenar',
      CONNECT_ASSESSMENT_FORM_OPTION_KEEP_NUMBER: 'Mantener número',
      WARNING_A11Y_LABEL: 'Warning',
      ERROR_SERVICE_SAME_OPERATOR:
        'No puedes realizar compra de un plan de tu misma compañía. ¡Revisa la oferta con otros operadores!',
      PURCHASE_ONLINE_TITLE: 'Disponible para compra en internet',
      COMBO_PLAN_PREPAGO_LABEL: 'Plan / Prepago',
      SHARE_LIKE_PRODUCT: 'Me gustó este producto',
      CHOOSE_OPTION_LABEL: 'Opción rango de horario:',
      CND_TITLE: 'Retira mañana',
      CHECK: 'Revisa stock en tienda',
      NO_RESULT_LABEL: 'Lo sentimos, no encontramos resultados para',
      WELCOME_LABEL: 'Bienvenid@,',
      FILTERS_TITLE: 'Filtrar',
      LOGIN_NOT_REGISTERED: '¿No tienes cuenta?',
      RATINGS_STAR_ONLY_TEXT: ' ',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_1:
        '$store$ tiene para ti $xlp_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      FALLBACK_SEO_SELLER_DESCRIPTION_FACETS_2:
        '$store$ tiene para ti $xlp_name$ $facet_name$ $facet_value$ y mucho más. Haz tus compras más fácil y seguro, todo un sólo lugar.',
      ERROR_NO_OFFER_PER_OPERATOR:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      PLANS_DETAILS_NEED_EVALUATION_LABEL: 'REVISA TUS PLANES',
      CONNECT_CLICK_TO_GET_CALLED_BUTTON_THIRD_MODULE_MOBILE: '¡Venta Telefonica!',
      PROMOTED_FILTER_FOR: 'Filtrar por ',
      COMBO_CLARO_LABEL: 'Claro',
      OK_TO_SHOP_LABEL: 'Ficha obtenida de',
      SURVEY_TEXT_TELL_US: '¡Cuéntanos!',
      HELP: 'ayuda',
      CONNECT_ASSESSMENT_FORM_RETRY_BUTTON: 'PROBAR CON OTRO RUT',
      INTERNATIONAL_SHIPPING: 'Envío Internacional',
      EURSIZE: 'EUR',
      SEE_LESS_FACET_VALUES: '+ Ver menos',
      AVAILABILITY_PDP: 'Disponibilidad de producto',
      TOGETHER_PRODUCTS: 'Van bien juntos',
      GO_BACK_TO_PLANS: 'Volver a planes',
      PLANS_CLICK_TO_GET_CALLED_BUTTON_COMUNICATE: 'COMUNÍCATE AHORA',
      PLANS_CARD_TITLE: 'CONTRATA TU PLAN',
      COMBO_NETLINE_LABEL: 'Netline',
      MY_ORDERS_DESC: 'Aquí podrás revisar el estado de tus órdenes.',
      PICKUP_INSTORE_RESULT_WILL_COME_HERE: 'Tus tienda más cercanas aparecerán aquí',
      SUBSCRIPTION_INVALID_EMAIL_ERROR: 'Debes ingresar un mail valido',
      FALLBACK_SEO_COLLECTION_DESCRIPTION:
        'Encuentra $xlp_name$ de tu marca favorita en falabella.com. Compra online con descuentos y envios gratis en productos seleccionados.',
      EXCLUDE_GSC_CATEGORY_ID_FOR_FREE_SHIPPING:
        'G200401,G200402,G200403,G200405,G200406,G200407,G20040804,G20040809,G20040813,G20040901,G20040906,G20040908,G20040914,G200410,G200411,G200412,G20041303,G20041213,G20041405,G20041406,G20041407,G20041410,G200415,G200416,G200417,G200418,G200419,G20042002,G20042006,G200421,G200422,G200423,G200424',
      CIUDAD_TEXT: 'Partido',
      FILTERS_TITLE_MOBILE: 'Filtrar',
      VENDOR_SCAN_INFO_LABEL: 'El escaneo es automático, evita brillos y reflejos.',
      PLANS_DETAILS_MONTHLY_COST_LABEL: 'Cargo fijo mensual',
      CMR_POINTS: 'CMR Puntos',
      CMRAPERTURATEXT_REQUEST: '¿Aún no tienes tu CMR Banco Falabella?',
      HOME_SHIPPING: 'Envío a domicilio',
      COMBO_SIMPLE_LABEL: 'Simple',
      WITHDRAWAL_AT_STORE_LABEL: 'Si compras hasta las',
      HOME_DELI_RESULT_WILL_COME_HERE: 'Tus fechas más cercanas aparecerán aquí',
      LOGIN_EMPTY_EMAIL: 'Por favor ingresa tu e-mail.',
      COLLECTIONS_TO_SHOW_PLANS: 'connect-products,prueba-connect,falabella-connect',
      ORDER_BY_MOBILE: 'Ordenar',
      AVAILABILITY_SELECT_OPTION: 'Selecciona opción para ver disponibilidad',
      VENDOR_LABEL: 'Vendedor',
      SO_COM_HAVE_STOCK: 'tenemos stock online en sodimac.com',
      CONNECT_IFRAME_HEIGHT: 713,
      CONNECT_ASSESSMENT_FORM_QUE_ES_ESTO: '¿Qué es esto?',
      COMBO_DEFAULT_LABEL: 'Selecciona',
      ADD_TO_CART_TEXT: 'Agregar al Carro',
      PAGES_LABEL: 'Páginas',
      SELECT_VARIANT_CHOOSE_OPTIONS_REBRANDING: 'Elige tus opciones',
      CMR_Falabella: 'CMR Falabella.',
      WHY: '¿Porqué?',
      FILTERS_AVAILABILITY_TITLE_MOBILE: 'Entrega',
      OWN_INT_SELLER_INFO:
        "Este producto está publicado directamente por {{tienda}} y cuenta con el respaldo de <b style='font-weight: bold'>Falabella.com</b>. Si al recibirlo no es lo que esperabas, te devolvemos tu dinero.<br/><br/><b style='font-weight: bold'>El precio del producto incluye el costo de envío internacional y pago de impuestos de internación</b> (aduana). Al ser internacional pasa por una inspección y, en algunos casos, esto podría generar atrasos en la entrega.",
      PUM_AFFIX: ' a ',
      CONNECT_PORTABILITY_REMINDER: 'Si te quieres portar, debes ser el títular de tú número',
      ACCEPT: 'ACEPTAR',
      PLANS_DETAILS_PRICE_LABEL: 'Valor equipo',
      PLANS_CLICK_TO_GET_CALLED_OK_TITLE_SIGN: '¡',
      TOP_SPECIFICATIONS: 'Especificaciones principales',
      SPECIFY_YOUR_SEARCH_LABEL: 'Especifica tu búsqueda:',
      SELECT_OPERATOR_ALERT_LABEL: 'El precio puede variar según Chip prepago y/o color',
      CONNECT_CLICK_TO_GET_CALLED_START_TIME: '09',
      COMBO_PLAN_LABEL: 'Plan',
      AB_TEST_VALUE_OVERRIDE: 'bi_ab__online_ltr_classifier',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      A11Y_LOCATION_LABEL: 'location icon',
      PLANS_CLICK_TO_GET_CALLED_NUMBER: 'O llámanos al 600 3904100',
      PLANS_DETAILS_MINUTES_LABEL: 'MINUTOS',
      CHOOSE_YOUR_PLAN: 'Elige tu equipo y plan',
      COLORS_AVAILABLE_SMALL: 'Colores Disponibles',
      PICKUP_INSTORE_NOT_AVAILABLE_IN: 'No disponible en ',
      FALLBACK_SEO_COLLECTION_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      SELLER_AND_SHIPPED_BY: 'y enviado por',
      COMBO_VIRGIN_LABEL: 'Virgin',
      DELIVERY_TYPE_MOB_SUB: 'Compra online o compra en tienda',
      FALLBACK_SEO_BRAND_TITLE_FACETS_2: '$xlp_name$ $facet_name$ $facet_value$ | $store$',
      RETURN_POLICY_INFO_SHOES: 'Tienes 30 días desde que lo recibes. ',
      FALLBACK_SEO_BRAND_TITLE_FACETS_1: '$xlp_name$ $facet_value$ | $store$',
      FREE_SHIPPING_PRICE: '59990',
      DELIVERYSLOT_CALENDAR_TIME_RANGE: 'Rango horario',
      BV_RECOMMENDED_THRESHOLD: 80,
      RESULTS: 'Resultados',
      NO_PLAN_LABEL:
        'Por ahora no contamos con planes disponibles para este teléfono. Te recomendamos revisar otros teléfonos para que elijas el que más te guste y lo puedas llevar con el plan de tu preferencia.',
      SELECT_VARIANT_WARNING_MESSAGE: 'Selecciona tus opciones para agregar el producto al carro',
      BAG: 'Bolsa',
      ADD_REBRANDING: 'Agregar',
      NEED_HELP_CALL_US_AT_PLAN: '¿Necesitas ayuda para contratar un plan? Llámanos al',
      AVAILABILITY_DELIVERY_TYPE: 'Tipo de entrega',
      ERROR_SERVICE_NO_CREDIT:
        'No existen ofertas disponibles con este operador en la actualidad. ¡Revisa la oferta con otros operadores!',
      SELECTION_SIZE: 'Talla:',
      NO_PLAN_TITLE: '¡Lo sentimos!',
      OFFER_PRICE_WARRANTY_LABEL: '(Oferta)',
      SURVEY_TEXT_HELP_US: 'Ayúdanos a mejorar tu experiencia',
      PLANS_CLICK_TO_GET_CALLED_TITLE: '¡No te quedes sin tu plan!',
      PLANS_CLICK_TO_GET_CALLED_FORM_INPUT_NUMBER: '+56',
      AVAILABILITY_IMMEDIATE_DELIVERY: 'Entrega inmediata',
      CSD_TITLE: 'Retira hoy',
      TYPE_C_HOME_DELI_TITLE: 'Disponible para despacho a domicilio',
      FALLBACK_SEO_SEARCH_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SEARCH_TITLE: '$xlp_name$',
      RECOMMENDED_WARRANTY: 'Recomendado',
      ITEM_ADDED_IN_CART_MKP: 'Producto agregado a tu Carro',
      SHIPPING_LABELS_NEW:
        'Llega hoy,Llega mañana,Envío <b>gratis</b>,Envío <b>gratis</b> app,Llega <b>gratis</b> mañana,Retira desde 90 min,Retira mañana',
      FALLBACK_SEO_SHOP_DESCRIPTION:
        'Encuentra $xlp_name$ en falabella.com y descubre las ofertas disponibles. Visita nuestro catálogo de $xlp_name$ y compra la opción perfecta para ti.',
      FALLBACK_SEO_SHOP_TITLE: '$xlp_name$',
      darSectionLabel: 'Producto sin derecho a retracto',
      WARRANTY_LABEL_PREFIX: '',
      OVERRIDE_FACETS_COUNT: 'f.derived.variant.sellerId',
      SHOP_THE_PROJECT_CALL_TO_ACTION_OPEN_MODAL: 'Arma tu proyecto',
      SHOP_THE_PROJECT_COACHMARK_BADGE: 'Nuevo',
      SHOP_THE_PROJECT_COACHMARK_TITLE: 'Descubre y compra el estilo completo',
      SHOP_THE_PROJECT_COACHMARK_DESCRIPTION:
        'Ahora podrás encontrar productos similares para recrear el espacio completo.',
      SHOP_THE_PROJECT_COACHMARK_BUTTON: 'Entendido',
      SHOP_THE_PROJECT_TOAST_ADD_TO_CART_ERROR: 'Hubo un error al agregar el producto, por favor vuelve a intentar.',
      SHOP_THE_PROJECT_TOAST_SELECT_PRODUCTS_WARNING: 'Agrega al menos un producto al Carro.',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_TITLE: 'Elige más productos para tu espacio',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL: 'Seleccionar todos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SELECT_ALL_PRODUCTS: 'productos',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SIMILAR_PRODUCTS: 'Más opciones',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_SAVE: 'Guardar',
      SHOP_THE_PROJECT_PRIMARY_PRODUCTS_ADD_TO_CART: 'Agregar al Carro',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_TITLE: 'Más opciones',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_EXCHANGE: 'Intercambiar',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_GO_BACK: 'Volver',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_NO_PRODUCTS: 'Ningún producto similar encontrado',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_1: 'Ocurrió un problema',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_FAIL_TEXT_2:
        'Por favor, actualiza. Si el problema continúa, vuelve a intentar en unos minutos.',
      SHOP_THE_PROJECT_SECONDARY_PRODUCTS_RETRY: 'Actualizar',
      PDP_SLOTS: 'PDP-HRT-1',
      WHOLESALE_BANNER_BADGE_TEXT_1: 'Precio mayorista',
      WHOLESALE_BANNER_BADGE_TEXT_2: '',
      WHOLESALE_BANNER_BADGE_FROM: 'desde',
      WHOLESALE_BANNER_BADGE_EACH: 'cada',
      WHOLESALE_BANNER_BADGE_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_ADD: 'Agrega',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_UNITS: 'un.',
      WHOLESALE_BANNER_BANNER_ADD_PRODUCTS_BANNER_TO_ACTIVATE: 'más para activar la promoción.',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_1: '¡Listo!',
      WHOLESALE_BANNER_BANNER_READY_BANNER_TEXT_2: 'Activaste la promoción.',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_SINGLE: 'promoción activada',
      WHOLESALE_BANNER_BANNER_PROMOTION_ACTIVE_MULTIPLE: 'promociones activadas',
      MY_FAV_TAG_NAME: 'Mis Favoritos',
      RESTRICTED_VARIANT_MODAL_TEXT:
        "Para comprar este producto debes ser <b style='font-weight: bold'>mayor de 18 años.</b> Además te recordamos que, cuando recibas tu pedido, debes mostrar tu cédula de identidad u otro documento expendido por la autoridad pública que acredite tu edad.</b>",
      RETURN_POLICY_PARA_3_3:
        'En el caso de tratarse de un servicio que no resulta aplicable el derecho de retracto de compra.',
      RETURN_POLICY_MODAL_FOOTER: 'Para más información revisa nuestros',
      RETURN_POLICY_MODAL_FOOTER_UNDERLINE_TEXT: 'términos y condiciones',
      RETURN_POLICY_PARA_1_1:
        'De acuerdo con el artículo 3 bis de la Ley N°19.496, podrás devolver tu producto en un plazo de 10 días contados desde su recepción, sin expresión de causa.',
      RETURN_POLICY_LIST_1:
        'Los productos que, por su naturaleza no puedan ser devueltos o puedan deteriorarse o caducar con rapidez.*Los productos confeccionados conforme a los especificaciones del consumidor.*Los productos de uso personal.*Los productos que se hayan deteriorado por un hecho imputable al consumidor.',
      RETURN_POLICY_PARA_1_2:
        'Ten en cuenta que tu producto lo debes haber comprado por internet, y que quedan excluidos de este derecho:',
      RETURN_POLICY_PARA_2_1:
        'En los Envíos Programados, si te arrepientes de tu compra, prefieres otro, no es de tu talla o simplemente cambiaste de opinión, puedes devolverlo o cambiarlo hasta 30 días corridos después de la fecha en que lo hayas recibido, en nuestras tiendas Tottus o solicitarlo en la sección “Mis Compras”.',
      RETURN_POLICY_PARA_2_2:
        'Ten en cuenta que lo debes entregar tal y como lo recibiste, sin uso, con todos sus accesorios, embalajes originales y con todos los regalos promocionales asociados a la compra.',
      RETURN_POLICY_LIST_2:
        'Alimentos, bebidas, suplementos alimenticios, vitaminas, ni de ningún otro producto análogo y/o de sus respectivas materias primas.*Productos intangibles, consumibles o que hayan caducado.*Productos a pedido o confeccionados a medida.*Productos digitales que se entregan mediante una descarga electrónica.*Plantas y flores.*Productos informados como usados, abiertos, reparados, de segunda selección, remanufacturados, con alguna deficiencia, o en cuya fabricación o elaboración se hayan utilizado partes o piezas usadas.',
      RETURN_POLICY_MODAL_HEADER_1: 'Derecho a retracto y satisfacción garantizada',
      RETURN_POLICY_MODAL_HEADER_3: 'DERECHO A RETRACTO',
      RETURN_POLICY_MODAL_HEADER_2: 'SATISFACCION GARANTIZADA',
      RETURN_POLICY_PARA_3_1: 'No aplica la Satisfacción Garantizada a los siguientes productos:',
      RETURN_POLICY_LIST_4:
        'Cuidado personal, belleza, perfumería, aromaterapia, productos de bienestar sexual, higiene y salud.*Trajes de baño, fajas, ropa interior.*Aros, piercing, accesorios para fumar.*Productos electrónicos.*Línea blanca y electrodomésticos.*Almohadas, ropa de cama y colchones.*Muebles, pinturas y herramientas.*Alimentos y cuidado de mascotas.*Productos de limpieza.*Bicicletas.',
      RETURN_POLICY_PARA_4_1:
        'En las siguientes categorías de productos, para que aplique la Satisfacción Garantizada es necesario que no hayan sido abiertos y que conserven sus sellos y embalaje originales:',
    },
    toggles: {
      isSearchWithSoCom: false,
      isSellerInfoVisibleInPDP: false,
      isHomeDeliveryVisibleInPod: false,
      isAddtionalInfoForSodimacEnabledInUI: true,
      isQuantityEdittableEnabled: true,
      isBVQuestionsEnabled: false,
      isShippingLabels404LogsDisabled: false,
      isPositionPerCategoryEnabled: true,
      isPictureTagEnabled: true,
      searchWithFlattenedPAIdEnabled: false,
      isRedirect301EnabledForPLP: true,
      isNewSearchVisible: true,
      isGenericCalculatorEnabled: true,
      IsSearchExperienceCheckbox: true,
      isMeatStickerApplicableInPDP: true,
      isPickUpFromStoreVisibleInFacet: false,
      isQuantityEditableEnabled: true,
      isOneClickCheckoutEnabled: false,
      isEventFilterEnabled: true,
      isBoomVisibleInPod: false,
      isSellerRucEnabled: true,
      isPickupInStoreVisibleInPDP: true,
      isSodimacSeoEnabled: true,
      isReaconditionedLinkEnabledPDP: true,
      isHomeDeliveryVisibleInFacet: false,
      shouldSendContextIdToReco: false,
      disableSponsoredProductsPDP: true,
      isStockQuantityVisibleInPDP: false,
      isPromotionsEnabledInPDP: true,
      isInhouseBundleWidgetActive: false,
      PDP_AB_TEST_OVERRIDE_VALUE: '',
      shouldSendUserIdToReco: false,
      isWarrantyTooltipEnabled: true,
      isNewTypeaheadEnabled: true,
      isStoreAvailabilityVisibleInPDP: true,
      isPickUpFromStoreVisibleInPod: false,
      isNewWarrantyOptionsV2Enabled: true,
      isShippingFacetVisible: true,
      isPoliticalIdExists: true,
      isAbCookieEnabled: false,
      isRelatedKeywordEnabled: false,
      showRatingDescription: false,
      isPlansClickToGetCalledEnabled: true,
      isNewBVWriteReviewEnabled: true,
      isAbCookieEnabledBrand: false,
      areSponsoredClickEventsEnabledWithQueryParams: true,
      isPDPShippingModalEnabled: false,
      isPlansEvaluationEnabled: true,
      newDiscountBadge: true,
      isSISExperienceOn: true,
      showListToggleButtons: true,
      isCMRButtonWithPriceVisibleInPDP: true,
      isComboUiEnabled: true,
      isSmartSearchEnabled: false,
      isPopOverVisible: true,
      isHomeDeliveryVisibleInPDP: true,
      isShippingAttributesEnabled: false,
      isSellerMute: true,
      isEstimatedShippingCostEnabled: false,
      isSurveyBarShowninPDP: false,
      isShippingFacetsWithFlattenedPIDVisibleForNovios: true,
      isFloorcalculatorEnabled: false,
      isNewTypeaheadEnabledForBeta: true,
      showPricesForSodimacProducts: true,
      isActiveTabAssistentePersonal: false,
      isBestSellerEnabled: true,
      isGeoLocationEnabled: true,
      isRedirect301EnabledForBrand: true,
      isSponsorBrandEnabled: true,
      isShippingFacetsWithFlattenedPIDVisible: true,
      isSizeEquivalencyTableVisible: false,
      featureEnableSponsoredDisplay: true,
      isCMRCalculatorEnabledPDP: false,
      isCMRAperturaUrlAddonsEnabled: true,
      isSisSodimacPdpEnabled: false,
      isNewDeliveryOptionsEnabled: true,
      isCatalogV2EndpointActive: true,
      isTypeAheadEnabled: true,
      useImplicitFilterForXLP: false,
      indexAndCrawlSLTPagesToggle: true,
      isMyListsEnabled: true,
      isAbCookieEnabledPLP: false,
      isGlobalCategoryEnabled: true,
      isBreadcrumbsV2Enabled: true,
      isComparativeTableSameSellerEnabled: false,
      areSponsoredClickEventsEnabled: true,
      isCustomABTestFlagEnabled: false,
      disableGeofinderModalForMobile: true,
      searchWithFlattenedPAIdEnabledForSOCOM: true,
      isRootCategoryGForFacetCategoriaDisabled: false,
      isSellerBusinessNameEnabled: true,
      isChatBotVisible: false,
      transversalBannerConfig: '{"home":true,"pdp":false,"xlp":true,"basket":true}',
      isPDPMyListsEnabled: true,
      isReturnPolicyVisibleInPDP: true,
      splitSearchFacetCalls: true,
      isHtmlValidatorEnabled: false,
      isFacetCountHidden: true,
      isPumPriceEnabled: false,
      isFastShippingTextEnabled: true,
      isAbCookieEnabledSeller: false,
      isPhotoSlurpEnabled: false,
      isCFMediasEnabled: true,
      isComparativeTableEnabled: true,
      isInternationalShippingVisibleInPod: true,
      isAbCookieEnabledCLP: false,
      isWebPushNotificationEnabled: true,
      isSecondaryRatingsFormEnabled: true,
      disableSponsoredProductsSisPDP: false,
      isInternationalBuyVisiblePDP: true,
      isGoogleAdsBannerEnabled: true,
      isBoomVisibleInFacet: false,
      isMeatStickerApplicable: true,
      isShippingFacetWithSwitchVisible: true,
      is3PFreeShippingEnabled: true,
      isQuantitySelectorVisibleInPDP: true,
      identifyBuyAtStore: false,
      isCategoryFacetConfiguredAsGlobalFacet: true,
      searchWithFlattenedPAIdEnabledForNovios: true,
      isFacetWithSwitchVisible: true,
      isAbCookieEnabledSLP: false,
      isOneClickButtonVisible: false,
      isPidAndPgidValidationDisabled: false,
      isShippingLabelsEnabledInPdp: false,
      isHelplineEnabled: true,
      isRecoV2Enabled: true,
      isNewSizeGroupService: false,
      isCMRAperturaEnabled: false,
      showCustomPlaceHolderForPriceRange: false,
      isSellerPopupEnabled: false,
      disableQuantitySelection: false,
      isTypeCAvailableInLightbox: false,
      isAddtionalSellerTextEnabled: true,
      isProductOrchestratorRecoEnabled: false,
      isCartQuantityLimitsEnabled: false,
      freeShippingOnZonesEnabled: true,
      isEventToggleVisible_SO_COM: false,
      isNewSortingLogicForSponsoredProductsEnabled: true,
      isTypeCProductsEnabled: false,
      isPodActionButtonEnabled: true,
      isSodimacFaviconTestActivated: false,
      isCMRAperturaInNewPageEnabled: true,
      isAdditionalServiceFilteredForSodimac: false,
      isMultipurposeBadgeApplicable: true,
      isEnabledSposoredVisitInPLP: true,
      isAIExperimentEnabled: true,
      isNewPriceApplicable: true,
      isRelevancyForCollection: true,
      isPDPWidgetGlobalEnabled: true,
      isInHouseReviewSectionEnabled: false,
      isNewWarrantyUIEnabled: true,
      isNewCMRDesignEnabledPDP: false,
      isNormalPriceCrossedOut: true,
      isCustomPDPABTestFlagEnabled: false,
      isNewWarrantyOptionsEnabled: true,
      hasFreeShippingForInternationalProducts: true,
      isEventToggleVisible: true,
      isMKPProductDisabled: false,
      adInjectorIsEnabled: true,
      isUnitForSaleEnabled: true,
      isImageDeliveryOverrideEnabled: true,
      isReviewValidationWithOrder: true,
      featureEnableSponsoredDisplayforPDP: true,
      isFomoBadgeVisible: true,
      isSizeChartDataVisible: true,
      is3PSellerSizeChartEnabled: false,
      isDemoUpVideoEnabled: false,
      FORBID_SAME_DAY_AND_AFTERNOON_IN_COLLECTIONS: false,
      isEnabledSponsoredClickInPDP: true,
      isImageGalleryEnabled: false,
      isImageGalleryMsgEnabled: false,
      isImageGallerySilderEnabled: false,
      isDebugAdsEnabled: false,
      showFacetsForCollectionRule: true,
      isDynamicFacetsEnabled: true,
      SHOW_SPONSORED_STRIP: true,
      addFeatureScriptsToLongDesc: true,
      allowLongDescScriptInjection: true,
      enableSponsoredInRecommendation: true,
      isEventToggleVisible_TO_COM: false,
      isKioskControlledSearchEnabled: false,
      popularBrandsStaticFacetsEnabled: false,
      IS_PROVIDER_EXPERIMENT_TURNED_ON: false,
      isSearchSpecialCharactersEnabled: true,
      newFreeShippingEnabled: false,
      isNewOmniChannelExperience: true,
      isNewSearchOrchestratorEnabled: false,
      isOrchestratorEnabled: true,
      isStoreFacetsEnabled: false,
      NEW_PROMOTION_CALL: false,
      isCustomBannerEnabled: true,
      isExpSellerFilterEnabled: true,
      isInstallmentWithoutInterestEnabled: true,
      popularBrandFacetsEnabled: true,
      isOkToShopFeatureEnabled: true,
      isRatingsShownInPDP: false,
      isCartPersistanceEnabled: true,
      isReviewsShownInPDP: false,
      isTottusBrandFilterDisabled: true,
    },
    endpoints: {
      APERTURA_URL_VALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpconOU',
      ATG_AUTH_BASEURL: 'https://www.falabella.com',
      CATALYST_AUTH_BASEURL: 'https://www.tottus.cl',
      WISHLISTS_PAGE_URI: 'https://www.falabella.com/falabella-cl/myaccount/myLists',
      BASKET_PAGE_URI: 'https://www.tottus.cl/tottus-cl/basket',
      WORKING_HOURS_SODIMAC: 'https://sodimac.falabella.com/sodimac-cl/page/tiendas-y-horarios-sodimac',
      RETURN_POLICY_LINK_URL: 'https://www.tottus.cl/tottus-cl/content/terminos-y-condiciones',
      WORKING_HOURS_TIENDA: 'https://tienda.falabella.com/falabella-cl/page/horarios-tienda-Falabella',
      BASKET_PAGE_URI_SODIMAC: 'https://www.sodimac.cl/sodimac-cl/basket',
      APERTURA_URL_INVALID_CMR:
        'https://www.falabella.com/falabella-cl/page/CMR-enlinea?staticPageId=28700002&from=bShR3VyENqOK/iZsx/hUW4owR5kjQSQtt/XRCU1Pf3rhnbHrJ75QVFx4rZoioZA7Druyh/M/DtI1I/gPmmejNaiDTql/XJr0Nrso6iy+PPtSAco+SCZAjoRj9QapowiHgPJruBhfVvV0Jdebsu4pvl8k5AR1a6Uf4OACMk5vpUTP/PbJtfiNL84QpaAdHM9kMdlDR4m/CUNHMSWXv8dgA1fqCuR1U4tNoyEocdM3NqzhscbJT1l+tQVaqJ6M8jJ1IUa2dl1wJQOeE1tSzTHfjy4jdLHemq4nxQiVxzWxe5gTfft90rmWuwFgt7Yu/yzvuo61qnL0Db8d8uI2RJTKFQ=&detalleClic=pdpsinOU',
      EXT_WARRANTY_LIGHTBOX_LINK: '/falabella-cl/page/garantia?staticPageId=11300003',
      SERVICES_CL_FALABELLA: 'https://www.falabella.com/falabella-cl/page/servicios-falabella',
      WORKING_HOURS_TOTTUS: 'https://tottus.falabella.com/tottus-cl/page/horario_tiendas',
      moreWarrantyBenefitsLink: 'https://www.falabella.com/falabella-cl/page/postventa-garantia-extendida',
    },
    facetLabels: {
      'f.shipping.hd_same_day_zones': '<p>Si compras hasta las&nbsp;<strong>16:00 horas</strong></p>',
      'f.derived.variant.activeEvent_SO_COM': '<p>Hasta 04/05/2025</p>',
      'f.derived.variant.freeShipping': '',
      'f.derived.variant.activeEvent': '<p>Hasta el 04/05/2025</p>',
      'f.derived.variant.activeEvent_TO_COM': '<p>SOLO POR 72 HRS</p>',
    },
    configurations: {
      fastShippingConfig: {
        facets: false,
        labels: false,
        novios: {
          facets: false,
          labels: false,
        },
        default: {
          facets: false,
          labels: false,
        },
      },
      vasConfig: {
        sponsorBrandPosition: {
          default: {
            desktop: 12,
            mobile: 14,
            tablet: 14,
          },
        },
        eventConfigForPageType: {
          pages: {},
        },
      },
      commerceApiErrors: {
        CART_CONFIG_BREACH: 'Se superó la cantidad máxima permitida por producto',
        CHECKOUT_SLOT_NOT_AVAILABLE:
          'Lo sentimos. Intenta con otra comuna o revisa la disponibilidad del envío a domicilio.',
        AL001: 'El vendedor subió el precio de este producto.',
        AL002: '¡Buena noticia! El vendedor bajó el precio de este producto.',
        AL003: 'Tuvimos un problema, no pudimos cargar el precio.',
        AL004: 'Lo sentimos, este producto recién se agotó.',
        AL005: 'Tuvimos un problema, no encontramos las unidades disponibles.',
        AL006: 'Lo sentimos, el vendedor despublicó este producto.',
        AL007: 'Se aplicó la promoción.',
        AL008: 'Se eliminó la promoción.',
        AL009: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL010: 'El cupón no es válido.',
        AL011: 'Agregamos el cupón con éxito.',
        AL012: 'Eliminamos el cupón.',
        AL013: 'El cupón expiró.',
        AL014: 'Superaste la cantidad máxima de unidades.',
        AL015: 'Superaste la cantidad máxima de unidades.',
        AL016: 'Superaste la cantidad máxima de unidades.',
        AL017: 'Superaste la cantidad máxima de productos que puedes llevar en tu Carro.',
        AL018: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL019: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL020: 'Superaste la cantidad máxima de unidades.',
        AL022: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL024: 'Tuvimos un problema, intenta agregar al Carro nuevamente.',
        AL025: 'Lo sentimos, este producto recién se agotó.',
        CART_DEFAULT_MESSAGE: 'Hubo un error al agregar el producto al carro',
      },
      adsConfig: {
        adProviderUrl:
          'https://assets.falabella.com/v3/assets/blt7c5c2f2f888a7cc3/blt3ef14bb68a88d66c/ads_desktop_v3.html',
        xlp: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-1655991838659-03',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-1655991534231-03',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
        search: [
          {
            slot: 'div-gpt-ad-1681222629103-03',
            folder: '/21632469435/PLP_Banner_Superior',
            container: 'google-banner-superior-div',
          },
          {
            slot: 'div-gpt-ad-16553991838659-0',
            folder: '/21632469435/plp_vertical',
            container: 'google-banner-izq-div',
          },
          {
            slot: 'div-gpt-ad-16553991534231-0',
            folder: '/21632469435/plp_horizontal_desktop',
            container: 'google-banner-inferior-desktop-div',
          },
        ],
      },
      sellerRedirectionMap: {
        falabella: 'https://tienda.falabella.com/falabella-cl',
        sodimac: 'https://sodimac.falabella.com/sodimac-cl',
        tottus: 'https://www.tottus.cl/tottus-cl',
        linio: 'https://linio.falabella.com/linio-cl',
        homecenter: 'https://homecenter.falabella.com/homecenter-cl',
      },
      commerceLimitApiAlerts: {
        AL023: 'Has alcanzado la cantidad máxima para este producto.',
        AL021: 'Has alcanzado la cantidad máxima de productos para tu Bolsa de compras',
      },
      ratingFacetConfig: {
        novios: {
          facet: true,
          details: true,
        },
        facet: false,
        details: false,
        useDerivedAttribute: true,
      },
      disabledStoresSponsoredProducts: {
        stores: ['tottus'],
      },
      productTitleBrandRemovalExclusion: 'dior',
      productTitleBrandRemovalExclusions: [
        'colacao',
        'cola cao',
        'doritos',
        'cheetos',
        'lays',
        'detodito',
        'puri ramitas',
        'cheezels',
      ],
      configPositionPerCategory: {
        default: {
          startingPositions: [1, 2, 7, 8, 29, 30],
          endingPositions: [1, 2],
        },
      },
      warrantyBenefits: [
        {
          header: 'Reparaciones con repuestos originales',
          renderCross: false,
          firstColRenderCross: false,
        },
        {
          header: 'Producto de reemplazo durante reparación.*',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Reparación dentro de 12 a 18 días',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Cobertura en caso de variación de voltaje',
          renderCross: false,
          firstColRenderCross: true,
        },
        {
          header: 'Garantía transferible si se vende o regala el producto',
          renderCross: false,
          firstColRenderCross: true,
        },
      ],
      A2C_ERRORS: {
        DEFAULT: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
        AL022:
          'Superaste la cantidad máxima de unidades permitidas para productos de este vendedor en el Carro. Por favor, ajusta la cantidad antes de proceder.',
        AL023: 'Ya agregaste todas las unidades disponibles de este producto. Puedes ir al Carro y revisar el detalle.',
        default: 'Tuvimos un problema y no logramos agregar tus productos al carro. Por favor inténtalo nuevamente.',
      },
      facetsWithLink: [],
      skipPositionCategories: [
        'cat20002',
        'cat850030',
        'cat14330023',
        'cat850036',
        'cat7330051',
        'cat1320008',
        'CATG34996',
        'cat850040',
        'cat1320010',
        'cat16580002',
        'cat13140017',
        'cat850034',
        'cat850042',
        'cat7350055',
        'cat850044',
        'cat11610008',
        'cat7350018',
        'cat7350012',
        'cat7350013',
        'cat7350017',
        'cat7350019',
        'cat18380042',
        'cat1320012',
        'cat7450073',
        'cat17980009',
        'cat7500027',
        'cat13620025',
        'cat7450062',
        'cat1640033',
        'cat5260002',
        'cat7450083',
        'cat7450088',
        'cat7450086',
        'cat7450065',
        'cat660024',
        'cat2083',
        'cat850068',
        'cat850064',
        'cat12440001',
        'cat690245',
        'cat13680004',
        'cat14730004',
        'cat6930168',
        'cat6930003',
        'CATG35031',
        'CATG12010',
        'cat7280122',
        'cat5620004',
        'cat12850003',
        'cat12850002',
        'cat12270016',
        'CATG34995',
        'cat7480104',
        'cat2017',
        'cat3207',
        'cat690235',
        'cat5880085',
        'cat3208',
        'cat6050003',
        'cat3143',
        'cat6050008',
        'cat590028',
        'cat570195',
        'cat6050011',
        'cat13990004',
        'CATG34994',
        'cat6930019',
        'cat12650001',
        'cat6930011',
        'cat6930180',
        'cat6930190',
        'cat6930014',
        'cat6930181',
        'cat6930018',
        'CATG19087',
        'cat6930191',
        'cat12650004',
        'cat12650002',
        'CATG33917',
        'cat190004',
        'cat7660148',
        'cat16400020',
        'cat16400012',
        'cat16400016',
        'cat16400014',
        'cat16400019',
        'cat16400015',
        'cat19280010',
        'cat16400013',
        'cat16400018',
        'cat17010032',
        'cat17010033',
        'cat19280007',
        'cat14370004',
        'cat17180020',
        'cat17180021',
        'cat7530038',
        'cat7530010',
        'cat15330001',
        'cat15330018',
        'cat15330005',
        'cat15330021',
        'cat15330022',
        'cat15330003',
        'cat15330006',
        'cat15330023',
        'cat15330011',
        'cat15330027',
        'cat15330009',
        'cat15330025',
        'cat15330030',
        'cat15330017',
        'cat15330019',
        'cat15330010',
        'cat15330026',
        'cat15330012',
        'cat15330029',
        'cat15330004',
        'cat15330020',
      ],
      SponsoredDisplayPosition: {
        positions: {},
      },
      meatStickersConfig: {
        enabled: true,
        labels: {
          same_day: 'Llega hoy',
          next_day: 'Llega mañana',
          next_day_gratis: 'Llega <b>gratis</b> mañana',
          free_shipping_app: 'Envío <b>gratis</b>',
          free_shipping_web: 'Envío <b>gratis</b> app',
          promo_free_shipping: 'Envío <b>gratis</b>',
          cc_same_day: 'Retira desde 90 min',
          cc_next_day: 'Retira mañana',
          hd_express: 'Retira en 2 horas',
        },
      },
      xlpSsrOptions: {
        podCountMobile: 12,
        podCountDesktop: 28,
      },
      featureHighlighter: {
        facets: {
          'Grandes marcas': 1740722055000,
          'Tipo de Entrega': 1744675200000,
        },
      },
      returnPolicy: {
        true: {
          header: {
            default: 'Devolver este producto es gratis',
            intl: 'Devolver este producto es gratis',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
        false: {
          header: {
            default: 'Producto sin derecho a retracto',
            intl: 'Producto sin derecho a retracto',
          },
          info: {
            default: 'Tienes 30 días desde que lo recibes',
          },
          link: 'Conoce los plazos y exclusiones del derecho a retracto y la satisfacción garantizada.',
          mobile: 'Politica de cambios y devoluciones',
        },
      },
      topSortExperimentConfig: {
        categories: [],
        searchTerms: [],
      },
      brandFacetAttributeBannerConfig: {
        imageBasePath: 'https://imagedelivery.net/4fYuQyy-r8_rpBpcY7lH_A/falabellaCL/misc/',
      },
      tipoFacetAttributeBannerConfig: {
        visible: true,
        androidVersion: '2.6.39',
        iosVersion: '2.6.38',
      },
      sellerExpCookies: {
        seller_exp_1: 'exp_1',
        seller_exp_2: 'exp_2',
        seller_exp_3: 'exp_3',
        seller_exp_4: 'exp_4',
      },
      whiteLabelSitesEnabled: ['fa_america', 'fa_aldo'],
      TO_COM_DEFAULT_COORDS: {
        latitude: '-33.731683',
        longitude: '-70.735547',
      },
      discountThresholdForTottusPromotions: 5,
    },
  },
};
